
// This file is auto-generated by the GenWeatherDataMap.py script.
// DO NOT EDIT

export let WeatherDataMap = {
  "name": "root",
  "children": [
    {
      "name": "Afghanistan",
      "children": [
        {
          "name": "Farmakan",
          "fullName": "Farmakan",
          "path": [
            "Afghanistan",
            "Farmakan"
          ],
          "lat": 33.391,
          "lng": 62.261
        },
        {
          "name": "Ghazni",
          "fullName": "Ghazni",
          "path": [
            "Afghanistan",
            "Ghazni"
          ],
          "lat": 33.533,
          "lng": 68.417
        },
        {
          "name": "Herat",
          "fullName": "Herat",
          "path": [
            "Afghanistan",
            "Herat"
          ],
          "lat": 34.21,
          "lng": 62.228
        },
        {
          "name": "Kabul",
          "fullName": "Kabul",
          "path": [
            "Afghanistan",
            "Kabul"
          ],
          "lat": 34.5552,
          "lng": 69.2142
        },
        {
          "name": "Kandahar",
          "fullName": "Kandahar",
          "path": [
            "Afghanistan",
            "Kandahar"
          ],
          "lat": 31.5021,
          "lng": 65.8524
        },
        {
          "name": "Konduz",
          "fullName": "Konduz",
          "path": [
            "Afghanistan",
            "Konduz"
          ],
          "lat": 36.667,
          "lng": 68.917
        },
        {
          "name": "Mazar-e-Sharif",
          "fullName": "Mazar-e-Sharif",
          "path": [
            "Afghanistan",
            "Mazar-e-Sharif"
          ],
          "lat": 36.7055,
          "lng": 67.2185
        }
      ]
    },
    {
      "name": "Algeria",
      "children": [
        {
          "name": "Algiers",
          "fullName": "Algiers",
          "path": [
            "Algeria",
            "Algiers"
          ],
          "lat": 36.767,
          "lng": 3.1
        },
        {
          "name": "Amguid",
          "fullName": "Amguid",
          "path": [
            "Algeria",
            "Amguid"
          ],
          "lat": 26.417,
          "lng": 5.367
        },
        {
          "name": "Annaba",
          "fullName": "Annaba",
          "path": [
            "Algeria",
            "Annaba"
          ],
          "lat": 36.822,
          "lng": 7.8036
        },
        {
          "name": "Bechar",
          "fullName": "Bechar",
          "path": [
            "Algeria",
            "Bechar"
          ],
          "lat": 31.646,
          "lng": -2.27
        },
        {
          "name": "Laghouat",
          "fullName": "Laghouat",
          "path": [
            "Algeria",
            "Laghouat"
          ],
          "lat": 33.764,
          "lng": 2.927
        },
        {
          "name": "Oran",
          "fullName": "Oran",
          "path": [
            "Algeria",
            "Oran"
          ],
          "lat": 35.624,
          "lng": -0.621
        },
        {
          "name": "Ouargla",
          "fullName": "Ouargla",
          "path": [
            "Algeria",
            "Ouargla"
          ],
          "lat": 31.917,
          "lng": 5.413
        },
        {
          "name": "Tabessa",
          "fullName": "Tabessa",
          "path": [
            "Algeria",
            "Tabessa"
          ],
          "lat": 35.432,
          "lng": 8.121
        },
        {
          "name": "Tamanrasset",
          "fullName": "Tamanrasset",
          "path": [
            "Algeria",
            "Tamanrasset"
          ],
          "lat": 22.8,
          "lng": 5.433
        },
        {
          "name": "Tindouf",
          "fullName": "Tindouf",
          "path": [
            "Algeria",
            "Tindouf"
          ],
          "lat": 27.7,
          "lng": -8.167
        }
      ]
    },
    {
      "name": "Argentina",
      "children": [
        {
          "name": "Bahia Blanca",
          "fullName": "Bahia Blanca",
          "path": [
            "Argentina",
            "Bahia Blanca"
          ],
          "lat": -38.7147,
          "lng": -62.1631
        },
        {
          "name": "Buenos Aires",
          "fullName": "Buenos Aires",
          "path": [
            "Argentina",
            "Buenos Aires"
          ],
          "lat": -34.5589,
          "lng": -58.4197
        },
        {
          "name": "Comodoro Rivadavia",
          "fullName": "Comodoro Rivadavia",
          "path": [
            "Argentina",
            "Comodoro Rivadavia"
          ],
          "lat": -45.7922,
          "lng": -67.4619
        },
        {
          "name": "Cordoba",
          "fullName": "Cordoba",
          "path": [
            "Argentina",
            "Cordoba"
          ],
          "lat": -31.2967,
          "lng": -64.2119
        },
        {
          "name": "Corrientes",
          "fullName": "Corrientes",
          "path": [
            "Argentina",
            "Corrientes"
          ],
          "lat": -27.4389,
          "lng": -59.0461
        },
        {
          "name": "El Calafate",
          "fullName": "El Calafate",
          "path": [
            "Argentina",
            "El Calafate"
          ],
          "lat": -50.336,
          "lng": -72.249
        },
        {
          "name": "Mendoza",
          "fullName": "Mendoza",
          "path": [
            "Argentina",
            "Mendoza"
          ],
          "lat": -32.8439,
          "lng": -68.7964
        },
        {
          "name": "Paso de los Libres",
          "fullName": "Paso de los Libres",
          "path": [
            "Argentina",
            "Paso de los Libres"
          ],
          "lat": -29.6894,
          "lng": -57.1486
        },
        {
          "name": "Salta",
          "fullName": "Salta",
          "path": [
            "Argentina",
            "Salta"
          ],
          "lat": -24.8444,
          "lng": -65.4758
        },
        {
          "name": "San Miguel de Tucuman",
          "fullName": "San Miguel de Tucuman",
          "path": [
            "Argentina",
            "San Miguel de Tucuman"
          ],
          "lat": -26.8372,
          "lng": -65.1083
        },
        {
          "name": "Ushuaia",
          "fullName": "Ushuaia",
          "path": [
            "Argentina",
            "Ushuaia"
          ],
          "lat": -54.84,
          "lng": -68.3033
        }
      ]
    },
    {
      "name": "Australia",
      "children": [
        {
          "name": "NSW",
          "children": [
            {
              "name": "Sydney",
              "fullName": "Sydney, NSW. Australia",
              "path": [
                "Australia",
                "NSW",
                "Sydney"
              ],
              "lat": -33.9057,
              "lng": 151.1135
            }
          ]
        },
        {
          "name": "QLD",
          "children": [
            {
              "name": "Brisbane",
              "fullName": "Brisbane, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Brisbane"
              ],
              "lat": -27.3917,
              "lng": 153.1292
            },
            {
              "name": "Cairns",
              "fullName": "Cairns, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Cairns"
              ],
              "lat": -16.8736,
              "lng": 145.745
            },
            {
              "name": "Durham",
              "fullName": "Durham, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Durham"
              ],
              "lat": -27.401,
              "lng": 141.811
            },
            {
              "name": "Georgetown",
              "fullName": "Georgetown, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Georgetown"
              ],
              "lat": -18.3,
              "lng": 143.55
            },
            {
              "name": "Gladstone",
              "fullName": "Gladstone, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Gladstone"
              ],
              "lat": -23.8553,
              "lng": 151.2628
            },
            {
              "name": "Gold Coast Seaway",
              "fullName": "Gold Coast Seaway, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Gold Coast Seaway"
              ],
              "lat": -27.9388,
              "lng": 153.4283
            },
            {
              "name": "Goondiwindi",
              "fullName": "Goondiwindi, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Goondiwindi"
              ],
              "lat": -28.521,
              "lng": 150.326
            },
            {
              "name": "Hervey Bay",
              "fullName": "Hervey Bay, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Hervey Bay"
              ],
              "lat": -25.322,
              "lng": 152.882
            },
            {
              "name": "Mackay",
              "fullName": "Mackay, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Mackay"
              ],
              "lat": -21.1706,
              "lng": 149.1794
            },
            {
              "name": "Mount Isa",
              "fullName": "Mount Isa, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Mount Isa"
              ],
              "lat": -20.6778,
              "lng": 139.4875
            },
            {
              "name": "Nanum",
              "fullName": "Nanum, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Nanum"
              ],
              "lat": -12.6778,
              "lng": 141.9208
            },
            {
              "name": "St. George",
              "fullName": "St. George, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "St. George"
              ],
              "lat": -28.049,
              "lng": 148.594
            },
            {
              "name": "Townsville",
              "fullName": "Townsville, QLD. Australia",
              "path": [
                "Australia",
                "QLD",
                "Townsville"
              ],
              "lat": -19.2483,
              "lng": 146.7661
            }
          ]
        },
        {
          "name": "Victoria",
          "children": [
            {
              "name": "Melbourne",
              "fullName": "Melbourne, Victoria. Australia",
              "path": [
                "Australia",
                "Victoria",
                "Melbourne"
              ],
              "lat": -37.8075,
              "lng": 144.97
            }
          ]
        },
        {
          "name": "WA",
          "children": [
            {
              "name": "Perth",
              "fullName": "Perth, WA. Australia",
              "path": [
                "Australia",
                "WA",
                "Perth"
              ],
              "lat": -31.9275,
              "lng": 115.9764
            }
          ]
        }
      ]
    },
    {
      "name": "Belize",
      "children": [
        {
          "name": "Ladyville",
          "fullName": "Ladyville",
          "path": [
            "Belize",
            "Ladyville"
          ],
          "lat": 17.539,
          "lng": -88.308
        }
      ]
    },
    {
      "name": "Bolivia",
      "children": [
        {
          "name": "Cochabamba",
          "fullName": "Cochabamba",
          "path": [
            "Bolivia",
            "Cochabamba"
          ],
          "lat": -17.421,
          "lng": -66.177
        },
        {
          "name": "El Alto",
          "fullName": "El Alto",
          "path": [
            "Bolivia",
            "El Alto"
          ],
          "lat": -16.513,
          "lng": -68.192
        },
        {
          "name": "Santa Cruz de la Sierra",
          "fullName": "Santa Cruz de la Sierra",
          "path": [
            "Bolivia",
            "Santa Cruz de la Sierra"
          ],
          "lat": -17.645,
          "lng": -63.135
        },
        {
          "name": "Trinidad",
          "fullName": "Trinidad",
          "path": [
            "Bolivia",
            "Trinidad"
          ],
          "lat": -14.819,
          "lng": -64.918
        }
      ]
    },
    {
      "name": "Bosnia and Herzegovina",
      "children": [
        {
          "name": "Banja Luka",
          "fullName": "Banja Luka",
          "path": [
            "Bosnia and Herzegovina",
            "Banja Luka"
          ],
          "lat": 44.783,
          "lng": 17.217
        },
        {
          "name": "Bihac",
          "fullName": "Bihac",
          "path": [
            "Bosnia and Herzegovina",
            "Bihac"
          ],
          "lat": 44.8076,
          "lng": 15.8667
        },
        {
          "name": "Mostar",
          "fullName": "Mostar",
          "path": [
            "Bosnia and Herzegovina",
            "Mostar"
          ],
          "lat": 43.3481,
          "lng": 17.7939
        },
        {
          "name": "Sarajevo",
          "fullName": "Sarajevo",
          "path": [
            "Bosnia and Herzegovina",
            "Sarajevo"
          ],
          "lat": 43.825,
          "lng": 18.331
        },
        {
          "name": "Tuzla",
          "fullName": "Tuzla",
          "path": [
            "Bosnia and Herzegovina",
            "Tuzla"
          ],
          "lat": 44.542,
          "lng": 18.6851
        }
      ]
    },
    {
      "name": "Brazil",
      "children": [
        {
          "name": "Aracaju",
          "fullName": "Aracaju",
          "path": [
            "Brazil",
            "Aracaju"
          ],
          "lat": -10.984,
          "lng": -37.07
        },
        {
          "name": "Ararangua",
          "fullName": "Ararangua",
          "path": [
            "Brazil",
            "Ararangua"
          ],
          "lat": -28.9314,
          "lng": -49.4981
        },
        {
          "name": "Belem",
          "fullName": "Belem",
          "path": [
            "Brazil",
            "Belem"
          ],
          "lat": -1.379,
          "lng": -48.476
        },
        {
          "name": "Belo Horizonte",
          "fullName": "Belo Horizonte",
          "path": [
            "Brazil",
            "Belo Horizonte"
          ],
          "lat": -19.8839,
          "lng": -43.9694
        },
        {
          "name": "Boa Vista",
          "fullName": "Boa Vista",
          "path": [
            "Brazil",
            "Boa Vista"
          ],
          "lat": 2.8169,
          "lng": -60.6908
        },
        {
          "name": "Brasilia",
          "fullName": "Brasilia",
          "path": [
            "Brazil",
            "Brasilia"
          ],
          "lat": -15.7894,
          "lng": -47.9258
        },
        {
          "name": "Campina Grande",
          "fullName": "Campina Grande",
          "path": [
            "Brazil",
            "Campina Grande"
          ],
          "lat": -7.225,
          "lng": -35.905
        },
        {
          "name": "Campo Grande",
          "fullName": "Campo Grande",
          "path": [
            "Brazil",
            "Campo Grande"
          ],
          "lat": -20.45,
          "lng": -54.617
        },
        {
          "name": "Campos dos Goytacazes",
          "fullName": "Campos dos Goytacazes",
          "path": [
            "Brazil",
            "Campos dos Goytacazes"
          ],
          "lat": -21.7147,
          "lng": -41.3442
        },
        {
          "name": "Cruzeiro do Sul",
          "fullName": "Cruzeiro do Sul",
          "path": [
            "Brazil",
            "Cruzeiro do Sul"
          ],
          "lat": -7.6108,
          "lng": -72.6813
        },
        {
          "name": "Curitiba",
          "fullName": "Curitiba",
          "path": [
            "Brazil",
            "Curitiba"
          ],
          "lat": -25.4486,
          "lng": -49.2308
        },
        {
          "name": "Dois Vizinhos",
          "fullName": "Dois Vizinhos",
          "path": [
            "Brazil",
            "Dois Vizinhos"
          ],
          "lat": -25.6991,
          "lng": -53.0953
        },
        {
          "name": "Florianopolis",
          "fullName": "Florianopolis",
          "path": [
            "Brazil",
            "Florianopolis"
          ],
          "lat": -27.6025,
          "lng": -48.62
        },
        {
          "name": "Goiania",
          "fullName": "Goiania",
          "path": [
            "Brazil",
            "Goiania"
          ],
          "lat": -16.6428,
          "lng": -49.22
        },
        {
          "name": "Imperatriz",
          "fullName": "Imperatriz",
          "path": [
            "Brazil",
            "Imperatriz"
          ],
          "lat": -5.531,
          "lng": -47.46
        },
        {
          "name": "Londrina",
          "fullName": "Londrina",
          "path": [
            "Brazil",
            "Londrina"
          ],
          "lat": -23.334,
          "lng": -51.13
        },
        {
          "name": "Macae",
          "fullName": "Macae",
          "path": [
            "Brazil",
            "Macae"
          ],
          "lat": -22.343,
          "lng": -41.767
        },
        {
          "name": "Macapa",
          "fullName": "Macapa",
          "path": [
            "Brazil",
            "Macapa"
          ],
          "lat": 0.05,
          "lng": -51.067
        },
        {
          "name": "Maceio",
          "fullName": "Maceio",
          "path": [
            "Brazil",
            "Maceio"
          ],
          "lat": -9.5511,
          "lng": -35.7703
        },
        {
          "name": "Manaus",
          "fullName": "Manaus",
          "path": [
            "Brazil",
            "Manaus"
          ],
          "lat": -3.1037,
          "lng": -60.0155
        },
        {
          "name": "Maringa",
          "fullName": "Maringa",
          "path": [
            "Brazil",
            "Maringa"
          ],
          "lat": -23.4052,
          "lng": -51.9328
        },
        {
          "name": "Pontes e Lacerda",
          "fullName": "Pontes e Lacerda",
          "path": [
            "Brazil",
            "Pontes e Lacerda"
          ],
          "lat": -15.235,
          "lng": -59.346
        },
        {
          "name": "Porto Alegre",
          "fullName": "Porto Alegre",
          "path": [
            "Brazil",
            "Porto Alegre"
          ],
          "lat": -29.994,
          "lng": -51.171
        },
        {
          "name": "Porto Velho",
          "fullName": "Porto Velho",
          "path": [
            "Brazil",
            "Porto Velho"
          ],
          "lat": -8.7936,
          "lng": -63.8459
        },
        {
          "name": "Recife",
          "fullName": "Recife",
          "path": [
            "Brazil",
            "Recife"
          ],
          "lat": -8.126,
          "lng": -34.924
        },
        {
          "name": "Rio de Janeiro",
          "fullName": "Rio de Janeiro",
          "path": [
            "Brazil",
            "Rio de Janeiro"
          ],
          "lat": -22.91,
          "lng": -43.163
        },
        {
          "name": "Sao Luis",
          "fullName": "Sao Luis",
          "path": [
            "Brazil",
            "Sao Luis"
          ],
          "lat": -2.5269,
          "lng": -44.2131
        },
        {
          "name": "Sao Paulo",
          "fullName": "Sao Paulo",
          "path": [
            "Brazil",
            "Sao Paulo"
          ],
          "lat": -23.4964,
          "lng": -46.62
        },
        {
          "name": "Uberlandia",
          "fullName": "Uberlandia",
          "path": [
            "Brazil",
            "Uberlandia"
          ],
          "lat": -18.9172,
          "lng": -48.2556
        },
        {
          "name": "Vilhena",
          "fullName": "Vilhena",
          "path": [
            "Brazil",
            "Vilhena"
          ],
          "lat": -12.7348,
          "lng": -60.1578
        }
      ]
    },
    {
      "name": "Canada",
      "children": [
        {
          "name": "AB",
          "children": [
            {
              "name": "Acadia Valley",
              "fullName": "Acadia Valley, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Acadia Valley"
              ],
              "lat": 51.066,
              "lng": -110.317
            },
            {
              "name": "Athabasca",
              "fullName": "Athabasca, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Athabasca"
              ],
              "lat": 54.6347,
              "lng": -113.3819
            },
            {
              "name": "Atlee",
              "fullName": "Atlee, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Atlee"
              ],
              "lat": 50.81,
              "lng": -111.006
            },
            {
              "name": "Banff",
              "fullName": "Banff, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Banff"
              ],
              "lat": 51.1936,
              "lng": -115.5525
            },
            {
              "name": "Barrhead",
              "fullName": "Barrhead, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Barrhead"
              ],
              "lat": 54.095,
              "lng": -114.448
            },
            {
              "name": "Beaverlodge",
              "fullName": "Beaverlodge, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Beaverlodge"
              ],
              "lat": 55.1967,
              "lng": -119.3964
            },
            {
              "name": "Big Valley",
              "fullName": "Big Valley, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Big Valley"
              ],
              "lat": 51.9978,
              "lng": -112.8025
            },
            {
              "name": "Bow Island",
              "fullName": "Bow Island, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Bow Island"
              ],
              "lat": 49.8684,
              "lng": -111.3664
            },
            {
              "name": "Bow Valley",
              "fullName": "Bow Valley, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Bow Valley"
              ],
              "lat": 51.083,
              "lng": -115.066
            },
            {
              "name": "Breton Plots",
              "fullName": "Breton Plots, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Breton Plots"
              ],
              "lat": 53.0894,
              "lng": -114.4408
            },
            {
              "name": "Cadogan",
              "fullName": "Cadogan, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Cadogan"
              ],
              "lat": 52.3342,
              "lng": -110.51
            },
            {
              "name": "Calgary",
              "fullName": "Calgary, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Calgary"
              ],
              "lat": 51.114,
              "lng": -114.02
            },
            {
              "name": "Camrose",
              "fullName": "Camrose, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Camrose"
              ],
              "lat": 53.0428,
              "lng": -112.8217
            },
            {
              "name": "Champion",
              "fullName": "Champion, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Champion"
              ],
              "lat": 50.2953,
              "lng": -113.3467
            },
            {
              "name": "Claresholm",
              "fullName": "Claresholm, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Claresholm"
              ],
              "lat": 50.0036,
              "lng": -113.6406
            },
            {
              "name": "Cleardale",
              "fullName": "Cleardale, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Cleardale"
              ],
              "lat": 56.3144,
              "lng": -119.745
            },
            {
              "name": "Cold Lake",
              "fullName": "Cold Lake, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Cold Lake"
              ],
              "lat": 54.42,
              "lng": -110.28
            },
            {
              "name": "Coronation",
              "fullName": "Coronation, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Coronation"
              ],
              "lat": 52.0742,
              "lng": -111.4494
            },
            {
              "name": "Crestomere",
              "fullName": "Crestomere, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Crestomere"
              ],
              "lat": 52.7328,
              "lng": -113.9028
            },
            {
              "name": "Crowsnest",
              "fullName": "Crowsnest, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Crowsnest"
              ],
              "lat": 49.63,
              "lng": -114.48
            },
            {
              "name": "Dewberry",
              "fullName": "Dewberry, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Dewberry"
              ],
              "lat": 53.6592,
              "lng": -110.5875
            },
            {
              "name": "Drumheller",
              "fullName": "Drumheller, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Drumheller"
              ],
              "lat": 51.45,
              "lng": -112.68
            },
            {
              "name": "Eaglesham",
              "fullName": "Eaglesham, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Eaglesham"
              ],
              "lat": 55.8081,
              "lng": -117.8867
            },
            {
              "name": "Edgerton",
              "fullName": "Edgerton, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Edgerton"
              ],
              "lat": 52.7778,
              "lng": -110.4328
            },
            {
              "name": "Edmonton",
              "fullName": "Edmonton, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Edmonton"
              ],
              "lat": 53.5799,
              "lng": -113.5156
            },
            {
              "name": "Edson",
              "fullName": "Edson, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Edson"
              ],
              "lat": 53.5805,
              "lng": -116.4535
            },
            {
              "name": "Elk Island National Park",
              "fullName": "Elk Island National Park, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Elk Island National Park"
              ],
              "lat": 53.6825,
              "lng": -112.8681
            },
            {
              "name": "Fairview",
              "fullName": "Fairview, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Fairview"
              ],
              "lat": 56.0814,
              "lng": -118.4394
            },
            {
              "name": "Foremost",
              "fullName": "Foremost, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Foremost"
              ],
              "lat": 49.4833,
              "lng": -111.4861
            },
            {
              "name": "Forestburg",
              "fullName": "Forestburg, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Forestburg"
              ],
              "lat": 52.5485,
              "lng": -112.1234
            },
            {
              "name": "Fort Assiniboine",
              "fullName": "Fort Assiniboine, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Fort Assiniboine"
              ],
              "lat": 54.41,
              "lng": -114.769
            },
            {
              "name": "Fort MacLeod",
              "fullName": "Fort MacLeod, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Fort MacLeod"
              ],
              "lat": 49.7858,
              "lng": -113.3794
            },
            {
              "name": "Fort McMurray",
              "fullName": "Fort McMurray, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Fort McMurray"
              ],
              "lat": 56.65,
              "lng": -111.2208
            },
            {
              "name": "Fort Vermilion",
              "fullName": "Fort Vermilion, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Fort Vermilion"
              ],
              "lat": 58.3822,
              "lng": -116.0403
            },
            {
              "name": "Garden River",
              "fullName": "Garden River, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Garden River"
              ],
              "lat": 58.7108,
              "lng": -113.8664
            },
            {
              "name": "Glenevis",
              "fullName": "Glenevis, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Glenevis"
              ],
              "lat": 53.8325,
              "lng": -114.5389
            },
            {
              "name": "Glenwood",
              "fullName": "Glenwood, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Glenwood"
              ],
              "lat": 49.334,
              "lng": -113.526
            },
            {
              "name": "Grand Prarie",
              "fullName": "Grand Prarie, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Grand Prarie"
              ],
              "lat": 55.18,
              "lng": -118.88
            },
            {
              "name": "Hawk Hills",
              "fullName": "Hawk Hills, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Hawk Hills"
              ],
              "lat": 57.265,
              "lng": -117.298
            },
            {
              "name": "Hendrickson Creek",
              "fullName": "Hendrickson Creek, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Hendrickson Creek"
              ],
              "lat": 53.795,
              "lng": -118.447
            },
            {
              "name": "High Level",
              "fullName": "High Level, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "High Level"
              ],
              "lat": 58.62,
              "lng": -117.16
            },
            {
              "name": "High Prarie",
              "fullName": "High Prarie, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "High Prarie"
              ],
              "lat": 55.3949,
              "lng": -116.4831
            },
            {
              "name": "Highvale",
              "fullName": "Highvale, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Highvale"
              ],
              "lat": 53.449,
              "lng": -114.464
            },
            {
              "name": "Holden",
              "fullName": "Holden, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Holden"
              ],
              "lat": 53.185,
              "lng": -112.2461
            },
            {
              "name": "Jasper",
              "fullName": "Jasper, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Jasper"
              ],
              "lat": 52.88,
              "lng": -118.07
            },
            {
              "name": "Kinsella",
              "fullName": "Kinsella, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Kinsella"
              ],
              "lat": 53.0469,
              "lng": -111.5473
            },
            {
              "name": "Lac La Biche",
              "fullName": "Lac La Biche, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Lac La Biche"
              ],
              "lat": 54.7689,
              "lng": -112.0236
            },
            {
              "name": "Lacombe",
              "fullName": "Lacombe, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Lacombe"
              ],
              "lat": 52.4492,
              "lng": -113.7569
            },
            {
              "name": "Leduc",
              "fullName": "Leduc, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Leduc"
              ],
              "lat": 53.3067,
              "lng": -113.6058
            },
            {
              "name": "Lethbridge",
              "fullName": "Lethbridge, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Lethbridge"
              ],
              "lat": 49.7,
              "lng": -112.77
            },
            {
              "name": "Lloydminster",
              "fullName": "Lloydminster, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Lloydminster"
              ],
              "lat": 53.312,
              "lng": -110.0744
            },
            {
              "name": "Medicine Hat",
              "fullName": "Medicine Hat, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Medicine Hat"
              ],
              "lat": 50.025,
              "lng": -110.7172
            },
            {
              "name": "Milk River",
              "fullName": "Milk River, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Milk River"
              ],
              "lat": 49.134,
              "lng": -112.051
            },
            {
              "name": "Morrin",
              "fullName": "Morrin, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Morrin"
              ],
              "lat": 51.6603,
              "lng": -112.675
            },
            {
              "name": "Nordegg",
              "fullName": "Nordegg, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Nordegg"
              ],
              "lat": 52.471,
              "lng": -116.077
            },
            {
              "name": "Olds",
              "fullName": "Olds, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Olds"
              ],
              "lat": 51.7586,
              "lng": -114.0847
            },
            {
              "name": "Onefour",
              "fullName": "Onefour, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Onefour"
              ],
              "lat": 49.1231,
              "lng": -110.4689
            },
            {
              "name": "Peace River",
              "fullName": "Peace River, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Peace River"
              ],
              "lat": 56.23,
              "lng": -117.45
            },
            {
              "name": "Pekisko",
              "fullName": "Pekisko, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Pekisko"
              ],
              "lat": 50.37,
              "lng": -114.42
            },
            {
              "name": "Pincher Creek",
              "fullName": "Pincher Creek, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Pincher Creek"
              ],
              "lat": 49.5222,
              "lng": -114.005
            },
            {
              "name": "Prarie River",
              "fullName": "Prarie River, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Prarie River"
              ],
              "lat": 58.627,
              "lng": -111.679
            },
            {
              "name": "Queenstown",
              "fullName": "Queenstown, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Queenstown"
              ],
              "lat": 50.5978,
              "lng": -112.8033
            },
            {
              "name": "Radway",
              "fullName": "Radway, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Radway"
              ],
              "lat": 53.995,
              "lng": -112.8791
            },
            {
              "name": "Raymond",
              "fullName": "Raymond, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Raymond"
              ],
              "lat": 49.487,
              "lng": -112.675
            },
            {
              "name": "Red Deer",
              "fullName": "Red Deer, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Red Deer"
              ],
              "lat": 52.179,
              "lng": -113.893
            },
            {
              "name": "Red Earth",
              "fullName": "Red Earth, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Red Earth"
              ],
              "lat": 56.5519,
              "lng": -115.2778
            },
            {
              "name": "Rocky Mountain House",
              "fullName": "Rocky Mountain House, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Rocky Mountain House"
              ],
              "lat": 52.4214,
              "lng": -114.9122
            },
            {
              "name": "Schuler",
              "fullName": "Schuler, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Schuler"
              ],
              "lat": 50.3069,
              "lng": -110.0906
            },
            {
              "name": "Sedalia",
              "fullName": "Sedalia, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Sedalia"
              ],
              "lat": 51.59,
              "lng": -110.755
            },
            {
              "name": "Slave Lake",
              "fullName": "Slave Lake, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Slave Lake"
              ],
              "lat": 55.2964,
              "lng": -114.7844
            },
            {
              "name": "Smoky Lake",
              "fullName": "Smoky Lake, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Smoky Lake"
              ],
              "lat": 54.265,
              "lng": -112.504
            },
            {
              "name": "Spirit River",
              "fullName": "Spirit River, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Spirit River"
              ],
              "lat": 55.695,
              "lng": -119.23
            },
            {
              "name": "St. Albert",
              "fullName": "St. Albert, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "St. Albert"
              ],
              "lat": 53.692,
              "lng": -113.6196
            },
            {
              "name": "St. Lina",
              "fullName": "St. Lina, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "St. Lina"
              ],
              "lat": 54.2824,
              "lng": -111.4512
            },
            {
              "name": "St. Paul",
              "fullName": "St. Paul, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "St. Paul"
              ],
              "lat": 54.0111,
              "lng": -111.2719
            },
            {
              "name": "Sundre",
              "fullName": "Sundre, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Sundre"
              ],
              "lat": 51.778,
              "lng": -114.683
            },
            {
              "name": "Three Hills",
              "fullName": "Three Hills, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Three Hills"
              ],
              "lat": 51.7675,
              "lng": -113.2056
            },
            {
              "name": "Two Hills",
              "fullName": "Two Hills, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Two Hills"
              ],
              "lat": 53.6253,
              "lng": -111.6783
            },
            {
              "name": "Valleyview",
              "fullName": "Valleyview, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Valleyview"
              ],
              "lat": 55.0981,
              "lng": -117.1992
            },
            {
              "name": "Vauxhall",
              "fullName": "Vauxhall, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Vauxhall"
              ],
              "lat": 50.053,
              "lng": -112.126
            },
            {
              "name": "Vegreville",
              "fullName": "Vegreville, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Vegreville"
              ],
              "lat": 53.5053,
              "lng": -112.0978
            },
            {
              "name": "Vermilion",
              "fullName": "Vermilion, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Vermilion"
              ],
              "lat": 53.3439,
              "lng": -110.8819
            },
            {
              "name": "Waterton Park Gate",
              "fullName": "Waterton Park Gate, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Waterton Park Gate"
              ],
              "lat": 49.1311,
              "lng": -113.8086
            },
            {
              "name": "Whitecourt",
              "fullName": "Whitecourt, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Whitecourt"
              ],
              "lat": 54.14,
              "lng": -115.784
            },
            {
              "name": "Yoho Park",
              "fullName": "Yoho Park, AB. Canada",
              "path": [
                "Canada",
                "AB",
                "Yoho Park"
              ],
              "lat": 51.447,
              "lng": -116.324
            }
          ]
        },
        {
          "name": "BC",
          "children": [
            {
              "name": "Abbotsford",
              "fullName": "Abbotsford, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Abbotsford"
              ],
              "lat": 49.027,
              "lng": -122.377
            },
            {
              "name": "Agassiz",
              "fullName": "Agassiz, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Agassiz"
              ],
              "lat": 49.2428,
              "lng": -121.7597
            },
            {
              "name": "Alert Bay",
              "fullName": "Alert Bay, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Alert Bay"
              ],
              "lat": 50.582,
              "lng": -126.915
            },
            {
              "name": "Amphitrite Point",
              "fullName": "Amphitrite Point, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Amphitrite Point"
              ],
              "lat": 48.9216,
              "lng": -125.541
            },
            {
              "name": "Blue River",
              "fullName": "Blue River, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Blue River"
              ],
              "lat": 52.129,
              "lng": -119.2898
            },
            {
              "name": "Bonilla Island",
              "fullName": "Bonilla Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Bonilla Island"
              ],
              "lat": 53.493,
              "lng": -130.637
            },
            {
              "name": "Burns Lake",
              "fullName": "Burns Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Burns Lake"
              ],
              "lat": 54.3833,
              "lng": -125.9586
            },
            {
              "name": "Cape Scott",
              "fullName": "Cape Scott, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Cape Scott"
              ],
              "lat": 50.7823,
              "lng": -128.427
            },
            {
              "name": "Cape St. James",
              "fullName": "Cape St. James, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Cape St. James"
              ],
              "lat": 51.9358,
              "lng": -131.0158
            },
            {
              "name": "Cathedral Point",
              "fullName": "Cathedral Point, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Cathedral Point"
              ],
              "lat": 52.188,
              "lng": -127.471
            },
            {
              "name": "Clinton",
              "fullName": "Clinton, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Clinton"
              ],
              "lat": 51.1447,
              "lng": -121.5049
            },
            {
              "name": "Comox",
              "fullName": "Comox, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Comox"
              ],
              "lat": 49.72,
              "lng": -124.9
            },
            {
              "name": "Creston",
              "fullName": "Creston, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Creston"
              ],
              "lat": 49.0817,
              "lng": -116.5007
            },
            {
              "name": "Dawson Creek",
              "fullName": "Dawson Creek, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Dawson Creek"
              ],
              "lat": 55.7388,
              "lng": -120.1869
            },
            {
              "name": "Dease Lake",
              "fullName": "Dease Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Dease Lake"
              ],
              "lat": 58.422,
              "lng": -130.031
            },
            {
              "name": "Discovery Island",
              "fullName": "Discovery Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Discovery Island"
              ],
              "lat": 48.4247,
              "lng": -123.2258
            },
            {
              "name": "Entrance Island",
              "fullName": "Entrance Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Entrance Island"
              ],
              "lat": 49.209,
              "lng": -123.81
            },
            {
              "name": "Estevan Point",
              "fullName": "Estevan Point, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Estevan Point"
              ],
              "lat": 49.3833,
              "lng": -126.5431
            },
            {
              "name": "Fort Nelson",
              "fullName": "Fort Nelson, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Fort Nelson"
              ],
              "lat": 58.8415,
              "lng": -122.5741
            },
            {
              "name": "Fort St. James",
              "fullName": "Fort St. James, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Fort St. James"
              ],
              "lat": 54.455,
              "lng": -124.286
            },
            {
              "name": "Fort St. John",
              "fullName": "Fort St. John, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Fort St. John"
              ],
              "lat": 56.2467,
              "lng": -120.7371
            },
            {
              "name": "Grey Islet",
              "fullName": "Grey Islet, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Grey Islet"
              ],
              "lat": 54.58,
              "lng": -130.698
            },
            {
              "name": "Helmcken Island",
              "fullName": "Helmcken Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Helmcken Island"
              ],
              "lat": 50.4,
              "lng": -125.87
            },
            {
              "name": "Herbert Island",
              "fullName": "Herbert Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Herbert Island"
              ],
              "lat": 50.94,
              "lng": -127.632
            },
            {
              "name": "Kamloops",
              "fullName": "Kamloops, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Kamloops"
              ],
              "lat": 50.6993,
              "lng": -120.4406
            },
            {
              "name": "Kelowna",
              "fullName": "Kelowna, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Kelowna"
              ],
              "lat": 49.96,
              "lng": -119.38
            },
            {
              "name": "Langara",
              "fullName": "Langara, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Langara"
              ],
              "lat": 54.255,
              "lng": -133.058
            },
            {
              "name": "Lillooet",
              "fullName": "Lillooet, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Lillooet"
              ],
              "lat": 50.6836,
              "lng": -121.9342
            },
            {
              "name": "MacKenzie",
              "fullName": "MacKenzie, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "MacKenzie"
              ],
              "lat": 55.299,
              "lng": -123.133
            },
            {
              "name": "Malahat",
              "fullName": "Malahat, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Malahat"
              ],
              "lat": 48.575,
              "lng": -123.53
            },
            {
              "name": "McInnes Island",
              "fullName": "McInnes Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "McInnes Island"
              ],
              "lat": 52.262,
              "lng": -128.719
            },
            {
              "name": "Merritt",
              "fullName": "Merritt, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Merritt"
              ],
              "lat": 50.1125,
              "lng": -120.7781
            },
            {
              "name": "Nakusp",
              "fullName": "Nakusp, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Nakusp"
              ],
              "lat": 50.2694,
              "lng": -117.8172
            },
            {
              "name": "Nelson",
              "fullName": "Nelson, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Nelson"
              ],
              "lat": 49.491,
              "lng": -117.305
            },
            {
              "name": "Nitinat Lake",
              "fullName": "Nitinat Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Nitinat Lake"
              ],
              "lat": 48.67,
              "lng": -124.83
            },
            {
              "name": "North Cowichan",
              "fullName": "North Cowichan, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "North Cowichan"
              ],
              "lat": 48.8242,
              "lng": -123.7189
            },
            {
              "name": "Ootsa Lake",
              "fullName": "Ootsa Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Ootsa Lake"
              ],
              "lat": 53.7719,
              "lng": -125.9967
            },
            {
              "name": "Osoyoos",
              "fullName": "Osoyoos, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Osoyoos"
              ],
              "lat": 49.0283,
              "lng": -119.4411
            },
            {
              "name": "Pemberton",
              "fullName": "Pemberton, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Pemberton"
              ],
              "lat": 50.306,
              "lng": -122.734
            },
            {
              "name": "Penticton",
              "fullName": "Penticton, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Penticton"
              ],
              "lat": 49.46,
              "lng": -119.6
            },
            {
              "name": "Pitt Meadows",
              "fullName": "Pitt Meadows, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Pitt Meadows"
              ],
              "lat": 49.2083,
              "lng": -122.69
            },
            {
              "name": "Port Alberni",
              "fullName": "Port Alberni, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Port Alberni"
              ],
              "lat": 49.32,
              "lng": -124.93
            },
            {
              "name": "Port Hardy",
              "fullName": "Port Hardy, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Port Hardy"
              ],
              "lat": 50.68,
              "lng": -127.37
            },
            {
              "name": "Prince George",
              "fullName": "Prince George, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Prince George"
              ],
              "lat": 53.889,
              "lng": -122.6719
            },
            {
              "name": "Prince Rupert",
              "fullName": "Prince Rupert, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Prince Rupert"
              ],
              "lat": 54.29,
              "lng": -130.44
            },
            {
              "name": "Princeton",
              "fullName": "Princeton, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Princeton"
              ],
              "lat": 49.4683,
              "lng": -120.5143
            },
            {
              "name": "Puntzi Mountain",
              "fullName": "Puntzi Mountain, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Puntzi Mountain"
              ],
              "lat": 52.1144,
              "lng": -124.1356
            },
            {
              "name": "Qualicum Beach",
              "fullName": "Qualicum Beach, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Qualicum Beach"
              ],
              "lat": 49.34,
              "lng": -124.39
            },
            {
              "name": "Quesnel",
              "fullName": "Quesnel, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Quesnel"
              ],
              "lat": 53.0269,
              "lng": -122.5064
            },
            {
              "name": "Revelstoke",
              "fullName": "Revelstoke, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Revelstoke"
              ],
              "lat": 50.9581,
              "lng": -118.1765
            },
            {
              "name": "Salmon Arm",
              "fullName": "Salmon Arm, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Salmon Arm"
              ],
              "lat": 50.703,
              "lng": -119.2906
            },
            {
              "name": "Sandspit",
              "fullName": "Sandspit, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Sandspit"
              ],
              "lat": 53.2494,
              "lng": -131.8133
            },
            {
              "name": "Saturna Capmon",
              "fullName": "Saturna Capmon, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Saturna Capmon"
              ],
              "lat": 48.7753,
              "lng": -123.1281
            },
            {
              "name": "Sheringham Point",
              "fullName": "Sheringham Point, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Sheringham Point"
              ],
              "lat": 48.3767,
              "lng": -123.9211
            },
            {
              "name": "Smithers",
              "fullName": "Smithers, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Smithers"
              ],
              "lat": 54.8242,
              "lng": -127.1894
            },
            {
              "name": "Solander Island",
              "fullName": "Solander Island, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Solander Island"
              ],
              "lat": 50.111,
              "lng": -127.94
            },
            {
              "name": "Sparwood",
              "fullName": "Sparwood, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Sparwood"
              ],
              "lat": 49.745,
              "lng": -114.8839
            },
            {
              "name": "Squamish",
              "fullName": "Squamish, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Squamish"
              ],
              "lat": 49.78,
              "lng": -123.16
            },
            {
              "name": "Tatlayoko Lake",
              "fullName": "Tatlayoko Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Tatlayoko Lake"
              ],
              "lat": 51.6747,
              "lng": -124.4031
            },
            {
              "name": "Terrace",
              "fullName": "Terrace, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Terrace"
              ],
              "lat": 54.47,
              "lng": -128.58
            },
            {
              "name": "Vancouver",
              "fullName": "Vancouver, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Vancouver"
              ],
              "lat": 49.19,
              "lng": -123.18
            },
            {
              "name": "Victoria",
              "fullName": "Victoria, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Victoria"
              ],
              "lat": 48.65,
              "lng": -123.43
            },
            {
              "name": "West Vancouver",
              "fullName": "West Vancouver, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "West Vancouver"
              ],
              "lat": 49.347,
              "lng": -123.1933
            },
            {
              "name": "Whistler",
              "fullName": "Whistler, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Whistler"
              ],
              "lat": 50.1289,
              "lng": -122.9547
            },
            {
              "name": "White Rock",
              "fullName": "White Rock, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "White Rock"
              ],
              "lat": 49.0181,
              "lng": -122.7839
            },
            {
              "name": "Williams Lake",
              "fullName": "Williams Lake, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Williams Lake"
              ],
              "lat": 52.1862,
              "lng": -122.0656
            },
            {
              "name": "Yoho Park",
              "fullName": "Yoho Park, BC. Canada",
              "path": [
                "Canada",
                "BC",
                "Yoho Park"
              ],
              "lat": 51.447,
              "lng": -116.324
            }
          ]
        },
        {
          "name": "MB",
          "children": [
            {
              "name": "Bachelors Island",
              "fullName": "Bachelors Island, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Bachelors Island"
              ],
              "lat": 51.75,
              "lng": -99.9
            },
            {
              "name": "Berens River",
              "fullName": "Berens River, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Berens River"
              ],
              "lat": 52.3597,
              "lng": -97.0219
            },
            {
              "name": "Brandon",
              "fullName": "Brandon, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Brandon"
              ],
              "lat": 49.9033,
              "lng": -99.9456
            },
            {
              "name": "Carman",
              "fullName": "Carman, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Carman"
              ],
              "lat": 49.5,
              "lng": -98.03
            },
            {
              "name": "Churchill",
              "fullName": "Churchill, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Churchill"
              ],
              "lat": 58.74,
              "lng": -94.07
            },
            {
              "name": "Cypress River",
              "fullName": "Cypress River, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Cypress River"
              ],
              "lat": 49.5622,
              "lng": -99.0739
            },
            {
              "name": "Dauphin",
              "fullName": "Dauphin, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Dauphin"
              ],
              "lat": 51.1003,
              "lng": -100.0569
            },
            {
              "name": "Emerson",
              "fullName": "Emerson, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Emerson"
              ],
              "lat": 49.0014,
              "lng": -97.2417
            },
            {
              "name": "Fisher Branch",
              "fullName": "Fisher Branch, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Fisher Branch"
              ],
              "lat": 51.0834,
              "lng": -97.5544
            },
            {
              "name": "Flin Flon",
              "fullName": "Flin Flon, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Flin Flon"
              ],
              "lat": 54.68,
              "lng": -101.68
            },
            {
              "name": "George Island",
              "fullName": "George Island, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "George Island"
              ],
              "lat": 52.819,
              "lng": -97.616
            },
            {
              "name": "Gillam",
              "fullName": "Gillam, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Gillam"
              ],
              "lat": 56.36,
              "lng": -94.71
            },
            {
              "name": "Gimli",
              "fullName": "Gimli, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Gimli"
              ],
              "lat": 50.631,
              "lng": -96.982
            },
            {
              "name": "Grand Rapids",
              "fullName": "Grand Rapids, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Grand Rapids"
              ],
              "lat": 53.183,
              "lng": -99.267
            },
            {
              "name": "Hunter Point",
              "fullName": "Hunter Point, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Hunter Point"
              ],
              "lat": 53.027,
              "lng": -100.935
            },
            {
              "name": "Island Lake",
              "fullName": "Island Lake, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Island Lake"
              ],
              "lat": 53.854,
              "lng": -94.653
            },
            {
              "name": "Lynn Lake",
              "fullName": "Lynn Lake, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Lynn Lake"
              ],
              "lat": 56.86,
              "lng": -101.08
            },
            {
              "name": "Melita",
              "fullName": "Melita, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Melita"
              ],
              "lat": 49.2812,
              "lng": -100.9862
            },
            {
              "name": "Morden",
              "fullName": "Morden, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Morden"
              ],
              "lat": 49.1875,
              "lng": -98.0839
            },
            {
              "name": "Norway House",
              "fullName": "Norway House, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Norway House"
              ],
              "lat": 53.96,
              "lng": -97.84
            },
            {
              "name": "Oakpoint",
              "fullName": "Oakpoint, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Oakpoint"
              ],
              "lat": 50.5,
              "lng": -98.037
            },
            {
              "name": "Pilot Mound",
              "fullName": "Pilot Mound, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Pilot Mound"
              ],
              "lat": 49.1881,
              "lng": -98.9064
            },
            {
              "name": "Pinawa",
              "fullName": "Pinawa, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Pinawa"
              ],
              "lat": 50.177,
              "lng": -96.065
            },
            {
              "name": "Portage La Prarie",
              "fullName": "Portage La Prarie, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Portage La Prarie"
              ],
              "lat": 49.9031,
              "lng": -98.2839
            },
            {
              "name": "Roblin",
              "fullName": "Roblin, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Roblin"
              ],
              "lat": 51.1833,
              "lng": -101.3628
            },
            {
              "name": "Shoal Lake",
              "fullName": "Shoal Lake, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Shoal Lake"
              ],
              "lat": 50.455,
              "lng": -100.6036
            },
            {
              "name": "Sprague",
              "fullName": "Sprague, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Sprague"
              ],
              "lat": 49.0236,
              "lng": -95.5983
            },
            {
              "name": "Swan River",
              "fullName": "Swan River, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Swan River"
              ],
              "lat": 52.1151,
              "lng": -101.233
            },
            {
              "name": "Tadoule Lake",
              "fullName": "Tadoule Lake, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Tadoule Lake"
              ],
              "lat": 58.709,
              "lng": -98.501
            },
            {
              "name": "The Pas",
              "fullName": "The Pas, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "The Pas"
              ],
              "lat": 53.9747,
              "lng": -101.0889
            },
            {
              "name": "Thompson",
              "fullName": "Thompson, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Thompson"
              ],
              "lat": 55.8,
              "lng": -97.86
            },
            {
              "name": "Victoria Beach",
              "fullName": "Victoria Beach, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Victoria Beach"
              ],
              "lat": 50.6944,
              "lng": -96.5625
            },
            {
              "name": "Wasagaming",
              "fullName": "Wasagaming, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Wasagaming"
              ],
              "lat": 50.655,
              "lng": -99.9419
            },
            {
              "name": "Winnipeg",
              "fullName": "Winnipeg, MB. Canada",
              "path": [
                "Canada",
                "MB",
                "Winnipeg"
              ],
              "lat": 49.9158,
              "lng": -97.2493
            }
          ]
        },
        {
          "name": "NB",
          "children": [
            {
              "name": "Alma",
              "fullName": "Alma, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Alma"
              ],
              "lat": 45.597,
              "lng": -64.953
            },
            {
              "name": "Bas Caraquet",
              "fullName": "Bas Caraquet, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Bas Caraquet"
              ],
              "lat": 47.8,
              "lng": -64.83
            },
            {
              "name": "Bathurst",
              "fullName": "Bathurst, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Bathurst"
              ],
              "lat": 47.631,
              "lng": -65.741
            },
            {
              "name": "Charlo",
              "fullName": "Charlo, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Charlo"
              ],
              "lat": 47.9889,
              "lng": -66.3336
            },
            {
              "name": "Edmundston",
              "fullName": "Edmundston, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Edmundston"
              ],
              "lat": 47.4167,
              "lng": -68.3244
            },
            {
              "name": "Fredricton",
              "fullName": "Fredricton, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Fredricton"
              ],
              "lat": 45.966,
              "lng": -66.651
            },
            {
              "name": "Grand Manan",
              "fullName": "Grand Manan, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Grand Manan"
              ],
              "lat": 44.712,
              "lng": -66.802
            },
            {
              "name": "Miramichi",
              "fullName": "Miramichi, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Miramichi"
              ],
              "lat": 47.0094,
              "lng": -65.465
            },
            {
              "name": "Moncton",
              "fullName": "Moncton, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Moncton"
              ],
              "lat": 46.1053,
              "lng": -64.6839
            },
            {
              "name": "Saint John",
              "fullName": "Saint John, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "Saint John"
              ],
              "lat": 45.318,
              "lng": -65.886
            },
            {
              "name": "St. Leonard",
              "fullName": "St. Leonard, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "St. Leonard"
              ],
              "lat": 47.158,
              "lng": -67.832
            },
            {
              "name": "St. Stephen",
              "fullName": "St. Stephen, NB. Canada",
              "path": [
                "Canada",
                "NB",
                "St. Stephen"
              ],
              "lat": 45.2103,
              "lng": -67.2528
            }
          ]
        },
        {
          "name": "NL",
          "children": [
            {
              "name": "Argentia",
              "fullName": "Argentia, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Argentia"
              ],
              "lat": 47.294,
              "lng": -53.993
            },
            {
              "name": "Badger",
              "fullName": "Badger, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Badger"
              ],
              "lat": 48.968,
              "lng": -56.061
            },
            {
              "name": "Bonavista",
              "fullName": "Bonavista, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Bonavista"
              ],
              "lat": 48.67,
              "lng": -53.11
            },
            {
              "name": "Burgeo",
              "fullName": "Burgeo, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Burgeo"
              ],
              "lat": 47.613,
              "lng": -57.61
            },
            {
              "name": "Cape Race",
              "fullName": "Cape Race, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Cape Race"
              ],
              "lat": 46.6602,
              "lng": -53.0755
            },
            {
              "name": "Cartwright",
              "fullName": "Cartwright, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Cartwright"
              ],
              "lat": 53.683,
              "lng": -57.041
            },
            {
              "name": "Churchill Falls",
              "fullName": "Churchill Falls, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Churchill Falls"
              ],
              "lat": 53.562,
              "lng": -64.106
            },
            {
              "name": "Corner Brook",
              "fullName": "Corner Brook, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Corner Brook"
              ],
              "lat": 48.93,
              "lng": -57.92
            },
            {
              "name": "Daniels Harbour",
              "fullName": "Daniels Harbour, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Daniels Harbour"
              ],
              "lat": 50.2364,
              "lng": -57.5811
            },
            {
              "name": "Englee",
              "fullName": "Englee, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Englee"
              ],
              "lat": 50.721,
              "lng": -56.113
            },
            {
              "name": "Gander",
              "fullName": "Gander, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Gander"
              ],
              "lat": 48.946,
              "lng": -54.567
            },
            {
              "name": "Goose Bay",
              "fullName": "Goose Bay, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Goose Bay"
              ],
              "lat": 53.317,
              "lng": -60.417
            },
            {
              "name": "Grates Cove",
              "fullName": "Grates Cove, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Grates Cove"
              ],
              "lat": 48.17,
              "lng": -52.94
            },
            {
              "name": "Hopedale",
              "fullName": "Hopedale, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Hopedale"
              ],
              "lat": 55.449,
              "lng": -60.228
            },
            {
              "name": "La Scie",
              "fullName": "La Scie, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "La Scie"
              ],
              "lat": 49.913,
              "lng": -55.671
            },
            {
              "name": "Marticot Island",
              "fullName": "Marticot Island, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Marticot Island"
              ],
              "lat": 47.328,
              "lng": -54.585
            },
            {
              "name": "Mary_s Harbour",
              "fullName": "Mary_s Harbour, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Mary_s Harbour"
              ],
              "lat": 52.304,
              "lng": -55.833
            },
            {
              "name": "Nain",
              "fullName": "Nain, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Nain"
              ],
              "lat": 56.55,
              "lng": -61.683
            },
            {
              "name": "Pool_s Island",
              "fullName": "Pool_s Island, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Pool_s Island"
              ],
              "lat": 49.1127,
              "lng": -53.5825
            },
            {
              "name": "Port Aux Basques",
              "fullName": "Port Aux Basques, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Port Aux Basques"
              ],
              "lat": 47.5734,
              "lng": -59.1531
            },
            {
              "name": "Rocky Harbour",
              "fullName": "Rocky Harbour, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Rocky Harbour"
              ],
              "lat": 49.5716,
              "lng": -57.8763
            },
            {
              "name": "Sagona Island",
              "fullName": "Sagona Island, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Sagona Island"
              ],
              "lat": 47.367,
              "lng": -55.795
            },
            {
              "name": "St. Anthony",
              "fullName": "St. Anthony, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "St. Anthony"
              ],
              "lat": 51.37,
              "lng": -55.6
            },
            {
              "name": "St. John_s",
              "fullName": "St. John_s, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "St. John_s"
              ],
              "lat": 47.62,
              "lng": -52.75
            },
            {
              "name": "St. Lawrence",
              "fullName": "St. Lawrence, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "St. Lawrence"
              ],
              "lat": 46.92,
              "lng": -55.38
            },
            {
              "name": "Terra Nova",
              "fullName": "Terra Nova, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Terra Nova"
              ],
              "lat": 48.56,
              "lng": -53.97
            },
            {
              "name": "Twillingate",
              "fullName": "Twillingate, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Twillingate"
              ],
              "lat": 49.688,
              "lng": -54.8002
            },
            {
              "name": "Wabush",
              "fullName": "Wabush, NL. Canada",
              "path": [
                "Canada",
                "NL",
                "Wabush"
              ],
              "lat": 52.92,
              "lng": -66.86
            }
          ]
        },
        {
          "name": "NS",
          "children": [
            {
              "name": "Amherst",
              "fullName": "Amherst, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Amherst"
              ],
              "lat": 45.8509,
              "lng": -64.2605
            },
            {
              "name": "Caribou Point",
              "fullName": "Caribou Point, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Caribou Point"
              ],
              "lat": 45.7643,
              "lng": -62.6806
            },
            {
              "name": "Greenwood",
              "fullName": "Greenwood, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Greenwood"
              ],
              "lat": 44.98,
              "lng": -64.92
            },
            {
              "name": "Halifax",
              "fullName": "Halifax, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Halifax"
              ],
              "lat": 44.657,
              "lng": -63.608
            },
            {
              "name": "Ingonish Beach",
              "fullName": "Ingonish Beach, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Ingonish Beach"
              ],
              "lat": 46.663,
              "lng": -60.406
            },
            {
              "name": "Kejimkujik",
              "fullName": "Kejimkujik, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Kejimkujik"
              ],
              "lat": 44.403,
              "lng": -65.203
            },
            {
              "name": "Lunenburg",
              "fullName": "Lunenburg, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Lunenburg"
              ],
              "lat": 44.36,
              "lng": -64.3
            },
            {
              "name": "Malay Falls",
              "fullName": "Malay Falls, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Malay Falls"
              ],
              "lat": 44.98,
              "lng": -62.48
            },
            {
              "name": "Margaree",
              "fullName": "Margaree, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Margaree"
              ],
              "lat": 46.369,
              "lng": -60.976
            },
            {
              "name": "Parrsboro",
              "fullName": "Parrsboro, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Parrsboro"
              ],
              "lat": 45.4135,
              "lng": -64.3462
            },
            {
              "name": "Port Hawkesbury",
              "fullName": "Port Hawkesbury, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Port Hawkesbury"
              ],
              "lat": 45.657,
              "lng": -61.373
            },
            {
              "name": "Sable Island",
              "fullName": "Sable Island, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Sable Island"
              ],
              "lat": 43.9314,
              "lng": -60.0083
            },
            {
              "name": "Sydney",
              "fullName": "Sydney, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Sydney"
              ],
              "lat": 46.163,
              "lng": -60.043
            },
            {
              "name": "Truro",
              "fullName": "Truro, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Truro"
              ],
              "lat": 45.37,
              "lng": -63.27
            },
            {
              "name": "Yarmouth",
              "fullName": "Yarmouth, NS. Canada",
              "path": [
                "Canada",
                "NS",
                "Yarmouth"
              ],
              "lat": 43.8308,
              "lng": -66.0886
            }
          ]
        },
        {
          "name": "NT",
          "children": [
            {
              "name": "Cape Parry",
              "fullName": "Cape Parry, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Cape Parry"
              ],
              "lat": 70.167,
              "lng": -124.717
            },
            {
              "name": "Fort Good Hope",
              "fullName": "Fort Good Hope, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Fort Good Hope"
              ],
              "lat": 66.242,
              "lng": -128.644
            },
            {
              "name": "Fort Reliance",
              "fullName": "Fort Reliance, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Fort Reliance"
              ],
              "lat": 62.711,
              "lng": -109.168
            },
            {
              "name": "Fort Smith",
              "fullName": "Fort Smith, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Fort Smith"
              ],
              "lat": 60.026,
              "lng": -111.929
            },
            {
              "name": "Hanbury River",
              "fullName": "Hanbury River, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Hanbury River"
              ],
              "lat": 63.6,
              "lng": -105.13
            },
            {
              "name": "Hay River",
              "fullName": "Hay River, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Hay River"
              ],
              "lat": 60.8394,
              "lng": -115.7816
            },
            {
              "name": "Holman",
              "fullName": "Holman, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Holman"
              ],
              "lat": 70.7614,
              "lng": -117.8
            },
            {
              "name": "Lindburg Landing",
              "fullName": "Lindburg Landing, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Lindburg Landing"
              ],
              "lat": 61.125,
              "lng": -122.852
            },
            {
              "name": "Mould Bay",
              "fullName": "Mould Bay, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Mould Bay"
              ],
              "lat": 76.237,
              "lng": -119.347
            },
            {
              "name": "Rabbit Kettle",
              "fullName": "Rabbit Kettle, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Rabbit Kettle"
              ],
              "lat": 61.96,
              "lng": -127.21
            },
            {
              "name": "Rae Lakes",
              "fullName": "Rae Lakes, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Rae Lakes"
              ],
              "lat": 64.115,
              "lng": -117.313
            },
            {
              "name": "Sachs Harbour",
              "fullName": "Sachs Harbour, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Sachs Harbour"
              ],
              "lat": 71.992,
              "lng": -125.243
            },
            {
              "name": "Thomsen River",
              "fullName": "Thomsen River, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Thomsen River"
              ],
              "lat": 73.2311,
              "lng": -119.5406
            },
            {
              "name": "Trail Valley",
              "fullName": "Trail Valley, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Trail Valley"
              ],
              "lat": 68.742,
              "lng": -133.499
            },
            {
              "name": "Tuktoyaktuk",
              "fullName": "Tuktoyaktuk, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Tuktoyaktuk"
              ],
              "lat": 69.436,
              "lng": -133.023
            },
            {
              "name": "Tuktut Nogait",
              "fullName": "Tuktut Nogait, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Tuktut Nogait"
              ],
              "lat": 69.199,
              "lng": -122.359
            },
            {
              "name": "Yellowknife",
              "fullName": "Yellowknife, NT. Canada",
              "path": [
                "Canada",
                "NT",
                "Yellowknife"
              ],
              "lat": 62.46,
              "lng": -114.44
            }
          ]
        },
        {
          "name": "NU",
          "children": [
            {
              "name": "Alert",
              "fullName": "Alert, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Alert"
              ],
              "lat": 82.493,
              "lng": -62.35
            },
            {
              "name": "Arctic Bay",
              "fullName": "Arctic Bay, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Arctic Bay"
              ],
              "lat": 72.993,
              "lng": -85.012
            },
            {
              "name": "Arviat",
              "fullName": "Arviat, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Arviat"
              ],
              "lat": 61.098,
              "lng": -94.069
            },
            {
              "name": "Baker Lake",
              "fullName": "Baker Lake, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Baker Lake"
              ],
              "lat": 64.319,
              "lng": -96.002
            },
            {
              "name": "Cambridge Bay",
              "fullName": "Cambridge Bay, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Cambridge Bay"
              ],
              "lat": 69.107,
              "lng": -105.116
            },
            {
              "name": "Cape Dorset",
              "fullName": "Cape Dorset, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Cape Dorset"
              ],
              "lat": 64.231,
              "lng": -76.53
            },
            {
              "name": "Cape Dyer",
              "fullName": "Cape Dyer, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Cape Dyer"
              ],
              "lat": 66.596,
              "lng": -61.581
            },
            {
              "name": "Cape Young",
              "fullName": "Cape Young, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Cape Young"
              ],
              "lat": 68.933,
              "lng": -116.917
            },
            {
              "name": "Clyde River",
              "fullName": "Clyde River, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Clyde River"
              ],
              "lat": 70.486,
              "lng": -68.517
            },
            {
              "name": "Coral Harbour",
              "fullName": "Coral Harbour, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Coral Harbour"
              ],
              "lat": 64.188,
              "lng": -83.349
            },
            {
              "name": "Dewar Lakes",
              "fullName": "Dewar Lakes, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Dewar Lakes"
              ],
              "lat": 68.651,
              "lng": -71.234
            },
            {
              "name": "Ennadai Lake",
              "fullName": "Ennadai Lake, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Ennadai Lake"
              ],
              "lat": 61.132,
              "lng": -100.884
            },
            {
              "name": "Eureka",
              "fullName": "Eureka, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Eureka"
              ],
              "lat": 79.989,
              "lng": -85.934
            },
            {
              "name": "Gjoa Haven",
              "fullName": "Gjoa Haven, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Gjoa Haven"
              ],
              "lat": 68.636,
              "lng": -95.85
            },
            {
              "name": "Grise Fiord",
              "fullName": "Grise Fiord, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Grise Fiord"
              ],
              "lat": 76.423,
              "lng": -82.902
            },
            {
              "name": "Hall Beach",
              "fullName": "Hall Beach, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Hall Beach"
              ],
              "lat": 68.78,
              "lng": -81.24
            },
            {
              "name": "Iqaluit",
              "fullName": "Iqaluit, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Iqaluit"
              ],
              "lat": 63.7478,
              "lng": -68.5444
            },
            {
              "name": "Isachsen",
              "fullName": "Isachsen, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Isachsen"
              ],
              "lat": 78.792,
              "lng": -103.554
            },
            {
              "name": "Lupin",
              "fullName": "Lupin, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Lupin"
              ],
              "lat": 65.76,
              "lng": -111.25
            },
            {
              "name": "Pelly Bay",
              "fullName": "Pelly Bay, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Pelly Bay"
              ],
              "lat": 68.538,
              "lng": -89.789
            },
            {
              "name": "Pond Inlet",
              "fullName": "Pond Inlet, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Pond Inlet"
              ],
              "lat": 72.693,
              "lng": -77.957
            },
            {
              "name": "Rankin Inlet",
              "fullName": "Rankin Inlet, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Rankin Inlet"
              ],
              "lat": 62.81,
              "lng": -92.11
            },
            {
              "name": "Rea Point",
              "fullName": "Rea Point, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Rea Point"
              ],
              "lat": 75.367,
              "lng": -105.717
            },
            {
              "name": "Resolute Bay",
              "fullName": "Resolute Bay, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Resolute Bay"
              ],
              "lat": 74.72,
              "lng": -94.97
            },
            {
              "name": "Robertson Lake",
              "fullName": "Robertson Lake, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Robertson Lake"
              ],
              "lat": 65.1,
              "lng": -102.43
            },
            {
              "name": "Spence Bay",
              "fullName": "Spence Bay, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Spence Bay"
              ],
              "lat": 69.55,
              "lng": -93.58
            },
            {
              "name": "Stefansson Island",
              "fullName": "Stefansson Island, NU. Canada",
              "path": [
                "Canada",
                "NU",
                "Stefansson Island"
              ],
              "lat": 73.766,
              "lng": -105.296
            }
          ]
        },
        {
          "name": "ON",
          "children": [
            {
              "name": "Algonquin Park",
              "fullName": "Algonquin Park, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Algonquin Park"
              ],
              "lat": 45.536,
              "lng": -78.262
            },
            {
              "name": "Armstrong",
              "fullName": "Armstrong, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Armstrong"
              ],
              "lat": 50.294,
              "lng": -88.905
            },
            {
              "name": "Atikokan",
              "fullName": "Atikokan, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Atikokan"
              ],
              "lat": 48.761,
              "lng": -91.6283
            },
            {
              "name": "Bancroft",
              "fullName": "Bancroft, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Bancroft"
              ],
              "lat": 45.0716,
              "lng": -77.8799
            },
            {
              "name": "Barrie",
              "fullName": "Barrie, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Barrie"
              ],
              "lat": 44.38,
              "lng": -79.78
            },
            {
              "name": "Big Trout Lake",
              "fullName": "Big Trout Lake, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Big Trout Lake"
              ],
              "lat": 53.82,
              "lng": -89.9
            },
            {
              "name": "Britt",
              "fullName": "Britt, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Britt"
              ],
              "lat": 45.8,
              "lng": -80.53
            },
            {
              "name": "Brockville",
              "fullName": "Brockville, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Brockville"
              ],
              "lat": 44.6354,
              "lng": -75.7516
            },
            {
              "name": "Cameron Falls",
              "fullName": "Cameron Falls, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Cameron Falls"
              ],
              "lat": 49.154,
              "lng": -88.345
            },
            {
              "name": "Chapleau",
              "fullName": "Chapleau, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Chapleau"
              ],
              "lat": 47.82,
              "lng": -83.347
            },
            {
              "name": "Dryden",
              "fullName": "Dryden, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Dryden"
              ],
              "lat": 49.83,
              "lng": -92.74
            },
            {
              "name": "Ear Falls",
              "fullName": "Ear Falls, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Ear Falls"
              ],
              "lat": 50.631,
              "lng": -93.221
            },
            {
              "name": "Fort Frances",
              "fullName": "Fort Frances, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Fort Frances"
              ],
              "lat": 48.6511,
              "lng": -93.4389
            },
            {
              "name": "Fort Severn",
              "fullName": "Fort Severn, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Fort Severn"
              ],
              "lat": 56.02,
              "lng": -87.68
            },
            {
              "name": "Gerladton",
              "fullName": "Gerladton, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Gerladton"
              ],
              "lat": 49.783,
              "lng": -86.931
            },
            {
              "name": "Goderich",
              "fullName": "Goderich, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Goderich"
              ],
              "lat": 43.7647,
              "lng": -81.7122
            },
            {
              "name": "Gore Bay",
              "fullName": "Gore Bay, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Gore Bay"
              ],
              "lat": 45.8846,
              "lng": -82.5743
            },
            {
              "name": "Hamilton",
              "fullName": "Hamilton, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Hamilton"
              ],
              "lat": 43.2619,
              "lng": -79.9204
            },
            {
              "name": "Kapuskasing",
              "fullName": "Kapuskasing, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Kapuskasing"
              ],
              "lat": 49.4053,
              "lng": -82.4431
            },
            {
              "name": "Kenora",
              "fullName": "Kenora, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Kenora"
              ],
              "lat": 49.791,
              "lng": -94.361
            },
            {
              "name": "Killarney",
              "fullName": "Killarney, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Killarney"
              ],
              "lat": 45.9682,
              "lng": -81.4888
            },
            {
              "name": "Kingston",
              "fullName": "Kingston, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Kingston"
              ],
              "lat": 44.2232,
              "lng": -76.5994
            },
            {
              "name": "Kirkland Lake",
              "fullName": "Kirkland Lake, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Kirkland Lake"
              ],
              "lat": 48.151,
              "lng": -80.012
            },
            {
              "name": "Lansdowne House",
              "fullName": "Lansdowne House, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Lansdowne House"
              ],
              "lat": 52.2,
              "lng": -87.94
            },
            {
              "name": "Little Flatland Island",
              "fullName": "Little Flatland Island, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Little Flatland Island"
              ],
              "lat": 49.69,
              "lng": -88.306
            },
            {
              "name": "London",
              "fullName": "London, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "London"
              ],
              "lat": 43.0269,
              "lng": -81.1486
            },
            {
              "name": "Long Point",
              "fullName": "Long Point, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Long Point"
              ],
              "lat": 42.549,
              "lng": -80.049
            },
            {
              "name": "Markham",
              "fullName": "Markham, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Markham"
              ],
              "lat": 43.866,
              "lng": -79.3681
            },
            {
              "name": "Mississauga",
              "fullName": "Mississauga, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Mississauga"
              ],
              "lat": 43.5525,
              "lng": -79.6665
            },
            {
              "name": "Moosonee",
              "fullName": "Moosonee, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Moosonee"
              ],
              "lat": 51.291,
              "lng": -80.617
            },
            {
              "name": "Muskoka",
              "fullName": "Muskoka, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Muskoka"
              ],
              "lat": 44.973,
              "lng": -79.304
            },
            {
              "name": "Muskrat Dam",
              "fullName": "Muskrat Dam, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Muskrat Dam"
              ],
              "lat": 53.44,
              "lng": -91.76
            },
            {
              "name": "Nagagami",
              "fullName": "Nagagami, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Nagagami"
              ],
              "lat": 49.7467,
              "lng": -84.1636
            },
            {
              "name": "North Bay",
              "fullName": "North Bay, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "North Bay"
              ],
              "lat": 46.365,
              "lng": -79.423
            },
            {
              "name": "Oshawa",
              "fullName": "Oshawa, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Oshawa"
              ],
              "lat": 43.92,
              "lng": -78.893
            },
            {
              "name": "Ottawa",
              "fullName": "Ottawa, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Ottawa"
              ],
              "lat": 45.3171,
              "lng": -75.6739
            },
            {
              "name": "Parry Sound",
              "fullName": "Parry Sound, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Parry Sound"
              ],
              "lat": 45.344,
              "lng": -80.042
            },
            {
              "name": "Peawanuck",
              "fullName": "Peawanuck, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Peawanuck"
              ],
              "lat": 54.99,
              "lng": -85.441
            },
            {
              "name": "Pembroke",
              "fullName": "Pembroke, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Pembroke"
              ],
              "lat": 45.8603,
              "lng": -77.2525
            },
            {
              "name": "Peterborough",
              "fullName": "Peterborough, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Peterborough"
              ],
              "lat": 44.2303,
              "lng": -78.3526
            },
            {
              "name": "Pickle Lake",
              "fullName": "Pickle Lake, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Pickle Lake"
              ],
              "lat": 51.4492,
              "lng": -90.2181
            },
            {
              "name": "Point Pelee",
              "fullName": "Point Pelee, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Point Pelee"
              ],
              "lat": 41.9488,
              "lng": -82.5192
            },
            {
              "name": "Point Petre",
              "fullName": "Point Petre, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Point Petre"
              ],
              "lat": 43.8396,
              "lng": -77.153
            },
            {
              "name": "Pukaskwa",
              "fullName": "Pukaskwa, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Pukaskwa"
              ],
              "lat": 48.608,
              "lng": -86.287
            },
            {
              "name": "Red Lake",
              "fullName": "Red Lake, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Red Lake"
              ],
              "lat": 51.07,
              "lng": -93.79
            },
            {
              "name": "Ridgetown",
              "fullName": "Ridgetown, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Ridgetown"
              ],
              "lat": 42.454,
              "lng": -81.886
            },
            {
              "name": "Royal Island",
              "fullName": "Royal Island, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Royal Island"
              ],
              "lat": 49.467,
              "lng": -94.761
            },
            {
              "name": "Sandy Lake",
              "fullName": "Sandy Lake, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Sandy Lake"
              ],
              "lat": 53.063,
              "lng": -93.344
            },
            {
              "name": "Sarnia",
              "fullName": "Sarnia, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Sarnia"
              ],
              "lat": 42.995,
              "lng": -82.3075
            },
            {
              "name": "Simcoe",
              "fullName": "Simcoe, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Simcoe"
              ],
              "lat": 42.85,
              "lng": -80.27
            },
            {
              "name": "Sioux Lookout",
              "fullName": "Sioux Lookout, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Sioux Lookout"
              ],
              "lat": 50.121,
              "lng": -91.903
            },
            {
              "name": "St. Catherines",
              "fullName": "St. Catherines, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "St. Catherines"
              ],
              "lat": 43.245,
              "lng": -79.218
            },
            {
              "name": "Sudbury",
              "fullName": "Sudbury, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Sudbury"
              ],
              "lat": 46.6237,
              "lng": -80.7939
            },
            {
              "name": "Thunder Bay",
              "fullName": "Thunder Bay, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Thunder Bay"
              ],
              "lat": 48.3694,
              "lng": -89.3272
            },
            {
              "name": "Timmins",
              "fullName": "Timmins, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Timmins"
              ],
              "lat": 48.568,
              "lng": -81.378
            },
            {
              "name": "Tobermory",
              "fullName": "Tobermory, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Tobermory"
              ],
              "lat": 45.2239,
              "lng": -81.635
            },
            {
              "name": "Toronto",
              "fullName": "Toronto, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Toronto"
              ],
              "lat": 43.6658,
              "lng": -79.3953
            },
            {
              "name": "Upsala",
              "fullName": "Upsala, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Upsala"
              ],
              "lat": 49.0361,
              "lng": -90.4614
            },
            {
              "name": "Waterloo",
              "fullName": "Waterloo, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Waterloo"
              ],
              "lat": 43.4735,
              "lng": -80.5572
            },
            {
              "name": "Wawa",
              "fullName": "Wawa, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Wawa"
              ],
              "lat": 47.973,
              "lng": -84.7824
            },
            {
              "name": "Welland",
              "fullName": "Welland, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Welland"
              ],
              "lat": 42.9733,
              "lng": -79.325
            },
            {
              "name": "Windsor",
              "fullName": "Windsor, ON. Canada",
              "path": [
                "Canada",
                "ON",
                "Windsor"
              ],
              "lat": 42.2788,
              "lng": -82.9494
            }
          ]
        },
        {
          "name": "PE",
          "children": [
            {
              "name": "Charlottetown",
              "fullName": "Charlottetown, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "Charlottetown"
              ],
              "lat": 46.289,
              "lng": -63.129
            },
            {
              "name": "East Point",
              "fullName": "East Point, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "East Point"
              ],
              "lat": 46.4597,
              "lng": -61.9878
            },
            {
              "name": "Maple Plains",
              "fullName": "Maple Plains, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "Maple Plains"
              ],
              "lat": 46.3,
              "lng": -63.58
            },
            {
              "name": "North Cape",
              "fullName": "North Cape, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "North Cape"
              ],
              "lat": 47.0581,
              "lng": -63.9969
            },
            {
              "name": "St. Peters",
              "fullName": "St. Peters, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "St. Peters"
              ],
              "lat": 46.4503,
              "lng": -62.5758
            },
            {
              "name": "Summerside",
              "fullName": "Summerside, PE. Canada",
              "path": [
                "Canada",
                "PE",
                "Summerside"
              ],
              "lat": 46.4413,
              "lng": -63.8375
            }
          ]
        },
        {
          "name": "QC",
          "children": [
            {
              "name": "Amqui",
              "fullName": "Amqui, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Amqui"
              ],
              "lat": 48.472,
              "lng": -67.435
            },
            {
              "name": "Baie-Comeau",
              "fullName": "Baie-Comeau, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Baie-Comeau"
              ],
              "lat": 49.259,
              "lng": -68.146
            },
            {
              "name": "Barrage Angliers",
              "fullName": "Barrage Angliers, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Barrage Angliers"
              ],
              "lat": 47.55,
              "lng": -79.24
            },
            {
              "name": "Barrage Temiscamingue",
              "fullName": "Barrage Temiscamingue, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Barrage Temiscamingue"
              ],
              "lat": 46.7097,
              "lng": -79.101
            },
            {
              "name": "Cap-Chat",
              "fullName": "Cap-Chat, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Cap-Chat"
              ],
              "lat": 49.1092,
              "lng": -66.6544
            },
            {
              "name": "Chamouchouane",
              "fullName": "Chamouchouane, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Chamouchouane"
              ],
              "lat": 49.278,
              "lng": -73.356
            },
            {
              "name": "Chapais",
              "fullName": "Chapais, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Chapais"
              ],
              "lat": 49.8225,
              "lng": -74.9753
            },
            {
              "name": "Chevery",
              "fullName": "Chevery, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Chevery"
              ],
              "lat": 50.465,
              "lng": -59.6394
            },
            {
              "name": "Chute-Des-Passes",
              "fullName": "Chute-Des-Passes, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Chute-Des-Passes"
              ],
              "lat": 49.84,
              "lng": -71.168
            },
            {
              "name": "Drummondville",
              "fullName": "Drummondville, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Drummondville"
              ],
              "lat": 45.8253,
              "lng": -72.5369
            },
            {
              "name": "Frelighsburg",
              "fullName": "Frelighsburg, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Frelighsburg"
              ],
              "lat": 45.0394,
              "lng": -72.8561
            },
            {
              "name": "Gaspe",
              "fullName": "Gaspe, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Gaspe"
              ],
              "lat": 48.7769,
              "lng": -64.4781
            },
            {
              "name": "Gatineau",
              "fullName": "Gatineau, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Gatineau"
              ],
              "lat": 45.52,
              "lng": -75.563
            },
            {
              "name": "Granby",
              "fullName": "Granby, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Granby"
              ],
              "lat": 45.3727,
              "lng": -72.7743
            },
            {
              "name": "Havre St. Pierre",
              "fullName": "Havre St. Pierre, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Havre St. Pierre"
              ],
              "lat": 50.282,
              "lng": -63.611
            },
            {
              "name": "Heath Point",
              "fullName": "Heath Point, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Heath Point"
              ],
              "lat": 49.085,
              "lng": -61.701
            },
            {
              "name": "Ile d_Orleans",
              "fullName": "Ile d_Orleans, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Ile d_Orleans"
              ],
              "lat": 46.9967,
              "lng": -70.8083
            },
            {
              "name": "Inukjuak",
              "fullName": "Inukjuak, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Inukjuak"
              ],
              "lat": 58.4672,
              "lng": -78.0786
            },
            {
              "name": "Jonquiere",
              "fullName": "Jonquiere, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Jonquiere"
              ],
              "lat": 48.425,
              "lng": -71.1425
            },
            {
              "name": "Kuujjuaq",
              "fullName": "Kuujjuaq, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Kuujjuaq"
              ],
              "lat": 58.0987,
              "lng": -68.4175
            },
            {
              "name": "L_Assomption",
              "fullName": "L_Assomption, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "L_Assomption"
              ],
              "lat": 45.8094,
              "lng": -73.4347
            },
            {
              "name": "L_Etape",
              "fullName": "L_Etape, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "L_Etape"
              ],
              "lat": 47.5622,
              "lng": -71.2289
            },
            {
              "name": "La Baie",
              "fullName": "La Baie, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "La Baie"
              ],
              "lat": 48.2981,
              "lng": -70.9194
            },
            {
              "name": "La Grande",
              "fullName": "La Grande, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "La Grande"
              ],
              "lat": 53.755,
              "lng": -73.675
            },
            {
              "name": "La Grande Riviere",
              "fullName": "La Grande Riviere, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "La Grande Riviere"
              ],
              "lat": 53.63,
              "lng": -77.7
            },
            {
              "name": "La Pocatiere",
              "fullName": "La Pocatiere, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "La Pocatiere"
              ],
              "lat": 47.354,
              "lng": -70.029
            },
            {
              "name": "La Tuque",
              "fullName": "La Tuque, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "La Tuque"
              ],
              "lat": 47.411,
              "lng": -72.787
            },
            {
              "name": "Lac Benoit",
              "fullName": "Lac Benoit, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Lac Benoit"
              ],
              "lat": 51.532,
              "lng": -71.111
            },
            {
              "name": "Lac Manouane",
              "fullName": "Lac Manouane, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Lac Manouane"
              ],
              "lat": 50.656,
              "lng": -70.532
            },
            {
              "name": "Magog",
              "fullName": "Magog, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Magog"
              ],
              "lat": 45.2677,
              "lng": -72.1617
            },
            {
              "name": "Maniwaki",
              "fullName": "Maniwaki, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Maniwaki"
              ],
              "lat": 46.2736,
              "lng": -75.9878
            },
            {
              "name": "Matagami",
              "fullName": "Matagami, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Matagami"
              ],
              "lat": 49.7578,
              "lng": -77.7933
            },
            {
              "name": "Mont Joli",
              "fullName": "Mont Joli, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Mont Joli"
              ],
              "lat": 48.603,
              "lng": -68.21
            },
            {
              "name": "Montreal",
              "fullName": "Montreal, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Montreal"
              ],
              "lat": 45.505,
              "lng": -73.5792
            },
            {
              "name": "Natashquan",
              "fullName": "Natashquan, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Natashquan"
              ],
              "lat": 50.19,
              "lng": -61.79
            },
            {
              "name": "New Carlisle",
              "fullName": "New Carlisle, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "New Carlisle"
              ],
              "lat": 48.0119,
              "lng": -65.3317
            },
            {
              "name": "Parent",
              "fullName": "Parent, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Parent"
              ],
              "lat": 47.922,
              "lng": -74.624
            },
            {
              "name": "Pingualuit",
              "fullName": "Pingualuit, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Pingualuit"
              ],
              "lat": 61.313,
              "lng": -73.668
            },
            {
              "name": "Port-Menier",
              "fullName": "Port-Menier, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Port-Menier"
              ],
              "lat": 49.839,
              "lng": -64.293
            },
            {
              "name": "Quebec City",
              "fullName": "Quebec City, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Quebec City"
              ],
              "lat": 46.7803,
              "lng": -71.2875
            },
            {
              "name": "Riviere Aux Feuilles",
              "fullName": "Riviere Aux Feuilles, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Riviere Aux Feuilles"
              ],
              "lat": 57.91,
              "lng": -72.976
            },
            {
              "name": "Riviere-du-Loup",
              "fullName": "Riviere-du-Loup, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Riviere-du-Loup"
              ],
              "lat": 47.8061,
              "lng": -69.5486
            },
            {
              "name": "Roberval",
              "fullName": "Roberval, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Roberval"
              ],
              "lat": 48.523,
              "lng": -72.2662
            },
            {
              "name": "Roquemaure",
              "fullName": "Roquemaure, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Roquemaure"
              ],
              "lat": 48.63,
              "lng": -79.46
            },
            {
              "name": "Rouyn-Noranda",
              "fullName": "Rouyn-Noranda, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Rouyn-Noranda"
              ],
              "lat": 48.2458,
              "lng": -79.0342
            },
            {
              "name": "Schefferville",
              "fullName": "Schefferville, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Schefferville"
              ],
              "lat": 54.8,
              "lng": -66.8
            },
            {
              "name": "Sept-Iles",
              "fullName": "Sept-Iles, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Sept-Iles"
              ],
              "lat": 50.2181,
              "lng": -66.2414
            },
            {
              "name": "Shawinigan",
              "fullName": "Shawinigan, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Shawinigan"
              ],
              "lat": 46.564,
              "lng": -72.733
            },
            {
              "name": "Sherbrooke",
              "fullName": "Sherbrooke, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Sherbrooke"
              ],
              "lat": 45.3686,
              "lng": -71.8233
            },
            {
              "name": "St. Anicet",
              "fullName": "St. Anicet, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "St. Anicet"
              ],
              "lat": 45.1208,
              "lng": -74.2894
            },
            {
              "name": "Ste. Agathe des Monts",
              "fullName": "Ste. Agathe des Monts, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Ste. Agathe des Monts"
              ],
              "lat": 46.05,
              "lng": -74.28
            },
            {
              "name": "Tadoussac",
              "fullName": "Tadoussac, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Tadoussac"
              ],
              "lat": 48.1356,
              "lng": -69.7164
            },
            {
              "name": "Thetford Mines",
              "fullName": "Thetford Mines, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Thetford Mines"
              ],
              "lat": 46.0492,
              "lng": -71.2661
            },
            {
              "name": "Trois-Rivieres",
              "fullName": "Trois-Rivieres, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Trois-Rivieres"
              ],
              "lat": 46.3537,
              "lng": -72.5155
            },
            {
              "name": "Val-d_Or",
              "fullName": "Val-d_Or, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Val-d_Or"
              ],
              "lat": 48.0564,
              "lng": -77.7867
            },
            {
              "name": "Valcartier",
              "fullName": "Valcartier, QC. Canada",
              "path": [
                "Canada",
                "QC",
                "Valcartier"
              ],
              "lat": 46.9004,
              "lng": -71.5032
            }
          ]
        },
        {
          "name": "SK",
          "children": [
            {
              "name": "Assiniboia",
              "fullName": "Assiniboia, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Assiniboia"
              ],
              "lat": 49.73,
              "lng": -105.95
            },
            {
              "name": "Broadview",
              "fullName": "Broadview, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Broadview"
              ],
              "lat": 50.368,
              "lng": -102.571
            },
            {
              "name": "Buffalo Narrows",
              "fullName": "Buffalo Narrows, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Buffalo Narrows"
              ],
              "lat": 55.8409,
              "lng": -108.4208
            },
            {
              "name": "Collins Bay",
              "fullName": "Collins Bay, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Collins Bay"
              ],
              "lat": 58.229,
              "lng": -103.678
            },
            {
              "name": "Cree Lake",
              "fullName": "Cree Lake, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Cree Lake"
              ],
              "lat": 57.35,
              "lng": -107.13
            },
            {
              "name": "Eastend",
              "fullName": "Eastend, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Eastend"
              ],
              "lat": 49.4378,
              "lng": -108.9886
            },
            {
              "name": "Estevan",
              "fullName": "Estevan, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Estevan"
              ],
              "lat": 49.205,
              "lng": -102.967
            },
            {
              "name": "Hudson Bay",
              "fullName": "Hudson Bay, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Hudson Bay"
              ],
              "lat": 52.814,
              "lng": -102.309
            },
            {
              "name": "Indian Head",
              "fullName": "Indian Head, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Indian Head"
              ],
              "lat": 50.55,
              "lng": -103.65
            },
            {
              "name": "Island Falls",
              "fullName": "Island Falls, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Island Falls"
              ],
              "lat": 55.53,
              "lng": -102.35
            },
            {
              "name": "Jimmy Lake",
              "fullName": "Jimmy Lake, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Jimmy Lake"
              ],
              "lat": 54.908,
              "lng": -109.962
            },
            {
              "name": "Kindersley",
              "fullName": "Kindersley, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Kindersley"
              ],
              "lat": 51.52,
              "lng": -109.18
            },
            {
              "name": "La Ronge",
              "fullName": "La Ronge, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "La Ronge"
              ],
              "lat": 55.1464,
              "lng": -105.2703
            },
            {
              "name": "Leader",
              "fullName": "Leader, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Leader"
              ],
              "lat": 50.91,
              "lng": -109.503
            },
            {
              "name": "Lucky Lake",
              "fullName": "Lucky Lake, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Lucky Lake"
              ],
              "lat": 50.95,
              "lng": -107.15
            },
            {
              "name": "Maple Creek",
              "fullName": "Maple Creek, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Maple Creek"
              ],
              "lat": 49.9025,
              "lng": -109.4661
            },
            {
              "name": "Meadow Lake",
              "fullName": "Meadow Lake, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Meadow Lake"
              ],
              "lat": 54.1286,
              "lng": -108.511
            },
            {
              "name": "Melfort",
              "fullName": "Melfort, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Melfort"
              ],
              "lat": 52.8164,
              "lng": -104.5964
            },
            {
              "name": "Moose Jaw",
              "fullName": "Moose Jaw, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Moose Jaw"
              ],
              "lat": 50.332,
              "lng": -105.537
            },
            {
              "name": "Nipawin",
              "fullName": "Nipawin, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Nipawin"
              ],
              "lat": 53.3331,
              "lng": -104.0047
            },
            {
              "name": "North Battleford",
              "fullName": "North Battleford, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "North Battleford"
              ],
              "lat": 52.7691,
              "lng": -108.251
            },
            {
              "name": "Outlook",
              "fullName": "Outlook, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Outlook"
              ],
              "lat": 51.48,
              "lng": -107.05
            },
            {
              "name": "Prince Albert",
              "fullName": "Prince Albert, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Prince Albert"
              ],
              "lat": 53.2103,
              "lng": -105.6767
            },
            {
              "name": "Regina",
              "fullName": "Regina, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Regina"
              ],
              "lat": 50.4269,
              "lng": -104.6703
            },
            {
              "name": "Saskatoon",
              "fullName": "Saskatoon, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Saskatoon"
              ],
              "lat": 52.1736,
              "lng": -106.7189
            },
            {
              "name": "Scott",
              "fullName": "Scott, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Scott"
              ],
              "lat": 52.3597,
              "lng": -108.8347
            },
            {
              "name": "Southend",
              "fullName": "Southend, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Southend"
              ],
              "lat": 56.337,
              "lng": -103.287
            },
            {
              "name": "Spiritwood",
              "fullName": "Spiritwood, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Spiritwood"
              ],
              "lat": 53.3661,
              "lng": -107.5564
            },
            {
              "name": "Stony Rapids",
              "fullName": "Stony Rapids, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Stony Rapids"
              ],
              "lat": 59.25,
              "lng": -105.84
            },
            {
              "name": "Swift Current",
              "fullName": "Swift Current, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Swift Current"
              ],
              "lat": 50.29,
              "lng": -107.69
            },
            {
              "name": "Uranium City",
              "fullName": "Uranium City, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Uranium City"
              ],
              "lat": 59.562,
              "lng": -108.478
            },
            {
              "name": "Val Marie",
              "fullName": "Val Marie, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Val Marie"
              ],
              "lat": 49.06,
              "lng": -107.59
            },
            {
              "name": "Waskesiu Lake",
              "fullName": "Waskesiu Lake, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Waskesiu Lake"
              ],
              "lat": 53.92,
              "lng": -106.07
            },
            {
              "name": "Watrous",
              "fullName": "Watrous, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Watrous"
              ],
              "lat": 51.67,
              "lng": -105.4
            },
            {
              "name": "Weyburn",
              "fullName": "Weyburn, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Weyburn"
              ],
              "lat": 49.7,
              "lng": -103.8
            },
            {
              "name": "Wynyard",
              "fullName": "Wynyard, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Wynyard"
              ],
              "lat": 51.77,
              "lng": -104.2
            },
            {
              "name": "Yorkton",
              "fullName": "Yorkton, SK. Canada",
              "path": [
                "Canada",
                "SK",
                "Yorkton"
              ],
              "lat": 51.2601,
              "lng": -102.4615
            }
          ]
        },
        {
          "name": "YT",
          "children": [
            {
              "name": "Burwash",
              "fullName": "Burwash, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Burwash"
              ],
              "lat": 61.3701,
              "lng": -139.0323
            },
            {
              "name": "Carmacks",
              "fullName": "Carmacks, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Carmacks"
              ],
              "lat": 62.115,
              "lng": -136.1919
            },
            {
              "name": "Dawson",
              "fullName": "Dawson, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Dawson"
              ],
              "lat": 64.0446,
              "lng": -139.1268
            },
            {
              "name": "Faro",
              "fullName": "Faro, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Faro"
              ],
              "lat": 62.21,
              "lng": -133.385
            },
            {
              "name": "Haines Junction",
              "fullName": "Haines Junction, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Haines Junction"
              ],
              "lat": 60.773,
              "lng": -137.58
            },
            {
              "name": "Herschel Island",
              "fullName": "Herschel Island, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Herschel Island"
              ],
              "lat": 69.568,
              "lng": -138.911
            },
            {
              "name": "Ivvavik National Park",
              "fullName": "Ivvavik National Park, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Ivvavik National Park"
              ],
              "lat": 69.164,
              "lng": -140.15
            },
            {
              "name": "MacMillan Pass",
              "fullName": "MacMillan Pass, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "MacMillan Pass"
              ],
              "lat": 63.244,
              "lng": -130.037
            },
            {
              "name": "Margaret Lake",
              "fullName": "Margaret Lake, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Margaret Lake"
              ],
              "lat": 68.801,
              "lng": -140.847
            },
            {
              "name": "Mayo",
              "fullName": "Mayo, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Mayo"
              ],
              "lat": 63.616,
              "lng": -135.88
            },
            {
              "name": "Old Crow",
              "fullName": "Old Crow, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Old Crow"
              ],
              "lat": 67.5679,
              "lng": -139.8449
            },
            {
              "name": "Rock River",
              "fullName": "Rock River, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Rock River"
              ],
              "lat": 66.9811,
              "lng": -136.2181
            },
            {
              "name": "Shingle Point",
              "fullName": "Shingle Point, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Shingle Point"
              ],
              "lat": 68.923,
              "lng": -137.261
            },
            {
              "name": "Teslin",
              "fullName": "Teslin, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Teslin"
              ],
              "lat": 60.1746,
              "lng": -132.7339
            },
            {
              "name": "Watson Lake",
              "fullName": "Watson Lake, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Watson Lake"
              ],
              "lat": 60.1142,
              "lng": -128.8237
            },
            {
              "name": "Whitehorse",
              "fullName": "Whitehorse, YT. Canada",
              "path": [
                "Canada",
                "YT",
                "Whitehorse"
              ],
              "lat": 60.7331,
              "lng": -135.0978
            }
          ]
        }
      ]
    },
    {
      "name": "Colombia",
      "children": [
        {
          "name": "Barranquilla",
          "fullName": "Barranquilla",
          "path": [
            "Colombia",
            "Barranquilla"
          ],
          "lat": 10.89,
          "lng": -74.781
        },
        {
          "name": "Bogota",
          "fullName": "Bogota",
          "path": [
            "Colombia",
            "Bogota"
          ],
          "lat": 4.702,
          "lng": -74.147
        },
        {
          "name": "Cali",
          "fullName": "Cali",
          "path": [
            "Colombia",
            "Cali"
          ],
          "lat": 3.543,
          "lng": -76.382
        },
        {
          "name": "Cucuta San Jose de Cucuta",
          "fullName": "Cucuta San Jose de Cucuta",
          "path": [
            "Colombia",
            "Cucuta San Jose de Cucuta"
          ],
          "lat": 7.928,
          "lng": -72.512
        },
        {
          "name": "Leticia",
          "fullName": "Leticia",
          "path": [
            "Colombia",
            "Leticia"
          ],
          "lat": -4.193,
          "lng": -69.943
        },
        {
          "name": "Medellin",
          "fullName": "Medellin",
          "path": [
            "Colombia",
            "Medellin"
          ],
          "lat": 6.165,
          "lng": -75.423
        }
      ]
    },
    {
      "name": "Costa Rica",
      "children": [
        {
          "name": "Daniel Oduber Quiros",
          "fullName": "Daniel Oduber Quiros",
          "path": [
            "Costa Rica",
            "Daniel Oduber Quiros"
          ],
          "lat": 10.593,
          "lng": -85.544
        },
        {
          "name": "San Jose",
          "fullName": "San Jose",
          "path": [
            "Costa Rica",
            "San Jose"
          ],
          "lat": 9.9892,
          "lng": -84.2183
        }
      ]
    },
    {
      "name": "Ecuador",
      "children": [
        {
          "name": "Guayaquil",
          "fullName": "Guayaquil",
          "path": [
            "Ecuador",
            "Guayaquil"
          ],
          "lat": -2.157,
          "lng": -79.884
        },
        {
          "name": "Latacunga",
          "fullName": "Latacunga",
          "path": [
            "Ecuador",
            "Latacunga"
          ],
          "lat": -0.907,
          "lng": -78.616
        },
        {
          "name": "Manta",
          "fullName": "Manta",
          "path": [
            "Ecuador",
            "Manta"
          ],
          "lat": -0.95,
          "lng": -80.683
        },
        {
          "name": "Quito",
          "fullName": "Quito",
          "path": [
            "Ecuador",
            "Quito"
          ],
          "lat": -0.141,
          "lng": -78.488
        }
      ]
    },
    {
      "name": "Egypt",
      "children": [
        {
          "name": "Abu Simbel",
          "fullName": "Abu Simbel",
          "path": [
            "Egypt",
            "Abu Simbel"
          ],
          "lat": 22.376,
          "lng": 31.612
        },
        {
          "name": "Alexandria",
          "fullName": "Alexandria",
          "path": [
            "Egypt",
            "Alexandria"
          ],
          "lat": 31.184,
          "lng": 29.949
        },
        {
          "name": "Arish",
          "fullName": "Arish",
          "path": [
            "Egypt",
            "Arish"
          ],
          "lat": 31.073,
          "lng": 33.836
        },
        {
          "name": "Assiut",
          "fullName": "Assiut",
          "path": [
            "Egypt",
            "Assiut"
          ],
          "lat": 27.047,
          "lng": 31.012
        },
        {
          "name": "Aswan",
          "fullName": "Aswan",
          "path": [
            "Egypt",
            "Aswan"
          ],
          "lat": 23.964,
          "lng": 32.82
        },
        {
          "name": "Cairo",
          "fullName": "Cairo",
          "path": [
            "Egypt",
            "Cairo"
          ],
          "lat": 30.122,
          "lng": 31.406
        },
        {
          "name": "Farafra",
          "fullName": "Farafra",
          "path": [
            "Egypt",
            "Farafra"
          ],
          "lat": 27.0583,
          "lng": 27.9892
        },
        {
          "name": "Kosseir",
          "fullName": "Kosseir",
          "path": [
            "Egypt",
            "Kosseir"
          ],
          "lat": 26.1356,
          "lng": 34.2583
        },
        {
          "name": "Luxor",
          "fullName": "Luxor",
          "path": [
            "Egypt",
            "Luxor"
          ],
          "lat": 25.671,
          "lng": 32.707
        },
        {
          "name": "Mersa Matruh",
          "fullName": "Mersa Matruh",
          "path": [
            "Egypt",
            "Mersa Matruh"
          ],
          "lat": 31.325,
          "lng": 27.222
        },
        {
          "name": "Minya",
          "fullName": "Minya",
          "path": [
            "Egypt",
            "Minya"
          ],
          "lat": 28.083,
          "lng": 30.733
        },
        {
          "name": "Mut City",
          "fullName": "Mut City",
          "path": [
            "Egypt",
            "Mut City"
          ],
          "lat": 25.5028,
          "lng": 28.9725
        },
        {
          "name": "Port Said",
          "fullName": "Port Said",
          "path": [
            "Egypt",
            "Port Said"
          ],
          "lat": 31.281,
          "lng": 32.244
        },
        {
          "name": "Sallum",
          "fullName": "Sallum",
          "path": [
            "Egypt",
            "Sallum"
          ],
          "lat": 31.57,
          "lng": 25.132
        },
        {
          "name": "Taba",
          "fullName": "Taba",
          "path": [
            "Egypt",
            "Taba"
          ],
          "lat": 29.5994,
          "lng": 34.7747
        },
        {
          "name": "Tor",
          "fullName": "Tor",
          "path": [
            "Egypt",
            "Tor"
          ],
          "lat": 28.209,
          "lng": 33.646
        }
      ]
    },
    {
      "name": "Ethiopia",
      "children": [
        {
          "name": "Addis Ababa",
          "fullName": "Addis Ababa",
          "path": [
            "Ethiopia",
            "Addis Ababa"
          ],
          "lat": 8.978,
          "lng": 38.799
        },
        {
          "name": "Bahir Dar",
          "fullName": "Bahir Dar",
          "path": [
            "Ethiopia",
            "Bahir Dar"
          ],
          "lat": 11.6,
          "lng": 37.4
        },
        {
          "name": "Mekele",
          "fullName": "Mekele",
          "path": [
            "Ethiopia",
            "Mekele"
          ],
          "lat": 13.5,
          "lng": 39.5
        }
      ]
    },
    {
      "name": "Fiji",
      "children": [
        {
          "name": "Nabouwalu",
          "fullName": "Nabouwalu",
          "path": [
            "Fiji",
            "Nabouwalu"
          ],
          "lat": -17.0,
          "lng": 178.7
        },
        {
          "name": "Nadi",
          "fullName": "Nadi",
          "path": [
            "Fiji",
            "Nadi"
          ],
          "lat": -17.755,
          "lng": 177.443
        },
        {
          "name": "Suva",
          "fullName": "Suva",
          "path": [
            "Fiji",
            "Suva"
          ],
          "lat": -18.043,
          "lng": 178.559
        }
      ]
    },
    {
      "name": "France",
      "children": [
        {
          "name": "Bordeaux",
          "fullName": "Bordeaux",
          "path": [
            "France",
            "Bordeaux"
          ],
          "lat": 44.8308,
          "lng": -0.6914
        },
        {
          "name": "Bourges",
          "fullName": "Bourges",
          "path": [
            "France",
            "Bourges"
          ],
          "lat": 47.0592,
          "lng": 2.3597
        },
        {
          "name": "Dunkerque",
          "fullName": "Dunkerque",
          "path": [
            "France",
            "Dunkerque"
          ],
          "lat": 51.0558,
          "lng": 2.3394
        },
        {
          "name": "Lorient",
          "fullName": "Lorient",
          "path": [
            "France",
            "Lorient"
          ],
          "lat": 47.7628,
          "lng": -3.4356
        },
        {
          "name": "Lyon",
          "fullName": "Lyon",
          "path": [
            "France",
            "Lyon"
          ],
          "lat": 45.7261,
          "lng": 4.9378
        },
        {
          "name": "Montpellier",
          "fullName": "Montpellier",
          "path": [
            "France",
            "Montpellier"
          ],
          "lat": 43.5769,
          "lng": 3.9631
        },
        {
          "name": "Nice",
          "fullName": "Nice",
          "path": [
            "France",
            "Nice"
          ],
          "lat": 43.6489,
          "lng": 7.2089
        },
        {
          "name": "Paris",
          "fullName": "Paris",
          "path": [
            "France",
            "Paris"
          ],
          "lat": 48.8217,
          "lng": 2.3378
        },
        {
          "name": "Rennes",
          "fullName": "Rennes",
          "path": [
            "France",
            "Rennes"
          ],
          "lat": 48.0689,
          "lng": -1.7339
        },
        {
          "name": "Saint-Malo",
          "fullName": "Saint-Malo",
          "path": [
            "France",
            "Saint-Malo"
          ],
          "lat": 48.5849,
          "lng": -2.0764
        },
        {
          "name": "Strasborg",
          "fullName": "Strasborg",
          "path": [
            "France",
            "Strasborg"
          ],
          "lat": 48.5494,
          "lng": 7.6403
        },
        {
          "name": "Toulouse",
          "fullName": "Toulouse",
          "path": [
            "France",
            "Toulouse"
          ],
          "lat": 43.6211,
          "lng": 1.3789
        }
      ]
    },
    {
      "name": "Germany",
      "children": [
        {
          "name": "Berlin",
          "fullName": "Berlin",
          "path": [
            "Germany",
            "Berlin"
          ],
          "lat": 52.5198,
          "lng": 13.4057
        },
        {
          "name": "Bremen",
          "fullName": "Bremen",
          "path": [
            "Germany",
            "Bremen"
          ],
          "lat": 53.0451,
          "lng": 8.7981
        },
        {
          "name": "Dresden",
          "fullName": "Dresden",
          "path": [
            "Germany",
            "Dresden"
          ],
          "lat": 51.0249,
          "lng": 13.7751
        },
        {
          "name": "Essen",
          "fullName": "Essen",
          "path": [
            "Germany",
            "Essen"
          ],
          "lat": 51.4041,
          "lng": 6.9677
        },
        {
          "name": "Gottingen",
          "fullName": "Gottingen",
          "path": [
            "Germany",
            "Gottingen"
          ],
          "lat": 51.5002,
          "lng": 9.9507
        },
        {
          "name": "Hamburg",
          "fullName": "Hamburg",
          "path": [
            "Germany",
            "Hamburg"
          ],
          "lat": 53.6332,
          "lng": 9.9881
        },
        {
          "name": "Koblenz",
          "fullName": "Koblenz",
          "path": [
            "Germany",
            "Koblenz"
          ],
          "lat": 50.3713,
          "lng": 7.5791
        },
        {
          "name": "Mannheim",
          "fullName": "Mannheim",
          "path": [
            "Germany",
            "Mannheim"
          ],
          "lat": 49.5063,
          "lng": 8.5584
        },
        {
          "name": "Memmingen",
          "fullName": "Memmingen",
          "path": [
            "Germany",
            "Memmingen"
          ],
          "lat": 47.989,
          "lng": 10.24
        },
        {
          "name": "Munich",
          "fullName": "Munich",
          "path": [
            "Germany",
            "Munich"
          ],
          "lat": 48.1632,
          "lng": 11.5429
        },
        {
          "name": "Nuremberg",
          "fullName": "Nuremberg",
          "path": [
            "Germany",
            "Nuremberg"
          ],
          "lat": 49.503,
          "lng": 11.0549
        },
        {
          "name": "Osnabrueck",
          "fullName": "Osnabrueck",
          "path": [
            "Germany",
            "Osnabrueck"
          ],
          "lat": 52.255,
          "lng": 8.053
        },
        {
          "name": "Passau",
          "fullName": "Passau",
          "path": [
            "Germany",
            "Passau"
          ],
          "lat": 48.578,
          "lng": 13.469
        },
        {
          "name": "Schleswig",
          "fullName": "Schleswig",
          "path": [
            "Germany",
            "Schleswig"
          ],
          "lat": 54.5275,
          "lng": 9.5487
        },
        {
          "name": "Stuttgart",
          "fullName": "Stuttgart",
          "path": [
            "Germany",
            "Stuttgart"
          ],
          "lat": 48.79,
          "lng": 9.217
        },
        {
          "name": "Ulm",
          "fullName": "Ulm",
          "path": [
            "Germany",
            "Ulm"
          ],
          "lat": 48.3837,
          "lng": 9.9524
        },
        {
          "name": "Wuerzberg",
          "fullName": "Wuerzberg",
          "path": [
            "Germany",
            "Wuerzberg"
          ],
          "lat": 49.7704,
          "lng": 9.9576
        }
      ]
    },
    {
      "name": "Greece",
      "children": [
        {
          "name": "Alexandroupoli",
          "fullName": "Alexandroupoli",
          "path": [
            "Greece",
            "Alexandroupoli"
          ],
          "lat": 40.856,
          "lng": 25.956
        },
        {
          "name": "Athens",
          "fullName": "Athens",
          "path": [
            "Greece",
            "Athens"
          ],
          "lat": 37.8897,
          "lng": 23.7417
        },
        {
          "name": "Chios",
          "fullName": "Chios",
          "path": [
            "Greece",
            "Chios"
          ],
          "lat": 38.3453,
          "lng": 26.1419
        },
        {
          "name": "Florina",
          "fullName": "Florina",
          "path": [
            "Greece",
            "Florina"
          ],
          "lat": 40.8047,
          "lng": 21.4281
        },
        {
          "name": "Heraklion",
          "fullName": "Heraklion",
          "path": [
            "Greece",
            "Heraklion"
          ],
          "lat": 35.34,
          "lng": 25.18
        },
        {
          "name": "Ioannina",
          "fullName": "Ioannina",
          "path": [
            "Greece",
            "Ioannina"
          ],
          "lat": 39.695,
          "lng": 20.819
        },
        {
          "name": "Larissa",
          "fullName": "Larissa",
          "path": [
            "Greece",
            "Larissa"
          ],
          "lat": 39.65,
          "lng": 22.466
        },
        {
          "name": "Serrai",
          "fullName": "Serrai",
          "path": [
            "Greece",
            "Serrai"
          ],
          "lat": 41.067,
          "lng": 23.567
        },
        {
          "name": "Syros",
          "fullName": "Syros",
          "path": [
            "Greece",
            "Syros"
          ],
          "lat": 37.423,
          "lng": 24.951
        },
        {
          "name": "Thessaloniki",
          "fullName": "Thessaloniki",
          "path": [
            "Greece",
            "Thessaloniki"
          ],
          "lat": 40.52,
          "lng": 22.971
        },
        {
          "name": "Tripolis",
          "fullName": "Tripolis",
          "path": [
            "Greece",
            "Tripolis"
          ],
          "lat": 37.525,
          "lng": 22.397
        }
      ]
    },
    {
      "name": "Guatemala",
      "children": [
        {
          "name": "Guatemala City",
          "fullName": "Guatemala City",
          "path": [
            "Guatemala",
            "Guatemala City"
          ],
          "lat": 14.583,
          "lng": -90.527
        },
        {
          "name": "Huehuetenango",
          "fullName": "Huehuetenango",
          "path": [
            "Guatemala",
            "Huehuetenango"
          ],
          "lat": 15.317,
          "lng": -91.467
        },
        {
          "name": "Puerto Barrios",
          "fullName": "Puerto Barrios",
          "path": [
            "Guatemala",
            "Puerto Barrios"
          ],
          "lat": 15.731,
          "lng": -88.584
        },
        {
          "name": "San Jose",
          "fullName": "San Jose",
          "path": [
            "Guatemala",
            "San Jose"
          ],
          "lat": 13.936,
          "lng": -90.836
        }
      ]
    },
    {
      "name": "India",
      "children": [
        {
          "name": "Bengaluru",
          "fullName": "Bengaluru",
          "path": [
            "India",
            "Bengaluru"
          ],
          "lat": 12.967,
          "lng": 77.583
        },
        {
          "name": "Kolkata",
          "fullName": "Kolkata",
          "path": [
            "India",
            "Kolkata"
          ],
          "lat": 22.6507,
          "lng": 88.4379
        },
        {
          "name": "Mumbai",
          "fullName": "Mumbai",
          "path": [
            "India",
            "Mumbai"
          ],
          "lat": 19.089,
          "lng": 72.868
        },
        {
          "name": "New Delhi",
          "fullName": "New Delhi",
          "path": [
            "India",
            "New Delhi"
          ],
          "lat": 28.5886,
          "lng": 77.2222
        },
        {
          "name": "Pondicherry",
          "fullName": "Pondicherry",
          "path": [
            "India",
            "Pondicherry"
          ],
          "lat": 11.967,
          "lng": 79.817
        },
        {
          "name": "Srinagar",
          "fullName": "Srinagar",
          "path": [
            "India",
            "Srinagar"
          ],
          "lat": 34.0508,
          "lng": 74.8045
        }
      ]
    },
    {
      "name": "Indonesia",
      "children": [
        {
          "name": "Ambon",
          "fullName": "Ambon",
          "path": [
            "Indonesia",
            "Ambon"
          ],
          "lat": -3.7111,
          "lng": 128.0853
        },
        {
          "name": "Balikpapan",
          "fullName": "Balikpapan",
          "path": [
            "Indonesia",
            "Balikpapan"
          ],
          "lat": -1.2625,
          "lng": 116.8947
        },
        {
          "name": "Banda Aceh",
          "fullName": "Banda Aceh",
          "path": [
            "Indonesia",
            "Banda Aceh"
          ],
          "lat": 5.5225,
          "lng": 95.4169
        },
        {
          "name": "Bandar Lampung",
          "fullName": "Bandar Lampung",
          "path": [
            "Indonesia",
            "Bandar Lampung"
          ],
          "lat": -5.2397,
          "lng": 105.1745
        },
        {
          "name": "Bandung",
          "fullName": "Bandung",
          "path": [
            "Indonesia",
            "Bandung"
          ],
          "lat": -6.901,
          "lng": 107.576
        },
        {
          "name": "Banjarmasin",
          "fullName": "Banjarmasin",
          "path": [
            "Indonesia",
            "Banjarmasin"
          ],
          "lat": -3.4388,
          "lng": 114.7525
        },
        {
          "name": "Bau-Bau",
          "fullName": "Bau-Bau",
          "path": [
            "Indonesia",
            "Bau-Bau"
          ],
          "lat": -5.4878,
          "lng": 122.5708
        },
        {
          "name": "Bima",
          "fullName": "Bima",
          "path": [
            "Indonesia",
            "Bima"
          ],
          "lat": -8.5428,
          "lng": 118.693
        },
        {
          "name": "Denpasar",
          "fullName": "Denpasar",
          "path": [
            "Indonesia",
            "Denpasar"
          ],
          "lat": -8.7494,
          "lng": 115.177
        },
        {
          "name": "Jakarta",
          "fullName": "Jakarta",
          "path": [
            "Indonesia",
            "Jakarta"
          ],
          "lat": -6.156,
          "lng": 106.8424
        },
        {
          "name": "Jayapura",
          "fullName": "Jayapura",
          "path": [
            "Indonesia",
            "Jayapura"
          ],
          "lat": -2.576,
          "lng": 140.5183
        },
        {
          "name": "Kupang",
          "fullName": "Kupang",
          "path": [
            "Indonesia",
            "Kupang"
          ],
          "lat": -10.1677,
          "lng": 123.6704
        },
        {
          "name": "Makassar",
          "fullName": "Makassar",
          "path": [
            "Indonesia",
            "Makassar"
          ],
          "lat": -5.1103,
          "lng": 119.4197
        },
        {
          "name": "Manado",
          "fullName": "Manado",
          "path": [
            "Indonesia",
            "Manado"
          ],
          "lat": 1.5458,
          "lng": 124.923
        },
        {
          "name": "Medan",
          "fullName": "Medan",
          "path": [
            "Indonesia",
            "Medan"
          ],
          "lat": 3.7883,
          "lng": 98.7147
        },
        {
          "name": "Mimika Baru",
          "fullName": "Mimika Baru",
          "path": [
            "Indonesia",
            "Mimika Baru"
          ],
          "lat": -4.5297,
          "lng": 136.8925
        },
        {
          "name": "Padang",
          "fullName": "Padang",
          "path": [
            "Indonesia",
            "Padang"
          ],
          "lat": -0.7936,
          "lng": 100.2892
        },
        {
          "name": "Palu",
          "fullName": "Palu",
          "path": [
            "Indonesia",
            "Palu"
          ],
          "lat": -0.9159,
          "lng": 119.9053
        },
        {
          "name": "Pangkal Pinang",
          "fullName": "Pangkal Pinang",
          "path": [
            "Indonesia",
            "Pangkal Pinang"
          ],
          "lat": -2.1631,
          "lng": 106.137
        },
        {
          "name": "Pontianak",
          "fullName": "Pontianak",
          "path": [
            "Indonesia",
            "Pontianak"
          ],
          "lat": -0.1421,
          "lng": 109.4025
        },
        {
          "name": "Praya Lombok",
          "fullName": "Praya Lombok",
          "path": [
            "Indonesia",
            "Praya Lombok"
          ],
          "lat": -8.7658,
          "lng": 116.2791
        },
        {
          "name": "Semarang",
          "fullName": "Semarang",
          "path": [
            "Indonesia",
            "Semarang"
          ],
          "lat": -6.9508,
          "lng": 110.4183
        },
        {
          "name": "Sorong",
          "fullName": "Sorong",
          "path": [
            "Indonesia",
            "Sorong"
          ],
          "lat": -0.8911,
          "lng": 131.2858
        },
        {
          "name": "Surabaya",
          "fullName": "Surabaya",
          "path": [
            "Indonesia",
            "Surabaya"
          ],
          "lat": -7.2236,
          "lng": 112.7239
        },
        {
          "name": "Tegal",
          "fullName": "Tegal",
          "path": [
            "Indonesia",
            "Tegal"
          ],
          "lat": -6.8681,
          "lng": 109.121
        }
      ]
    },
    {
      "name": "Iraq",
      "children": [
        {
          "name": "Baghdad",
          "fullName": "Baghdad",
          "path": [
            "Iraq",
            "Baghdad"
          ],
          "lat": 33.2728,
          "lng": 44.2716
        },
        {
          "name": "Basrah",
          "fullName": "Basrah",
          "path": [
            "Iraq",
            "Basrah"
          ],
          "lat": 30.549,
          "lng": 47.662
        },
        {
          "name": "Kirkuk",
          "fullName": "Kirkuk",
          "path": [
            "Iraq",
            "Kirkuk"
          ],
          "lat": 35.469,
          "lng": 44.349
        },
        {
          "name": "Mosul",
          "fullName": "Mosul",
          "path": [
            "Iraq",
            "Mosul"
          ],
          "lat": 36.306,
          "lng": 43.147
        },
        {
          "name": "Najaf",
          "fullName": "Najaf",
          "path": [
            "Iraq",
            "Najaf"
          ],
          "lat": 31.95,
          "lng": 44.317
        },
        {
          "name": "Nasiriya",
          "fullName": "Nasiriya",
          "path": [
            "Iraq",
            "Nasiriya"
          ],
          "lat": 31.017,
          "lng": 46.233
        },
        {
          "name": "Sulaymaniyah",
          "fullName": "Sulaymaniyah",
          "path": [
            "Iraq",
            "Sulaymaniyah"
          ],
          "lat": 35.55,
          "lng": 45.45
        }
      ]
    },
    {
      "name": "Italy",
      "children": [
        {
          "name": "Bari",
          "fullName": "Bari",
          "path": [
            "Italy",
            "Bari"
          ],
          "lat": 41.121,
          "lng": 16.884
        },
        {
          "name": "Brindisi",
          "fullName": "Brindisi",
          "path": [
            "Italy",
            "Brindisi"
          ],
          "lat": 40.6578,
          "lng": 17.9517
        },
        {
          "name": "Cagliari",
          "fullName": "Cagliari",
          "path": [
            "Italy",
            "Cagliari"
          ],
          "lat": 39.244,
          "lng": 9.06
        },
        {
          "name": "Catania",
          "fullName": "Catania",
          "path": [
            "Italy",
            "Catania"
          ],
          "lat": 37.467,
          "lng": 15.066
        },
        {
          "name": "Florence",
          "fullName": "Florence",
          "path": [
            "Italy",
            "Florence"
          ],
          "lat": 43.786,
          "lng": 11.216
        },
        {
          "name": "Imperia",
          "fullName": "Imperia",
          "path": [
            "Italy",
            "Imperia"
          ],
          "lat": 43.884,
          "lng": 8.029
        },
        {
          "name": "Milan",
          "fullName": "Milan",
          "path": [
            "Italy",
            "Milan"
          ],
          "lat": 45.445,
          "lng": 9.277
        },
        {
          "name": "Naples",
          "fullName": "Naples",
          "path": [
            "Italy",
            "Naples"
          ],
          "lat": 40.884,
          "lng": 14.291
        },
        {
          "name": "Reggio di Calabria",
          "fullName": "Reggio di Calabria",
          "path": [
            "Italy",
            "Reggio di Calabria"
          ],
          "lat": 38.071,
          "lng": 15.652
        },
        {
          "name": "Rimini",
          "fullName": "Rimini",
          "path": [
            "Italy",
            "Rimini"
          ],
          "lat": 44.0244,
          "lng": 12.6128
        },
        {
          "name": "Rome",
          "fullName": "Rome",
          "path": [
            "Italy",
            "Rome"
          ],
          "lat": 41.952,
          "lng": 12.501
        },
        {
          "name": "Termoli",
          "fullName": "Termoli",
          "path": [
            "Italy",
            "Termoli"
          ],
          "lat": 42.004,
          "lng": 14.996
        },
        {
          "name": "Trapani",
          "fullName": "Trapani",
          "path": [
            "Italy",
            "Trapani"
          ],
          "lat": 37.911,
          "lng": 12.488
        },
        {
          "name": "Turin",
          "fullName": "Turin",
          "path": [
            "Italy",
            "Turin"
          ],
          "lat": 45.034,
          "lng": 7.733
        },
        {
          "name": "Venice",
          "fullName": "Venice",
          "path": [
            "Italy",
            "Venice"
          ],
          "lat": 45.505,
          "lng": 12.352
        }
      ]
    },
    {
      "name": "Jamaica",
      "children": [
        {
          "name": "Kingston",
          "fullName": "Kingston",
          "path": [
            "Jamaica",
            "Kingston"
          ],
          "lat": 17.936,
          "lng": -76.788
        },
        {
          "name": "Montego Bay",
          "fullName": "Montego Bay",
          "path": [
            "Jamaica",
            "Montego Bay"
          ],
          "lat": 18.504,
          "lng": -77.913
        }
      ]
    },
    {
      "name": "Kuwait",
      "children": [
        {
          "name": "Abdali",
          "fullName": "Abdali",
          "path": [
            "Kuwait",
            "Abdali"
          ],
          "lat": 30.067,
          "lng": 47.683
        },
        {
          "name": "Kuwait City",
          "fullName": "Kuwait City",
          "path": [
            "Kuwait",
            "Kuwait City"
          ],
          "lat": 29.3,
          "lng": 47.933
        },
        {
          "name": "Salmi",
          "fullName": "Salmi",
          "path": [
            "Kuwait",
            "Salmi"
          ],
          "lat": 29.1,
          "lng": 46.683
        },
        {
          "name": "Wafra",
          "fullName": "Wafra",
          "path": [
            "Kuwait",
            "Wafra"
          ],
          "lat": 28.567,
          "lng": 48.067
        }
      ]
    },
    {
      "name": "Libya",
      "children": [
        {
          "name": "Al-Jawf",
          "fullName": "Al-Jawf",
          "path": [
            "Libya",
            "Al-Jawf"
          ],
          "lat": 24.1986,
          "lng": 23.3
        },
        {
          "name": "Benghazi",
          "fullName": "Benghazi",
          "path": [
            "Libya",
            "Benghazi"
          ],
          "lat": 32.097,
          "lng": 20.269
        },
        {
          "name": "Ghadamis",
          "fullName": "Ghadamis",
          "path": [
            "Libya",
            "Ghadamis"
          ],
          "lat": 30.152,
          "lng": 9.715
        },
        {
          "name": "Jalu",
          "fullName": "Jalu",
          "path": [
            "Libya",
            "Jalu"
          ],
          "lat": 29.0275,
          "lng": 21.5458
        },
        {
          "name": "Misratah",
          "fullName": "Misratah",
          "path": [
            "Libya",
            "Misratah"
          ],
          "lat": 32.325,
          "lng": 15.059
        },
        {
          "name": "Nalut",
          "fullName": "Nalut",
          "path": [
            "Libya",
            "Nalut"
          ],
          "lat": 31.867,
          "lng": 10.983
        },
        {
          "name": "Sabha",
          "fullName": "Sabha",
          "path": [
            "Libya",
            "Sabha"
          ],
          "lat": 26.987,
          "lng": 14.473
        },
        {
          "name": "Tripoli",
          "fullName": "Tripoli",
          "path": [
            "Libya",
            "Tripoli"
          ],
          "lat": 32.664,
          "lng": 13.159
        },
        {
          "name": "Waddan",
          "fullName": "Waddan",
          "path": [
            "Libya",
            "Waddan"
          ],
          "lat": 29.1343,
          "lng": 15.9353
        }
      ]
    },
    {
      "name": "Malaysia",
      "children": [
        {
          "name": "Butterworth",
          "fullName": "Butterworth",
          "path": [
            "Malaysia",
            "Butterworth"
          ],
          "lat": 5.467,
          "lng": 100.383
        },
        {
          "name": "Kota Bharu",
          "fullName": "Kota Bharu",
          "path": [
            "Malaysia",
            "Kota Bharu"
          ],
          "lat": 6.1638,
          "lng": 102.301
        },
        {
          "name": "Kuala Lumpur",
          "fullName": "Kuala Lumpur",
          "path": [
            "Malaysia",
            "Kuala Lumpur"
          ],
          "lat": 3.1307,
          "lng": 101.553
        },
        {
          "name": "Malacca",
          "fullName": "Malacca",
          "path": [
            "Malaysia",
            "Malacca"
          ],
          "lat": 2.2551,
          "lng": 102.244
        },
        {
          "name": "Mersing",
          "fullName": "Mersing",
          "path": [
            "Malaysia",
            "Mersing"
          ],
          "lat": 2.445,
          "lng": 103.831
        },
        {
          "name": "Pahang",
          "fullName": "Pahang",
          "path": [
            "Malaysia",
            "Pahang"
          ],
          "lat": 3.7727,
          "lng": 103.212
        },
        {
          "name": "Senai",
          "fullName": "Senai",
          "path": [
            "Malaysia",
            "Senai"
          ],
          "lat": 1.6384,
          "lng": 103.666
        }
      ]
    },
    {
      "name": "Malta",
      "children": [
        {
          "name": "Valletta",
          "fullName": "Valletta",
          "path": [
            "Malta",
            "Valletta"
          ],
          "lat": 35.857,
          "lng": 14.478
        }
      ]
    },
    {
      "name": "Mauritius",
      "children": [
        {
          "name": "Agalega",
          "fullName": "Agalega",
          "path": [
            "Mauritius",
            "Agalega"
          ],
          "lat": -10.38,
          "lng": 56.61
        },
        {
          "name": "Port Louis",
          "fullName": "Port Louis",
          "path": [
            "Mauritius",
            "Port Louis"
          ],
          "lat": -20.2971,
          "lng": 57.4969
        },
        {
          "name": "Rodrigues",
          "fullName": "Rodrigues",
          "path": [
            "Mauritius",
            "Rodrigues"
          ],
          "lat": -19.6811,
          "lng": 63.4264
        },
        {
          "name": "Saint Brandon",
          "fullName": "Saint Brandon",
          "path": [
            "Mauritius",
            "Saint Brandon"
          ],
          "lat": -16.433,
          "lng": 59.605
        },
        {
          "name": "Saint-Denis",
          "fullName": "Saint-Denis",
          "path": [
            "Mauritius",
            "Saint-Denis"
          ],
          "lat": -20.892,
          "lng": 55.529
        }
      ]
    },
    {
      "name": "Mexico",
      "children": [
        {
          "name": "Chihuahua",
          "fullName": "Chihuahua",
          "path": [
            "Mexico",
            "Chihuahua"
          ],
          "lat": 28.703,
          "lng": -105.965
        },
        {
          "name": "Coatzacoalcos",
          "fullName": "Coatzacoalcos",
          "path": [
            "Mexico",
            "Coatzacoalcos"
          ],
          "lat": 18.1403,
          "lng": -94.5108
        },
        {
          "name": "Guadalajara",
          "fullName": "Guadalajara",
          "path": [
            "Mexico",
            "Guadalajara"
          ],
          "lat": 20.522,
          "lng": -103.311
        },
        {
          "name": "Guayamas",
          "fullName": "Guayamas",
          "path": [
            "Mexico",
            "Guayamas"
          ],
          "lat": 27.9575,
          "lng": -110.7973
        },
        {
          "name": "La Paz",
          "fullName": "La Paz",
          "path": [
            "Mexico",
            "La Paz"
          ],
          "lat": 24.129,
          "lng": -110.321
        },
        {
          "name": "Matamoros",
          "fullName": "Matamoros",
          "path": [
            "Mexico",
            "Matamoros"
          ],
          "lat": 25.77,
          "lng": -97.525
        },
        {
          "name": "Mazatlan",
          "fullName": "Mazatlan",
          "path": [
            "Mexico",
            "Mazatlan"
          ],
          "lat": 23.2172,
          "lng": -106.4111
        },
        {
          "name": "Mexicali",
          "fullName": "Mexicali",
          "path": [
            "Mexico",
            "Mexicali"
          ],
          "lat": 32.631,
          "lng": -115.242
        },
        {
          "name": "Mexico City",
          "fullName": "Mexico City",
          "path": [
            "Mexico",
            "Mexico City"
          ],
          "lat": 19.436,
          "lng": -99.072
        },
        {
          "name": "Monterrey",
          "fullName": "Monterrey",
          "path": [
            "Mexico",
            "Monterrey"
          ],
          "lat": 25.6825,
          "lng": -100.2717
        },
        {
          "name": "Puerto Vallarta",
          "fullName": "Puerto Vallarta",
          "path": [
            "Mexico",
            "Puerto Vallarta"
          ],
          "lat": 20.68,
          "lng": -105.254
        },
        {
          "name": "Tampico",
          "fullName": "Tampico",
          "path": [
            "Mexico",
            "Tampico"
          ],
          "lat": 22.296,
          "lng": -97.866
        },
        {
          "name": "Tapachula",
          "fullName": "Tapachula",
          "path": [
            "Mexico",
            "Tapachula"
          ],
          "lat": 14.8872,
          "lng": -92.2964
        },
        {
          "name": "Tijuana",
          "fullName": "Tijuana",
          "path": [
            "Mexico",
            "Tijuana"
          ],
          "lat": 32.541,
          "lng": -116.97
        },
        {
          "name": "Tuxtla Gutierrez",
          "fullName": "Tuxtla Gutierrez",
          "path": [
            "Mexico",
            "Tuxtla Gutierrez"
          ],
          "lat": 16.7631,
          "lng": -93.1475
        },
        {
          "name": "Veracruz",
          "fullName": "Veracruz",
          "path": [
            "Mexico",
            "Veracruz"
          ],
          "lat": 19.146,
          "lng": -96.187
        },
        {
          "name": "Zacatecas",
          "fullName": "Zacatecas",
          "path": [
            "Mexico",
            "Zacatecas"
          ],
          "lat": 22.7789,
          "lng": -102.5669
        }
      ]
    },
    {
      "name": "New Zealand",
      "children": [
        {
          "name": "Auckland",
          "fullName": "Auckland",
          "path": [
            "New Zealand",
            "Auckland"
          ],
          "lat": -37.0089,
          "lng": 174.8072
        },
        {
          "name": "Christchurch",
          "fullName": "Christchurch",
          "path": [
            "New Zealand",
            "Christchurch"
          ],
          "lat": -43.4897,
          "lng": 172.5269
        },
        {
          "name": "Dunedin",
          "fullName": "Dunedin",
          "path": [
            "New Zealand",
            "Dunedin"
          ],
          "lat": -45.9267,
          "lng": 170.1967
        },
        {
          "name": "Gisborne",
          "fullName": "Gisborne",
          "path": [
            "New Zealand",
            "Gisborne"
          ],
          "lat": -38.6586,
          "lng": 177.985
        },
        {
          "name": "Invercargill",
          "fullName": "Invercargill",
          "path": [
            "New Zealand",
            "Invercargill"
          ],
          "lat": -46.4108,
          "lng": 168.3178
        },
        {
          "name": "Kaitaia",
          "fullName": "Kaitaia",
          "path": [
            "New Zealand",
            "Kaitaia"
          ],
          "lat": -35.1328,
          "lng": 173.2639
        },
        {
          "name": "Napier",
          "fullName": "Napier",
          "path": [
            "New Zealand",
            "Napier"
          ],
          "lat": -39.4703,
          "lng": 176.8644
        },
        {
          "name": "New Plymouth",
          "fullName": "New Plymouth",
          "path": [
            "New Zealand",
            "New Plymouth"
          ],
          "lat": -39.0078,
          "lng": 174.1836
        },
        {
          "name": "Palmerston North",
          "fullName": "Palmerston North",
          "path": [
            "New Zealand",
            "Palmerston North"
          ],
          "lat": -40.323,
          "lng": 175.612
        },
        {
          "name": "Queenstown",
          "fullName": "Queenstown",
          "path": [
            "New Zealand",
            "Queenstown"
          ],
          "lat": -45.0175,
          "lng": 168.74
        },
        {
          "name": "Timaru",
          "fullName": "Timaru",
          "path": [
            "New Zealand",
            "Timaru"
          ],
          "lat": -44.305,
          "lng": 171.2214
        },
        {
          "name": "Wellington",
          "fullName": "Wellington",
          "path": [
            "New Zealand",
            "Wellington"
          ],
          "lat": -41.3311,
          "lng": 174.806
        },
        {
          "name": "Westport",
          "fullName": "Westport",
          "path": [
            "New Zealand",
            "Westport"
          ],
          "lat": -41.7406,
          "lng": 171.5797
        }
      ]
    },
    {
      "name": "Pakistan",
      "children": [
        {
          "name": "Bahawalpur",
          "fullName": "Bahawalpur",
          "path": [
            "Pakistan",
            "Bahawalpur"
          ],
          "lat": 29.4,
          "lng": 71.783
        },
        {
          "name": "Dera Ismail Khan",
          "fullName": "Dera Ismail Khan",
          "path": [
            "Pakistan",
            "Dera Ismail Khan"
          ],
          "lat": 31.909,
          "lng": 70.897
        },
        {
          "name": "Faisalabad",
          "fullName": "Faisalabad",
          "path": [
            "Pakistan",
            "Faisalabad"
          ],
          "lat": 31.433,
          "lng": 73.1
        },
        {
          "name": "Hyderabad",
          "fullName": "Hyderabad",
          "path": [
            "Pakistan",
            "Hyderabad"
          ],
          "lat": 25.383,
          "lng": 68.417
        },
        {
          "name": "Islamabad",
          "fullName": "Islamabad",
          "path": [
            "Pakistan",
            "Islamabad"
          ],
          "lat": 33.617,
          "lng": 73.099
        },
        {
          "name": "Karachi",
          "fullName": "Karachi",
          "path": [
            "Pakistan",
            "Karachi"
          ],
          "lat": 24.907,
          "lng": 67.161
        },
        {
          "name": "Lahore",
          "fullName": "Lahore",
          "path": [
            "Pakistan",
            "Lahore"
          ],
          "lat": 31.55,
          "lng": 74.333
        },
        {
          "name": "Multan",
          "fullName": "Multan",
          "path": [
            "Pakistan",
            "Multan"
          ],
          "lat": 30.203,
          "lng": 71.419
        },
        {
          "name": "Peshawar",
          "fullName": "Peshawar",
          "path": [
            "Pakistan",
            "Peshawar"
          ],
          "lat": 34.017,
          "lng": 71.583
        },
        {
          "name": "Quetta",
          "fullName": "Quetta",
          "path": [
            "Pakistan",
            "Quetta"
          ],
          "lat": 30.251,
          "lng": 66.938
        },
        {
          "name": "Sialkot",
          "fullName": "Sialkot",
          "path": [
            "Pakistan",
            "Sialkot"
          ],
          "lat": 32.5,
          "lng": 74.533
        },
        {
          "name": "Sukkur",
          "fullName": "Sukkur",
          "path": [
            "Pakistan",
            "Sukkur"
          ],
          "lat": 27.667,
          "lng": 68.9
        }
      ]
    },
    {
      "name": "Panama",
      "children": [
        {
          "name": "Panama City",
          "fullName": "Panama City",
          "path": [
            "Panama",
            "Panama City"
          ],
          "lat": 8.917,
          "lng": -79.6
        }
      ]
    },
    {
      "name": "Papua New Guinea",
      "children": [
        {
          "name": "Momote",
          "fullName": "Momote",
          "path": [
            "Papua New Guinea",
            "Momote"
          ],
          "lat": -2.062,
          "lng": 147.424
        },
        {
          "name": "Port Moresby",
          "fullName": "Port Moresby",
          "path": [
            "Papua New Guinea",
            "Port Moresby"
          ],
          "lat": -9.443,
          "lng": 147.22
        }
      ]
    },
    {
      "name": "Peru",
      "children": [
        {
          "name": "Chiclayo",
          "fullName": "Chiclayo",
          "path": [
            "Peru",
            "Chiclayo"
          ],
          "lat": -6.787,
          "lng": -79.828
        },
        {
          "name": "Cusco",
          "fullName": "Cusco",
          "path": [
            "Peru",
            "Cusco"
          ],
          "lat": -13.536,
          "lng": -71.939
        },
        {
          "name": "Iquitos",
          "fullName": "Iquitos",
          "path": [
            "Peru",
            "Iquitos"
          ],
          "lat": -3.785,
          "lng": -73.309
        },
        {
          "name": "Lima",
          "fullName": "Lima",
          "path": [
            "Peru",
            "Lima"
          ],
          "lat": -12.022,
          "lng": -77.114
        },
        {
          "name": "Piura",
          "fullName": "Piura",
          "path": [
            "Peru",
            "Piura"
          ],
          "lat": -5.206,
          "lng": -80.616
        },
        {
          "name": "Pucallpa",
          "fullName": "Pucallpa",
          "path": [
            "Peru",
            "Pucallpa"
          ],
          "lat": -8.378,
          "lng": -74.574
        },
        {
          "name": "Tacna",
          "fullName": "Tacna",
          "path": [
            "Peru",
            "Tacna"
          ],
          "lat": -18.053,
          "lng": -70.276
        },
        {
          "name": "Talara",
          "fullName": "Talara",
          "path": [
            "Peru",
            "Talara"
          ],
          "lat": -4.577,
          "lng": -81.254
        },
        {
          "name": "Trujillo",
          "fullName": "Trujillo",
          "path": [
            "Peru",
            "Trujillo"
          ],
          "lat": -8.081,
          "lng": -79.109
        }
      ]
    },
    {
      "name": "Philippines",
      "children": [
        {
          "name": "Angeles City",
          "fullName": "Angeles City",
          "path": [
            "Philippines",
            "Angeles City"
          ],
          "lat": 15.1851,
          "lng": 120.549
        },
        {
          "name": "Cagayan de Oro City",
          "fullName": "Cagayan de Oro City",
          "path": [
            "Philippines",
            "Cagayan de Oro City"
          ],
          "lat": 8.484,
          "lng": 124.647
        },
        {
          "name": "Catbalogan",
          "fullName": "Catbalogan",
          "path": [
            "Philippines",
            "Catbalogan"
          ],
          "lat": 11.7751,
          "lng": 124.8842
        },
        {
          "name": "Cebu City",
          "fullName": "Cebu City",
          "path": [
            "Philippines",
            "Cebu City"
          ],
          "lat": 10.3224,
          "lng": 123.98
        },
        {
          "name": "Dagupan City",
          "fullName": "Dagupan City",
          "path": [
            "Philippines",
            "Dagupan City"
          ],
          "lat": 16.0868,
          "lng": 120.352
        },
        {
          "name": "Davao City",
          "fullName": "Davao City",
          "path": [
            "Philippines",
            "Davao City"
          ],
          "lat": 7.126,
          "lng": 125.646
        },
        {
          "name": "Iloilo City",
          "fullName": "Iloilo City",
          "path": [
            "Philippines",
            "Iloilo City"
          ],
          "lat": 10.7728,
          "lng": 122.5794
        },
        {
          "name": "Laoag City",
          "fullName": "Laoag City",
          "path": [
            "Philippines",
            "Laoag City"
          ],
          "lat": 18.1832,
          "lng": 120.5347
        },
        {
          "name": "Legazpi City",
          "fullName": "Legazpi City",
          "path": [
            "Philippines",
            "Legazpi City"
          ],
          "lat": 13.1508,
          "lng": 123.7283
        },
        {
          "name": "Lucena City",
          "fullName": "Lucena City",
          "path": [
            "Philippines",
            "Lucena City"
          ],
          "lat": 14.0184,
          "lng": 121.5967
        },
        {
          "name": "Manila-Quezon",
          "fullName": "Manila-Quezon",
          "path": [
            "Philippines",
            "Manila-Quezon"
          ],
          "lat": 14.583,
          "lng": 120.983
        },
        {
          "name": "Puerto Princesa",
          "fullName": "Puerto Princesa",
          "path": [
            "Philippines",
            "Puerto Princesa"
          ],
          "lat": 9.7402,
          "lng": 118.759
        },
        {
          "name": "San Jose",
          "fullName": "San Jose",
          "path": [
            "Philippines",
            "San Jose"
          ],
          "lat": 12.3596,
          "lng": 121.0478
        },
        {
          "name": "Surigao City",
          "fullName": "Surigao City",
          "path": [
            "Philippines",
            "Surigao City"
          ],
          "lat": 9.783,
          "lng": 125.489
        },
        {
          "name": "Tuguegarao City",
          "fullName": "Tuguegarao City",
          "path": [
            "Philippines",
            "Tuguegarao City"
          ],
          "lat": 17.6478,
          "lng": 121.7585
        }
      ]
    },
    {
      "name": "Poland",
      "children": [
        {
          "name": "Bialystok",
          "fullName": "Bialystok",
          "path": [
            "Poland",
            "Bialystok"
          ],
          "lat": 53.1073,
          "lng": 23.1623
        },
        {
          "name": "Bydgoszcz",
          "fullName": "Bydgoszcz",
          "path": [
            "Poland",
            "Bydgoszcz"
          ],
          "lat": 53.0964,
          "lng": 17.995
        },
        {
          "name": "Cracow",
          "fullName": "Cracow",
          "path": [
            "Poland",
            "Cracow"
          ],
          "lat": 50.0777,
          "lng": 19.7948
        },
        {
          "name": "Gdansk",
          "fullName": "Gdansk",
          "path": [
            "Poland",
            "Gdansk"
          ],
          "lat": 54.3997,
          "lng": 18.6978
        },
        {
          "name": "Jelenia Gora",
          "fullName": "Jelenia Gora",
          "path": [
            "Poland",
            "Jelenia Gora"
          ],
          "lat": 50.9003,
          "lng": 15.7889
        },
        {
          "name": "Lublin",
          "fullName": "Lublin",
          "path": [
            "Poland",
            "Lublin"
          ],
          "lat": 51.233,
          "lng": 22.683
        },
        {
          "name": "Poznan",
          "fullName": "Poznan",
          "path": [
            "Poland",
            "Poznan"
          ],
          "lat": 52.4167,
          "lng": 16.8347
        },
        {
          "name": "Radom",
          "fullName": "Radom",
          "path": [
            "Poland",
            "Radom"
          ],
          "lat": 51.414,
          "lng": 21.111
        },
        {
          "name": "Szczecin",
          "fullName": "Szczecin",
          "path": [
            "Poland",
            "Szczecin"
          ],
          "lat": 53.3953,
          "lng": 14.6228
        },
        {
          "name": "Warsaw",
          "fullName": "Warsaw",
          "path": [
            "Poland",
            "Warsaw"
          ],
          "lat": 52.1628,
          "lng": 20.9611
        }
      ]
    },
    {
      "name": "Portugal",
      "children": [
        {
          "name": "Braganca",
          "fullName": "Braganca",
          "path": [
            "Portugal",
            "Braganca"
          ],
          "lat": 41.8037,
          "lng": -6.7429
        },
        {
          "name": "Coimbra",
          "fullName": "Coimbra",
          "path": [
            "Portugal",
            "Coimbra"
          ],
          "lat": 40.2135,
          "lng": -8.4552
        },
        {
          "name": "Evora",
          "fullName": "Evora",
          "path": [
            "Portugal",
            "Evora"
          ],
          "lat": 38.567,
          "lng": -7.9
        },
        {
          "name": "Faro",
          "fullName": "Faro",
          "path": [
            "Portugal",
            "Faro"
          ],
          "lat": 37.0167,
          "lng": -7.9719
        },
        {
          "name": "Lisbon",
          "fullName": "Lisbon",
          "path": [
            "Portugal",
            "Lisbon"
          ],
          "lat": 38.7191,
          "lng": -9.1497
        },
        {
          "name": "Porto",
          "fullName": "Porto",
          "path": [
            "Portugal",
            "Porto"
          ],
          "lat": 41.2322,
          "lng": -8.6792
        },
        {
          "name": "Vila Real",
          "fullName": "Vila Real",
          "path": [
            "Portugal",
            "Vila Real"
          ],
          "lat": 41.317,
          "lng": -7.733
        }
      ]
    },
    {
      "name": "Puerto Rico",
      "children": [
        {
          "name": "Fajardo",
          "fullName": "Fajardo",
          "path": [
            "Puerto Rico",
            "Fajardo"
          ],
          "lat": 18.335,
          "lng": -65.631
        },
        {
          "name": "Ponce Mercedita",
          "fullName": "Ponce Mercedita",
          "path": [
            "Puerto Rico",
            "Ponce Mercedita"
          ],
          "lat": 18.008,
          "lng": -66.564
        },
        {
          "name": "San Juan",
          "fullName": "San Juan",
          "path": [
            "Puerto Rico",
            "San Juan"
          ],
          "lat": 18.4317,
          "lng": -65.9919
        }
      ]
    },
    {
      "name": "Qatar",
      "children": [
        {
          "name": "Doha",
          "fullName": "Doha",
          "path": [
            "Qatar",
            "Doha"
          ],
          "lat": 25.261,
          "lng": 51.565
        }
      ]
    },
    {
      "name": "Reunion",
      "children": [
        {
          "name": "Reunion",
          "fullName": "Reunion",
          "path": [
            "Reunion",
            "Reunion"
          ],
          "lat": -20.892,
          "lng": 55.529
        }
      ]
    },
    {
      "name": "Saudi Arabia",
      "children": [
        {
          "name": "Al Aqiq",
          "fullName": "Al Aqiq",
          "path": [
            "Saudi Arabia",
            "Al Aqiq"
          ],
          "lat": 20.296,
          "lng": 41.634
        },
        {
          "name": "Arar",
          "fullName": "Arar",
          "path": [
            "Saudi Arabia",
            "Arar"
          ],
          "lat": 30.907,
          "lng": 41.138
        },
        {
          "name": "Dammam",
          "fullName": "Dammam",
          "path": [
            "Saudi Arabia",
            "Dammam"
          ],
          "lat": 26.265,
          "lng": 50.152
        },
        {
          "name": "Gassim",
          "fullName": "Gassim",
          "path": [
            "Saudi Arabia",
            "Gassim"
          ],
          "lat": 26.3,
          "lng": 43.767
        },
        {
          "name": "Jeddah",
          "fullName": "Jeddah",
          "path": [
            "Saudi Arabia",
            "Jeddah"
          ],
          "lat": 21.68,
          "lng": 39.157
        },
        {
          "name": "Jizan",
          "fullName": "Jizan",
          "path": [
            "Saudi Arabia",
            "Jizan"
          ],
          "lat": 16.8964,
          "lng": 42.5837
        },
        {
          "name": "Medina",
          "fullName": "Medina",
          "path": [
            "Saudi Arabia",
            "Medina"
          ],
          "lat": 24.553,
          "lng": 39.705
        },
        {
          "name": "Najran",
          "fullName": "Najran",
          "path": [
            "Saudi Arabia",
            "Najran"
          ],
          "lat": 17.611,
          "lng": 44.419
        },
        {
          "name": "Qaisumah",
          "fullName": "Qaisumah",
          "path": [
            "Saudi Arabia",
            "Qaisumah"
          ],
          "lat": 28.335,
          "lng": 46.125
        },
        {
          "name": "Riyadh",
          "fullName": "Riyadh",
          "path": [
            "Saudi Arabia",
            "Riyadh"
          ],
          "lat": 24.722,
          "lng": 46.725
        },
        {
          "name": "Tabuk",
          "fullName": "Tabuk",
          "path": [
            "Saudi Arabia",
            "Tabuk"
          ],
          "lat": 28.365,
          "lng": 36.619
        }
      ]
    },
    {
      "name": "Senegal",
      "children": [
        {
          "name": "Dakar",
          "fullName": "Dakar",
          "path": [
            "Senegal",
            "Dakar"
          ],
          "lat": 14.74,
          "lng": -17.49
        },
        {
          "name": "Diourbel",
          "fullName": "Diourbel",
          "path": [
            "Senegal",
            "Diourbel"
          ],
          "lat": 14.65,
          "lng": -16.233
        },
        {
          "name": "Kaolack",
          "fullName": "Kaolack",
          "path": [
            "Senegal",
            "Kaolack"
          ],
          "lat": 14.147,
          "lng": -16.051
        },
        {
          "name": "Kolda",
          "fullName": "Kolda",
          "path": [
            "Senegal",
            "Kolda"
          ],
          "lat": 12.883,
          "lng": -14.967
        },
        {
          "name": "Saint-Louis",
          "fullName": "Saint-Louis",
          "path": [
            "Senegal",
            "Saint-Louis"
          ],
          "lat": 16.051,
          "lng": -16.463
        },
        {
          "name": "Tambacounda",
          "fullName": "Tambacounda",
          "path": [
            "Senegal",
            "Tambacounda"
          ],
          "lat": 13.737,
          "lng": -13.653
        },
        {
          "name": "Ziguinchor",
          "fullName": "Ziguinchor",
          "path": [
            "Senegal",
            "Ziguinchor"
          ],
          "lat": 12.556,
          "lng": -16.282
        }
      ]
    },
    {
      "name": "Serbia",
      "children": [
        {
          "name": "Belgrade",
          "fullName": "Belgrade",
          "path": [
            "Serbia",
            "Belgrade"
          ],
          "lat": 44.7984,
          "lng": 20.4648
        },
        {
          "name": "Kragujevac",
          "fullName": "Kragujevac",
          "path": [
            "Serbia",
            "Kragujevac"
          ],
          "lat": 44.033,
          "lng": 20.933
        },
        {
          "name": "Leskovac",
          "fullName": "Leskovac",
          "path": [
            "Serbia",
            "Leskovac"
          ],
          "lat": 42.983,
          "lng": 21.95
        },
        {
          "name": "Negotin",
          "fullName": "Negotin",
          "path": [
            "Serbia",
            "Negotin"
          ],
          "lat": 44.233,
          "lng": 22.55
        },
        {
          "name": "Novi Sad",
          "fullName": "Novi Sad",
          "path": [
            "Serbia",
            "Novi Sad"
          ],
          "lat": 45.333,
          "lng": 19.85
        },
        {
          "name": "Palic",
          "fullName": "Palic",
          "path": [
            "Serbia",
            "Palic"
          ],
          "lat": 46.1,
          "lng": 19.767
        },
        {
          "name": "Prizren",
          "fullName": "Prizren",
          "path": [
            "Serbia",
            "Prizren"
          ],
          "lat": 42.217,
          "lng": 20.733
        },
        {
          "name": "Vrsac",
          "fullName": "Vrsac",
          "path": [
            "Serbia",
            "Vrsac"
          ],
          "lat": 45.147,
          "lng": 21.31
        }
      ]
    },
    {
      "name": "Singapore",
      "children": [
        {
          "name": "Singapore",
          "fullName": "Singapore",
          "path": [
            "Singapore",
            "Singapore"
          ],
          "lat": 1.3678,
          "lng": 103.9826
        }
      ]
    },
    {
      "name": "Slovenia",
      "children": [
        {
          "name": "Celje",
          "fullName": "Celje",
          "path": [
            "Slovenia",
            "Celje"
          ],
          "lat": 46.237,
          "lng": 15.226
        },
        {
          "name": "Lesce",
          "fullName": "Lesce",
          "path": [
            "Slovenia",
            "Lesce"
          ],
          "lat": 46.367,
          "lng": 14.183
        },
        {
          "name": "Ljubljana",
          "fullName": "Ljubljana",
          "path": [
            "Slovenia",
            "Ljubljana"
          ],
          "lat": 46.0656,
          "lng": 14.5122
        },
        {
          "name": "Murska Sobota",
          "fullName": "Murska Sobota",
          "path": [
            "Slovenia",
            "Murska Sobota"
          ],
          "lat": 46.6521,
          "lng": 16.1913
        },
        {
          "name": "Nova Gorica",
          "fullName": "Nova Gorica",
          "path": [
            "Slovenia",
            "Nova Gorica"
          ],
          "lat": 45.8954,
          "lng": 13.6241
        }
      ]
    },
    {
      "name": "South Africa",
      "children": [
        {
          "name": "FS",
          "children": [
            {
              "name": "Bloemfontein",
              "fullName": "Bloemfontein, FS. South Africa",
              "path": [
                "South Africa",
                "FS",
                "Bloemfontein"
              ],
              "lat": -29.1039,
              "lng": 26.2981
            }
          ]
        },
        {
          "name": "GP",
          "children": [
            {
              "name": "Johannesburg",
              "fullName": "Johannesburg, GP. South Africa",
              "path": [
                "South Africa",
                "GP",
                "Johannesburg"
              ],
              "lat": -26.143,
              "lng": 28.235
            }
          ]
        },
        {
          "name": "WC",
          "children": [
            {
              "name": "Cape Town",
              "fullName": "Cape Town, WC. South Africa",
              "path": [
                "South Africa",
                "WC",
                "Cape Town"
              ],
              "lat": -33.9631,
              "lng": 18.6022
            }
          ]
        }
      ]
    },
    {
      "name": "South Korea",
      "children": [
        {
          "name": "Busan",
          "fullName": "Busan",
          "path": [
            "South Korea",
            "Busan"
          ],
          "lat": 35.1047,
          "lng": 129.0319
        },
        {
          "name": "Cheongju",
          "fullName": "Cheongju",
          "path": [
            "South Korea",
            "Cheongju"
          ],
          "lat": 36.6392,
          "lng": 127.4406
        },
        {
          "name": "Daegu",
          "fullName": "Daegu",
          "path": [
            "South Korea",
            "Daegu"
          ],
          "lat": 35.828,
          "lng": 128.652
        },
        {
          "name": "Gangneung",
          "fullName": "Gangneung",
          "path": [
            "South Korea",
            "Gangneung"
          ],
          "lat": 37.7514,
          "lng": 128.8911
        },
        {
          "name": "Gwangju",
          "fullName": "Gwangju",
          "path": [
            "South Korea",
            "Gwangju"
          ],
          "lat": 35.1731,
          "lng": 126.8917
        },
        {
          "name": "Jeju",
          "fullName": "Jeju",
          "path": [
            "South Korea",
            "Jeju"
          ],
          "lat": 33.5142,
          "lng": 126.5297
        },
        {
          "name": "Seoul",
          "fullName": "Seoul",
          "path": [
            "South Korea",
            "Seoul"
          ],
          "lat": 37.533,
          "lng": 126.967
        }
      ]
    },
    {
      "name": "Spain",
      "children": [
        {
          "name": "Barcelona",
          "fullName": "Barcelona",
          "path": [
            "Spain",
            "Barcelona"
          ],
          "lat": 41.3898,
          "lng": 2.2002
        },
        {
          "name": "La Coruna",
          "fullName": "La Coruna",
          "path": [
            "Spain",
            "La Coruna"
          ],
          "lat": 43.3658,
          "lng": -8.4214
        },
        {
          "name": "Madrid",
          "fullName": "Madrid",
          "path": [
            "Spain",
            "Madrid"
          ],
          "lat": 40.467,
          "lng": -3.556
        },
        {
          "name": "Mallorca",
          "fullName": "Mallorca",
          "path": [
            "Spain",
            "Mallorca"
          ],
          "lat": 39.5533,
          "lng": 2.6253
        },
        {
          "name": "Murcia",
          "fullName": "Murcia",
          "path": [
            "Spain",
            "Murcia"
          ],
          "lat": 38.0019,
          "lng": -1.1708
        },
        {
          "name": "San Fernando",
          "fullName": "San Fernando",
          "path": [
            "Spain",
            "San Fernando"
          ],
          "lat": 36.4657,
          "lng": -6.2055
        },
        {
          "name": "San Sebastian",
          "fullName": "San Sebastian",
          "path": [
            "Spain",
            "San Sebastian"
          ],
          "lat": 43.3064,
          "lng": -2.0411
        },
        {
          "name": "Santander",
          "fullName": "Santander",
          "path": [
            "Spain",
            "Santander"
          ],
          "lat": 43.4292,
          "lng": -3.8314
        },
        {
          "name": "Soria",
          "fullName": "Soria",
          "path": [
            "Spain",
            "Soria"
          ],
          "lat": 41.783,
          "lng": -2.483
        },
        {
          "name": "Valladolid",
          "fullName": "Valladolid",
          "path": [
            "Spain",
            "Valladolid"
          ],
          "lat": 41.6408,
          "lng": -4.7544
        }
      ]
    },
    {
      "name": "Sri Lanka",
      "children": [
        {
          "name": "Anuradhapura",
          "fullName": "Anuradhapura",
          "path": [
            "Sri Lanka",
            "Anuradhapura"
          ],
          "lat": 8.301,
          "lng": 80.428
        },
        {
          "name": "Batticaloa",
          "fullName": "Batticaloa",
          "path": [
            "Sri Lanka",
            "Batticaloa"
          ],
          "lat": 7.7124,
          "lng": 81.7011
        },
        {
          "name": "Colombo",
          "fullName": "Colombo",
          "path": [
            "Sri Lanka",
            "Colombo"
          ],
          "lat": 6.9047,
          "lng": 79.872
        },
        {
          "name": "Galle",
          "fullName": "Galle",
          "path": [
            "Sri Lanka",
            "Galle"
          ],
          "lat": 6.0296,
          "lng": 80.2143
        },
        {
          "name": "Kandy",
          "fullName": "Kandy",
          "path": [
            "Sri Lanka",
            "Kandy"
          ],
          "lat": 7.3344,
          "lng": 80.6266
        },
        {
          "name": "Mannar",
          "fullName": "Mannar",
          "path": [
            "Sri Lanka",
            "Mannar"
          ],
          "lat": 8.983,
          "lng": 79.917
        },
        {
          "name": "Puttalam",
          "fullName": "Puttalam",
          "path": [
            "Sri Lanka",
            "Puttalam"
          ],
          "lat": 8.0271,
          "lng": 79.8416
        }
      ]
    },
    {
      "name": "Thailand",
      "children": [
        {
          "name": "Bangkok",
          "fullName": "Bangkok",
          "path": [
            "Thailand",
            "Bangkok"
          ],
          "lat": 13.7264,
          "lng": 100.56
        },
        {
          "name": "Hat Yai",
          "fullName": "Hat Yai",
          "path": [
            "Thailand",
            "Hat Yai"
          ],
          "lat": 7.0187,
          "lng": 100.4978
        },
        {
          "name": "Khon Kaen",
          "fullName": "Khon Kaen",
          "path": [
            "Thailand",
            "Khon Kaen"
          ],
          "lat": 16.467,
          "lng": 102.784
        },
        {
          "name": "Lampang",
          "fullName": "Lampang",
          "path": [
            "Thailand",
            "Lampang"
          ],
          "lat": 18.2781,
          "lng": 99.5064
        },
        {
          "name": "Nakhon Sawan",
          "fullName": "Nakhon Sawan",
          "path": [
            "Thailand",
            "Nakhon Sawan"
          ],
          "lat": 15.6717,
          "lng": 100.1322
        },
        {
          "name": "Nan",
          "fullName": "Nan",
          "path": [
            "Thailand",
            "Nan"
          ],
          "lat": 18.7669,
          "lng": 100.7633
        },
        {
          "name": "Phitsanulok",
          "fullName": "Phitsanulok",
          "path": [
            "Thailand",
            "Phitsanulok"
          ],
          "lat": 16.7961,
          "lng": 100.2758
        },
        {
          "name": "Prachuap",
          "fullName": "Prachuap",
          "path": [
            "Thailand",
            "Prachuap"
          ],
          "lat": 11.835,
          "lng": 99.8103
        },
        {
          "name": "Ubon Ratchathani",
          "fullName": "Ubon Ratchathani",
          "path": [
            "Thailand",
            "Ubon Ratchathani"
          ],
          "lat": 15.251,
          "lng": 104.87
        },
        {
          "name": "Udon Thani",
          "fullName": "Udon Thani",
          "path": [
            "Thailand",
            "Udon Thani"
          ],
          "lat": 17.377,
          "lng": 102.809
        }
      ]
    },
    {
      "name": "Tunisia",
      "children": [
        {
          "name": "El Kef",
          "fullName": "El Kef",
          "path": [
            "Tunisia",
            "El Kef"
          ],
          "lat": 36.1231,
          "lng": 8.7239
        },
        {
          "name": "Gabes",
          "fullName": "Gabes",
          "path": [
            "Tunisia",
            "Gabes"
          ],
          "lat": 33.883,
          "lng": 10.107
        },
        {
          "name": "Sfax",
          "fullName": "Sfax",
          "path": [
            "Tunisia",
            "Sfax"
          ],
          "lat": 34.718,
          "lng": 10.691
        },
        {
          "name": "Sidi Bouzid",
          "fullName": "Sidi Bouzid",
          "path": [
            "Tunisia",
            "Sidi Bouzid"
          ],
          "lat": 35.0,
          "lng": 9.483
        },
        {
          "name": "Sousse",
          "fullName": "Sousse",
          "path": [
            "Tunisia",
            "Sousse"
          ],
          "lat": 35.758,
          "lng": 10.755
        },
        {
          "name": "Tataouine",
          "fullName": "Tataouine",
          "path": [
            "Tunisia",
            "Tataouine"
          ],
          "lat": 32.9577,
          "lng": 10.4671
        },
        {
          "name": "Tunis",
          "fullName": "Tunis",
          "path": [
            "Tunisia",
            "Tunis"
          ],
          "lat": 36.8509,
          "lng": 10.2145
        }
      ]
    },
    {
      "name": "Turkey",
      "children": [
        {
          "name": "Adana",
          "fullName": "Adana",
          "path": [
            "Turkey",
            "Adana"
          ],
          "lat": 36.982,
          "lng": 35.28
        },
        {
          "name": "Afyonkarahisar",
          "fullName": "Afyonkarahisar",
          "path": [
            "Turkey",
            "Afyonkarahisar"
          ],
          "lat": 38.733,
          "lng": 30.6
        },
        {
          "name": "Ankara",
          "fullName": "Ankara",
          "path": [
            "Turkey",
            "Ankara"
          ],
          "lat": 39.973,
          "lng": 32.863
        },
        {
          "name": "Antalya",
          "fullName": "Antalya",
          "path": [
            "Turkey",
            "Antalya"
          ],
          "lat": 36.885,
          "lng": 30.6829
        },
        {
          "name": "Canakkale",
          "fullName": "Canakkale",
          "path": [
            "Turkey",
            "Canakkale"
          ],
          "lat": 40.1414,
          "lng": 26.3995
        },
        {
          "name": "Edirne",
          "fullName": "Edirne",
          "path": [
            "Turkey",
            "Edirne"
          ],
          "lat": 41.6766,
          "lng": 26.5506
        },
        {
          "name": "Erzurum",
          "fullName": "Erzurum",
          "path": [
            "Turkey",
            "Erzurum"
          ],
          "lat": 39.9058,
          "lng": 41.2544
        },
        {
          "name": "Isparta",
          "fullName": "Isparta",
          "path": [
            "Turkey",
            "Isparta"
          ],
          "lat": 37.7852,
          "lng": 30.5668
        },
        {
          "name": "Istanbul",
          "fullName": "Istanbul",
          "path": [
            "Turkey",
            "Istanbul"
          ],
          "lat": 40.967,
          "lng": 28.817
        },
        {
          "name": "Izmir",
          "fullName": "Izmir",
          "path": [
            "Turkey",
            "Izmir"
          ],
          "lat": 38.3945,
          "lng": 27.0821
        },
        {
          "name": "Kayseri",
          "fullName": "Kayseri",
          "path": [
            "Turkey",
            "Kayseri"
          ],
          "lat": 38.773,
          "lng": 35.491
        },
        {
          "name": "Samsun",
          "fullName": "Samsun",
          "path": [
            "Turkey",
            "Samsun"
          ],
          "lat": 41.3439,
          "lng": 36.2562
        },
        {
          "name": "Sanliurfa",
          "fullName": "Sanliurfa",
          "path": [
            "Turkey",
            "Sanliurfa"
          ],
          "lat": 37.1604,
          "lng": 38.7867
        }
      ]
    },
    {
      "name": "United Arab Emirates",
      "children": [
        {
          "name": "Abu Dhabi",
          "fullName": "Abu Dhabi",
          "path": [
            "United Arab Emirates",
            "Abu Dhabi"
          ],
          "lat": 24.428,
          "lng": 54.458
        },
        {
          "name": "Al Ain",
          "fullName": "Al Ain",
          "path": [
            "United Arab Emirates",
            "Al Ain"
          ],
          "lat": 24.262,
          "lng": 55.609
        },
        {
          "name": "Dubai",
          "fullName": "Dubai",
          "path": [
            "United Arab Emirates",
            "Dubai"
          ],
          "lat": 25.255,
          "lng": 55.364
        },
        {
          "name": "Ras Al Khaimah",
          "fullName": "Ras Al Khaimah",
          "path": [
            "United Arab Emirates",
            "Ras Al Khaimah"
          ],
          "lat": 25.613,
          "lng": 55.939
        }
      ]
    },
    {
      "name": "United States",
      "children": [
        {
          "name": "AK",
          "children": [
            {
              "name": "Anaktuvuk",
              "fullName": "Anaktuvuk, AK. United States",
              "path": [
                "United States",
                "AK",
                "Anaktuvuk"
              ],
              "lat": 68.135,
              "lng": -151.742
            },
            {
              "name": "Anchorage",
              "fullName": "Anchorage, AK. United States",
              "path": [
                "United States",
                "AK",
                "Anchorage"
              ],
              "lat": 61.1567,
              "lng": -149.9864
            },
            {
              "name": "Cordova",
              "fullName": "Cordova, AK. United States",
              "path": [
                "United States",
                "AK",
                "Cordova"
              ],
              "lat": 60.492,
              "lng": -145.476
            },
            {
              "name": "Deadhorse",
              "fullName": "Deadhorse, AK. United States",
              "path": [
                "United States",
                "AK",
                "Deadhorse"
              ],
              "lat": 70.192,
              "lng": -148.477
            },
            {
              "name": "Dillingham",
              "fullName": "Dillingham, AK. United States",
              "path": [
                "United States",
                "AK",
                "Dillingham"
              ],
              "lat": 59.05,
              "lng": -158.517
            },
            {
              "name": "Dutch Harbor",
              "fullName": "Dutch Harbor, AK. United States",
              "path": [
                "United States",
                "AK",
                "Dutch Harbor"
              ],
              "lat": 53.895,
              "lng": -166.543
            },
            {
              "name": "Fairbanks",
              "fullName": "Fairbanks, AK. United States",
              "path": [
                "United States",
                "AK",
                "Fairbanks"
              ],
              "lat": 64.804,
              "lng": -147.876
            },
            {
              "name": "Fort Yukon",
              "fullName": "Fort Yukon, AK. United States",
              "path": [
                "United States",
                "AK",
                "Fort Yukon"
              ],
              "lat": 66.567,
              "lng": -145.267
            },
            {
              "name": "Kodiak",
              "fullName": "Kodiak, AK. United States",
              "path": [
                "United States",
                "AK",
                "Kodiak"
              ],
              "lat": 57.751,
              "lng": -152.486
            },
            {
              "name": "Noatak",
              "fullName": "Noatak, AK. United States",
              "path": [
                "United States",
                "AK",
                "Noatak"
              ],
              "lat": 67.566,
              "lng": -162.975
            },
            {
              "name": "Nome",
              "fullName": "Nome, AK. United States",
              "path": [
                "United States",
                "AK",
                "Nome"
              ],
              "lat": 64.511,
              "lng": -165.44
            },
            {
              "name": "Palmer",
              "fullName": "Palmer, AK. United States",
              "path": [
                "United States",
                "AK",
                "Palmer"
              ],
              "lat": 61.595,
              "lng": -149.092
            },
            {
              "name": "Point Lay",
              "fullName": "Point Lay, AK. United States",
              "path": [
                "United States",
                "AK",
                "Point Lay"
              ],
              "lat": 69.733,
              "lng": -163.005
            },
            {
              "name": "Portage Glacier",
              "fullName": "Portage Glacier, AK. United States",
              "path": [
                "United States",
                "AK",
                "Portage Glacier"
              ],
              "lat": 60.785,
              "lng": -148.841
            },
            {
              "name": "Ruby",
              "fullName": "Ruby, AK. United States",
              "path": [
                "United States",
                "AK",
                "Ruby"
              ],
              "lat": 64.727,
              "lng": -155.47
            },
            {
              "name": "Scammon Bay",
              "fullName": "Scammon Bay, AK. United States",
              "path": [
                "United States",
                "AK",
                "Scammon Bay"
              ],
              "lat": 61.845,
              "lng": -165.571
            },
            {
              "name": "Utqiagvik",
              "fullName": "Utqiagvik, AK. United States",
              "path": [
                "United States",
                "AK",
                "Utqiagvik"
              ],
              "lat": 71.283,
              "lng": -156.782
            }
          ]
        },
        {
          "name": "AL",
          "children": [
            {
              "name": "Albertville",
              "fullName": "Albertville, AL. United States",
              "path": [
                "United States",
                "AL",
                "Albertville"
              ],
              "lat": 34.229,
              "lng": -86.256
            },
            {
              "name": "Birmingham",
              "fullName": "Birmingham, AL. United States",
              "path": [
                "United States",
                "AL",
                "Birmingham"
              ],
              "lat": 33.566,
              "lng": -86.745
            },
            {
              "name": "Dothan",
              "fullName": "Dothan, AL. United States",
              "path": [
                "United States",
                "AL",
                "Dothan"
              ],
              "lat": 31.317,
              "lng": -85.45
            },
            {
              "name": "Huntsville",
              "fullName": "Huntsville, AL. United States",
              "path": [
                "United States",
                "AL",
                "Huntsville"
              ],
              "lat": 34.861,
              "lng": -86.557
            },
            {
              "name": "Mobile",
              "fullName": "Mobile, AL. United States",
              "path": [
                "United States",
                "AL",
                "Mobile"
              ],
              "lat": 30.688,
              "lng": -88.246
            },
            {
              "name": "Montgomery",
              "fullName": "Montgomery, AL. United States",
              "path": [
                "United States",
                "AL",
                "Montgomery"
              ],
              "lat": 32.3,
              "lng": -86.408
            }
          ]
        },
        {
          "name": "AR",
          "children": [
            {
              "name": "Fayetteville",
              "fullName": "Fayetteville, AR. United States",
              "path": [
                "United States",
                "AR",
                "Fayetteville"
              ],
              "lat": 36.01,
              "lng": -94.169
            },
            {
              "name": "Jonesboro",
              "fullName": "Jonesboro, AR. United States",
              "path": [
                "United States",
                "AR",
                "Jonesboro"
              ],
              "lat": 35.831,
              "lng": -90.646
            },
            {
              "name": "Little Rock",
              "fullName": "Little Rock, AR. United States",
              "path": [
                "United States",
                "AR",
                "Little Rock"
              ],
              "lat": 34.835,
              "lng": -92.2594
            },
            {
              "name": "Texarkana",
              "fullName": "Texarkana, AR. United States",
              "path": [
                "United States",
                "AR",
                "Texarkana"
              ],
              "lat": 33.454,
              "lng": -94.007
            }
          ]
        },
        {
          "name": "AZ",
          "children": [
            {
              "name": "Bullhead",
              "fullName": "Bullhead, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Bullhead"
              ],
              "lat": 35.157,
              "lng": -114.559
            },
            {
              "name": "Page",
              "fullName": "Page, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Page"
              ],
              "lat": 36.926,
              "lng": -111.448
            },
            {
              "name": "Phoenix",
              "fullName": "Phoenix, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Phoenix"
              ],
              "lat": 33.428,
              "lng": -112.004
            },
            {
              "name": "Sierra Vista",
              "fullName": "Sierra Vista, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Sierra Vista"
              ],
              "lat": 31.588,
              "lng": -110.344
            },
            {
              "name": "St. Johns",
              "fullName": "St. Johns, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "St. Johns"
              ],
              "lat": 34.518,
              "lng": -109.379
            },
            {
              "name": "Tucson",
              "fullName": "Tucson, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Tucson"
              ],
              "lat": 32.228,
              "lng": -110.956
            },
            {
              "name": "Yuma",
              "fullName": "Yuma, AZ. United States",
              "path": [
                "United States",
                "AZ",
                "Yuma"
              ],
              "lat": 32.65,
              "lng": -114.6
            }
          ]
        },
        {
          "name": "CA",
          "children": [
            {
              "name": "Alturas",
              "fullName": "Alturas, CA. United States",
              "path": [
                "United States",
                "CA",
                "Alturas"
              ],
              "lat": 41.483,
              "lng": -120.567
            },
            {
              "name": "Blythe",
              "fullName": "Blythe, CA. United States",
              "path": [
                "United States",
                "CA",
                "Blythe"
              ],
              "lat": 33.619,
              "lng": -114.714
            },
            {
              "name": "Crescent City",
              "fullName": "Crescent City, CA. United States",
              "path": [
                "United States",
                "CA",
                "Crescent City"
              ],
              "lat": 41.78,
              "lng": -124.237
            },
            {
              "name": "El Centro",
              "fullName": "El Centro, CA. United States",
              "path": [
                "United States",
                "CA",
                "El Centro"
              ],
              "lat": 32.817,
              "lng": -115.683
            },
            {
              "name": "Fresno",
              "fullName": "Fresno, CA. United States",
              "path": [
                "United States",
                "CA",
                "Fresno"
              ],
              "lat": 36.78,
              "lng": -119.719
            },
            {
              "name": "Humboldt Bay",
              "fullName": "Humboldt Bay, CA. United States",
              "path": [
                "United States",
                "CA",
                "Humboldt Bay"
              ],
              "lat": 40.8097,
              "lng": -124.16
            },
            {
              "name": "Lake Tahoe",
              "fullName": "Lake Tahoe, CA. United States",
              "path": [
                "United States",
                "CA",
                "Lake Tahoe"
              ],
              "lat": 38.898,
              "lng": -119.995
            },
            {
              "name": "Los Angeles",
              "fullName": "Los Angeles, CA. United States",
              "path": [
                "United States",
                "CA",
                "Los Angeles"
              ],
              "lat": 34.024,
              "lng": -118.291
            },
            {
              "name": "Mammoth Lakes",
              "fullName": "Mammoth Lakes, CA. United States",
              "path": [
                "United States",
                "CA",
                "Mammoth Lakes"
              ],
              "lat": 37.633,
              "lng": -118.85
            },
            {
              "name": "Merced",
              "fullName": "Merced, CA. United States",
              "path": [
                "United States",
                "CA",
                "Merced"
              ],
              "lat": 37.285,
              "lng": -120.513
            },
            {
              "name": "Montague",
              "fullName": "Montague, CA. United States",
              "path": [
                "United States",
                "CA",
                "Montague"
              ],
              "lat": 41.781,
              "lng": -122.468
            },
            {
              "name": "Needles",
              "fullName": "Needles, CA. United States",
              "path": [
                "United States",
                "CA",
                "Needles"
              ],
              "lat": 34.768,
              "lng": -114.619
            },
            {
              "name": "Oceanside",
              "fullName": "Oceanside, CA. United States",
              "path": [
                "United States",
                "CA",
                "Oceanside"
              ],
              "lat": 33.219,
              "lng": -117.349
            },
            {
              "name": "Palm Springs",
              "fullName": "Palm Springs, CA. United States",
              "path": [
                "United States",
                "CA",
                "Palm Springs"
              ],
              "lat": 33.822,
              "lng": -116.504
            },
            {
              "name": "Petaluma-Ronhert Park",
              "fullName": "Petaluma-Ronhert Park, CA. United States",
              "path": [
                "United States",
                "CA",
                "Petaluma-Ronhert Park"
              ],
              "lat": 38.258,
              "lng": -122.606
            },
            {
              "name": "Porterville",
              "fullName": "Porterville, CA. United States",
              "path": [
                "United States",
                "CA",
                "Porterville"
              ],
              "lat": 36.029,
              "lng": -119.063
            },
            {
              "name": "Ramona",
              "fullName": "Ramona, CA. United States",
              "path": [
                "United States",
                "CA",
                "Ramona"
              ],
              "lat": 33.038,
              "lng": -116.916
            },
            {
              "name": "Redding",
              "fullName": "Redding, CA. United States",
              "path": [
                "United States",
                "CA",
                "Redding"
              ],
              "lat": 40.518,
              "lng": -122.299
            },
            {
              "name": "Ridgecrest",
              "fullName": "Ridgecrest, CA. United States",
              "path": [
                "United States",
                "CA",
                "Ridgecrest"
              ],
              "lat": 35.688,
              "lng": -117.693
            },
            {
              "name": "Sacramento",
              "fullName": "Sacramento, CA. United States",
              "path": [
                "United States",
                "CA",
                "Sacramento"
              ],
              "lat": 38.696,
              "lng": -121.59
            },
            {
              "name": "Salinas",
              "fullName": "Salinas, CA. United States",
              "path": [
                "United States",
                "CA",
                "Salinas"
              ],
              "lat": 36.664,
              "lng": -121.608
            },
            {
              "name": "San Diego",
              "fullName": "San Diego, CA. United States",
              "path": [
                "United States",
                "CA",
                "San Diego"
              ],
              "lat": 32.734,
              "lng": -117.183
            },
            {
              "name": "San Francisco",
              "fullName": "San Francisco, CA. United States",
              "path": [
                "United States",
                "CA",
                "San Francisco"
              ],
              "lat": 37.62,
              "lng": -122.365
            },
            {
              "name": "San Luis",
              "fullName": "San Luis, CA. United States",
              "path": [
                "United States",
                "CA",
                "San Luis"
              ],
              "lat": 35.237,
              "lng": -120.641
            },
            {
              "name": "Santa Barbara",
              "fullName": "Santa Barbara, CA. United States",
              "path": [
                "United States",
                "CA",
                "Santa Barbara"
              ],
              "lat": 34.426,
              "lng": -119.843
            },
            {
              "name": "Stockton",
              "fullName": "Stockton, CA. United States",
              "path": [
                "United States",
                "CA",
                "Stockton"
              ],
              "lat": 37.889,
              "lng": -121.226
            },
            {
              "name": "Truckee-Tahoe",
              "fullName": "Truckee-Tahoe, CA. United States",
              "path": [
                "United States",
                "CA",
                "Truckee-Tahoe"
              ],
              "lat": 39.32,
              "lng": -120.139
            },
            {
              "name": "Ukiah",
              "fullName": "Ukiah, CA. United States",
              "path": [
                "United States",
                "CA",
                "Ukiah"
              ],
              "lat": 39.126,
              "lng": -123.201
            },
            {
              "name": "Yuba City",
              "fullName": "Yuba City, CA. United States",
              "path": [
                "United States",
                "CA",
                "Yuba City"
              ],
              "lat": 39.102,
              "lng": -121.568
            }
          ]
        },
        {
          "name": "CO",
          "children": [
            {
              "name": "Alamosa",
              "fullName": "Alamosa, CO. United States",
              "path": [
                "United States",
                "CO",
                "Alamosa"
              ],
              "lat": 37.439,
              "lng": -105.861
            },
            {
              "name": "Colorado Springs",
              "fullName": "Colorado Springs, CO. United States",
              "path": [
                "United States",
                "CO",
                "Colorado Springs"
              ],
              "lat": 38.81,
              "lng": -104.688
            },
            {
              "name": "Cortez",
              "fullName": "Cortez, CO. United States",
              "path": [
                "United States",
                "CO",
                "Cortez"
              ],
              "lat": 37.307,
              "lng": -108.626
            },
            {
              "name": "Craig",
              "fullName": "Craig, CO. United States",
              "path": [
                "United States",
                "CO",
                "Craig"
              ],
              "lat": 40.493,
              "lng": -107.524
            },
            {
              "name": "Denver",
              "fullName": "Denver, CO. United States",
              "path": [
                "United States",
                "CO",
                "Denver"
              ],
              "lat": 39.833,
              "lng": -104.658
            },
            {
              "name": "Fort Collins",
              "fullName": "Fort Collins, CO. United States",
              "path": [
                "United States",
                "CO",
                "Fort Collins"
              ],
              "lat": 40.588,
              "lng": -105.042
            },
            {
              "name": "Fort Morgan",
              "fullName": "Fort Morgan, CO. United States",
              "path": [
                "United States",
                "CO",
                "Fort Morgan"
              ],
              "lat": 40.167,
              "lng": -103.217
            },
            {
              "name": "Grand Junction",
              "fullName": "Grand Junction, CO. United States",
              "path": [
                "United States",
                "CO",
                "Grand Junction"
              ],
              "lat": 39.12,
              "lng": -108.525
            },
            {
              "name": "Lamar",
              "fullName": "Lamar, CO. United States",
              "path": [
                "United States",
                "CO",
                "Lamar"
              ],
              "lat": 38.07,
              "lng": -102.688
            },
            {
              "name": "Montrose",
              "fullName": "Montrose, CO. United States",
              "path": [
                "United States",
                "CO",
                "Montrose"
              ],
              "lat": 38.506,
              "lng": -107.899
            }
          ]
        },
        {
          "name": "CT",
          "children": [
            {
              "name": "Bridgeport",
              "fullName": "Bridgeport, CT. United States",
              "path": [
                "United States",
                "CT",
                "Bridgeport"
              ],
              "lat": 41.164,
              "lng": -73.127
            },
            {
              "name": "Hartford",
              "fullName": "Hartford, CT. United States",
              "path": [
                "United States",
                "CT",
                "Hartford"
              ],
              "lat": 41.736,
              "lng": -72.651
            },
            {
              "name": "New London",
              "fullName": "New London, CT. United States",
              "path": [
                "United States",
                "CT",
                "New London"
              ],
              "lat": 41.328,
              "lng": -72.049
            }
          ]
        },
        {
          "name": "DC",
          "children": [
            {
              "name": "Washington",
              "fullName": "Washington, DC. United States",
              "path": [
                "United States",
                "DC",
                "Washington"
              ],
              "lat": 38.847,
              "lng": -77.035
            }
          ]
        },
        {
          "name": "DE",
          "children": [
            {
              "name": "Dover",
              "fullName": "Dover, DE. United States",
              "path": [
                "United States",
                "DE",
                "Dover"
              ],
              "lat": 39.133,
              "lng": -75.467
            },
            {
              "name": "Georgetown",
              "fullName": "Georgetown, DE. United States",
              "path": [
                "United States",
                "DE",
                "Georgetown"
              ],
              "lat": 38.69,
              "lng": -75.363
            },
            {
              "name": "Wilmington",
              "fullName": "Wilmington, DE. United States",
              "path": [
                "United States",
                "DE",
                "Wilmington"
              ],
              "lat": 39.674,
              "lng": -75.606
            }
          ]
        },
        {
          "name": "FL",
          "children": [
            {
              "name": "Daytona Beach",
              "fullName": "Daytona Beach, FL. United States",
              "path": [
                "United States",
                "FL",
                "Daytona Beach"
              ],
              "lat": 29.183,
              "lng": -81.048
            },
            {
              "name": "Fort Myers",
              "fullName": "Fort Myers, FL. United States",
              "path": [
                "United States",
                "FL",
                "Fort Myers"
              ],
              "lat": 26.536,
              "lng": -81.755
            },
            {
              "name": "Gainesville",
              "fullName": "Gainesville, FL. United States",
              "path": [
                "United States",
                "FL",
                "Gainesville"
              ],
              "lat": 29.692,
              "lng": -82.276
            },
            {
              "name": "Jacksonville",
              "fullName": "Jacksonville, FL. United States",
              "path": [
                "United States",
                "FL",
                "Jacksonville"
              ],
              "lat": 30.4839,
              "lng": -81.7011
            },
            {
              "name": "Marianna",
              "fullName": "Marianna, FL. United States",
              "path": [
                "United States",
                "FL",
                "Marianna"
              ],
              "lat": 30.836,
              "lng": -85.184
            },
            {
              "name": "Miami",
              "fullName": "Miami, FL. United States",
              "path": [
                "United States",
                "FL",
                "Miami"
              ],
              "lat": 25.907,
              "lng": -80.28
            },
            {
              "name": "Orlando",
              "fullName": "Orlando, FL. United States",
              "path": [
                "United States",
                "FL",
                "Orlando"
              ],
              "lat": 28.545,
              "lng": -81.333
            },
            {
              "name": "Panama City",
              "fullName": "Panama City, FL. United States",
              "path": [
                "United States",
                "FL",
                "Panama City"
              ],
              "lat": 30.212,
              "lng": -85.683
            },
            {
              "name": "Penascola",
              "fullName": "Penascola, FL. United States",
              "path": [
                "United States",
                "FL",
                "Penascola"
              ],
              "lat": 30.478,
              "lng": -87.187
            },
            {
              "name": "Tallahassee",
              "fullName": "Tallahassee, FL. United States",
              "path": [
                "United States",
                "FL",
                "Tallahassee"
              ],
              "lat": 30.4459,
              "lng": -84.3007
            },
            {
              "name": "Tampa",
              "fullName": "Tampa, FL. United States",
              "path": [
                "United States",
                "FL",
                "Tampa"
              ],
              "lat": 27.962,
              "lng": -82.54
            },
            {
              "name": "Vero Beach",
              "fullName": "Vero Beach, FL. United States",
              "path": [
                "United States",
                "FL",
                "Vero Beach"
              ],
              "lat": 27.651,
              "lng": -80.42
            }
          ]
        },
        {
          "name": "GA",
          "children": [
            {
              "name": "Albany",
              "fullName": "Albany, GA. United States",
              "path": [
                "United States",
                "GA",
                "Albany"
              ],
              "lat": 31.536,
              "lng": -84.194
            },
            {
              "name": "Atlanta",
              "fullName": "Atlanta, GA. United States",
              "path": [
                "United States",
                "GA",
                "Atlanta"
              ],
              "lat": 33.63,
              "lng": -84.442
            },
            {
              "name": "Augusta",
              "fullName": "Augusta, GA. United States",
              "path": [
                "United States",
                "GA",
                "Augusta"
              ],
              "lat": 33.467,
              "lng": -82.039
            },
            {
              "name": "Brunswick",
              "fullName": "Brunswick, GA. United States",
              "path": [
                "United States",
                "GA",
                "Brunswick"
              ],
              "lat": 31.259,
              "lng": -81.466
            },
            {
              "name": "Columbus",
              "fullName": "Columbus, GA. United States",
              "path": [
                "United States",
                "GA",
                "Columbus"
              ],
              "lat": 32.516,
              "lng": -84.942
            },
            {
              "name": "Dalton",
              "fullName": "Dalton, GA. United States",
              "path": [
                "United States",
                "GA",
                "Dalton"
              ],
              "lat": 34.722,
              "lng": -84.869
            },
            {
              "name": "Savannah",
              "fullName": "Savannah, GA. United States",
              "path": [
                "United States",
                "GA",
                "Savannah"
              ],
              "lat": 32.131,
              "lng": -81.202
            },
            {
              "name": "Vidalia",
              "fullName": "Vidalia, GA. United States",
              "path": [
                "United States",
                "GA",
                "Vidalia"
              ],
              "lat": 32.193,
              "lng": -82.372
            },
            {
              "name": "Warner-Robins",
              "fullName": "Warner-Robins, GA. United States",
              "path": [
                "United States",
                "GA",
                "Warner-Robins"
              ],
              "lat": 32.633,
              "lng": -83.6
            }
          ]
        },
        {
          "name": "HI",
          "children": [
            {
              "name": "Hilo",
              "fullName": "Hilo, HI. United States",
              "path": [
                "United States",
                "HI",
                "Hilo"
              ],
              "lat": 19.719,
              "lng": -155.053
            },
            {
              "name": "Honolulu",
              "fullName": "Honolulu, HI. United States",
              "path": [
                "United States",
                "HI",
                "Honolulu"
              ],
              "lat": 21.324,
              "lng": -157.929
            },
            {
              "name": "Lihue",
              "fullName": "Lihue, HI. United States",
              "path": [
                "United States",
                "HI",
                "Lihue"
              ],
              "lat": 21.984,
              "lng": -159.341
            }
          ]
        },
        {
          "name": "IA",
          "children": [
            {
              "name": "Atlantic",
              "fullName": "Atlantic, IA. United States",
              "path": [
                "United States",
                "IA",
                "Atlantic"
              ],
              "lat": 41.407,
              "lng": -95.047
            },
            {
              "name": "Burlington",
              "fullName": "Burlington, IA. United States",
              "path": [
                "United States",
                "IA",
                "Burlington"
              ],
              "lat": 40.783,
              "lng": -91.125
            },
            {
              "name": "Cedar Rapids",
              "fullName": "Cedar Rapids, IA. United States",
              "path": [
                "United States",
                "IA",
                "Cedar Rapids"
              ],
              "lat": 41.883,
              "lng": -91.717
            },
            {
              "name": "Creston",
              "fullName": "Creston, IA. United States",
              "path": [
                "United States",
                "IA",
                "Creston"
              ],
              "lat": 41.02,
              "lng": -94.364
            },
            {
              "name": "Des Moines",
              "fullName": "Des Moines, IA. United States",
              "path": [
                "United States",
                "IA",
                "Des Moines"
              ],
              "lat": 41.534,
              "lng": -93.653
            },
            {
              "name": "Dubuque",
              "fullName": "Dubuque, IA. United States",
              "path": [
                "United States",
                "IA",
                "Dubuque"
              ],
              "lat": 42.398,
              "lng": -90.704
            },
            {
              "name": "Fort Dodge",
              "fullName": "Fort Dodge, IA. United States",
              "path": [
                "United States",
                "IA",
                "Fort Dodge"
              ],
              "lat": 42.55,
              "lng": -94.183
            },
            {
              "name": "Mason City",
              "fullName": "Mason City, IA. United States",
              "path": [
                "United States",
                "IA",
                "Mason City"
              ],
              "lat": 43.154,
              "lng": -93.327
            },
            {
              "name": "Ottumwa",
              "fullName": "Ottumwa, IA. United States",
              "path": [
                "United States",
                "IA",
                "Ottumwa"
              ],
              "lat": 41.108,
              "lng": -92.447
            },
            {
              "name": "Spencer",
              "fullName": "Spencer, IA. United States",
              "path": [
                "United States",
                "IA",
                "Spencer"
              ],
              "lat": 43.164,
              "lng": -95.202
            },
            {
              "name": "Waterloo",
              "fullName": "Waterloo, IA. United States",
              "path": [
                "United States",
                "IA",
                "Waterloo"
              ],
              "lat": 42.554,
              "lng": -92.401
            }
          ]
        },
        {
          "name": "ID",
          "children": [
            {
              "name": "Boise",
              "fullName": "Boise, ID. United States",
              "path": [
                "United States",
                "ID",
                "Boise"
              ],
              "lat": 43.567,
              "lng": -116.241
            },
            {
              "name": "Coeur D_Alene",
              "fullName": "Coeur D_Alene, ID. United States",
              "path": [
                "United States",
                "ID",
                "Coeur D_Alene"
              ],
              "lat": 47.767,
              "lng": -116.817
            },
            {
              "name": "Idaho Falls",
              "fullName": "Idaho Falls, ID. United States",
              "path": [
                "United States",
                "ID",
                "Idaho Falls"
              ],
              "lat": 43.519,
              "lng": -112.064
            },
            {
              "name": "Lewiston",
              "fullName": "Lewiston, ID. United States",
              "path": [
                "United States",
                "ID",
                "Lewiston"
              ],
              "lat": 46.375,
              "lng": -117.016
            },
            {
              "name": "McCall",
              "fullName": "McCall, ID. United States",
              "path": [
                "United States",
                "ID",
                "McCall"
              ],
              "lat": 44.889,
              "lng": -116.102
            },
            {
              "name": "Pocatello",
              "fullName": "Pocatello, ID. United States",
              "path": [
                "United States",
                "ID",
                "Pocatello"
              ],
              "lat": 42.92,
              "lng": -112.571
            },
            {
              "name": "Salmon",
              "fullName": "Salmon, ID. United States",
              "path": [
                "United States",
                "ID",
                "Salmon"
              ],
              "lat": 45.117,
              "lng": -113.883
            },
            {
              "name": "Twin Falls",
              "fullName": "Twin Falls, ID. United States",
              "path": [
                "United States",
                "ID",
                "Twin Falls"
              ],
              "lat": 42.482,
              "lng": -114.487
            }
          ]
        },
        {
          "name": "IL",
          "children": [
            {
              "name": "Carbondale",
              "fullName": "Carbondale, IL. United States",
              "path": [
                "United States",
                "IL",
                "Carbondale"
              ],
              "lat": 37.78,
              "lng": -89.25
            },
            {
              "name": "Champaign",
              "fullName": "Champaign, IL. United States",
              "path": [
                "United States",
                "IL",
                "Champaign"
              ],
              "lat": 40.04,
              "lng": -88.278
            },
            {
              "name": "Chicago",
              "fullName": "Chicago, IL. United States",
              "path": [
                "United States",
                "IL",
                "Chicago"
              ],
              "lat": 41.96,
              "lng": -87.932
            },
            {
              "name": "East St. Louis",
              "fullName": "East St. Louis, IL. United States",
              "path": [
                "United States",
                "IL",
                "East St. Louis"
              ],
              "lat": 38.571,
              "lng": -90.157
            },
            {
              "name": "Moline",
              "fullName": "Moline, IL. United States",
              "path": [
                "United States",
                "IL",
                "Moline"
              ],
              "lat": 41.45,
              "lng": -90.517
            },
            {
              "name": "Olney",
              "fullName": "Olney, IL. United States",
              "path": [
                "United States",
                "IL",
                "Olney"
              ],
              "lat": 38.722,
              "lng": -88.176
            },
            {
              "name": "Peoria",
              "fullName": "Peoria, IL. United States",
              "path": [
                "United States",
                "IL",
                "Peoria"
              ],
              "lat": 40.668,
              "lng": -89.684
            },
            {
              "name": "Quincy",
              "fullName": "Quincy, IL. United States",
              "path": [
                "United States",
                "IL",
                "Quincy"
              ],
              "lat": 39.937,
              "lng": -91.192
            },
            {
              "name": "Springfield",
              "fullName": "Springfield, IL. United States",
              "path": [
                "United States",
                "IL",
                "Springfield"
              ],
              "lat": 39.845,
              "lng": -89.684
            }
          ]
        },
        {
          "name": "IN",
          "children": [
            {
              "name": "Evansville",
              "fullName": "Evansville, IN. United States",
              "path": [
                "United States",
                "IN",
                "Evansville"
              ],
              "lat": 38.044,
              "lng": -87.521
            },
            {
              "name": "Fort Wayne",
              "fullName": "Fort Wayne, IN. United States",
              "path": [
                "United States",
                "IN",
                "Fort Wayne"
              ],
              "lat": 40.971,
              "lng": -85.206
            },
            {
              "name": "Indianapolis",
              "fullName": "Indianapolis, IN. United States",
              "path": [
                "United States",
                "IN",
                "Indianapolis"
              ],
              "lat": 39.725,
              "lng": -86.282
            },
            {
              "name": "Lafayette",
              "fullName": "Lafayette, IN. United States",
              "path": [
                "United States",
                "IN",
                "Lafayette"
              ],
              "lat": 40.412,
              "lng": -86.937
            },
            {
              "name": "South Bend",
              "fullName": "South Bend, IN. United States",
              "path": [
                "United States",
                "IN",
                "South Bend"
              ],
              "lat": 41.707,
              "lng": -86.316
            }
          ]
        },
        {
          "name": "KS",
          "children": [
            {
              "name": "Coffeyville",
              "fullName": "Coffeyville, KS. United States",
              "path": [
                "United States",
                "KS",
                "Coffeyville"
              ],
              "lat": 37.091,
              "lng": -95.566
            },
            {
              "name": "Concordia",
              "fullName": "Concordia, KS. United States",
              "path": [
                "United States",
                "KS",
                "Concordia"
              ],
              "lat": 39.551,
              "lng": -97.651
            },
            {
              "name": "Dodge City",
              "fullName": "Dodge City, KS. United States",
              "path": [
                "United States",
                "KS",
                "Dodge City"
              ],
              "lat": 37.7614,
              "lng": -99.9686
            },
            {
              "name": "Goodland",
              "fullName": "Goodland, KS. United States",
              "path": [
                "United States",
                "KS",
                "Goodland"
              ],
              "lat": 39.367,
              "lng": -101.693
            },
            {
              "name": "Manhattan",
              "fullName": "Manhattan, KS. United States",
              "path": [
                "United States",
                "KS",
                "Manhattan"
              ],
              "lat": 39.135,
              "lng": -96.679
            },
            {
              "name": "Topeka",
              "fullName": "Topeka, KS. United States",
              "path": [
                "United States",
                "KS",
                "Topeka"
              ],
              "lat": 39.0722,
              "lng": -95.6306
            },
            {
              "name": "Wichita",
              "fullName": "Wichita, KS. United States",
              "path": [
                "United States",
                "KS",
                "Wichita"
              ],
              "lat": 37.746,
              "lng": -97.221
            }
          ]
        },
        {
          "name": "KY",
          "children": [
            {
              "name": "Bowling Green",
              "fullName": "Bowling Green, KY. United States",
              "path": [
                "United States",
                "KY",
                "Bowling Green"
              ],
              "lat": 36.965,
              "lng": -86.424
            },
            {
              "name": "Convington",
              "fullName": "Convington, KY. United States",
              "path": [
                "United States",
                "KY",
                "Convington"
              ],
              "lat": 39.044,
              "lng": -84.672
            },
            {
              "name": "Danville",
              "fullName": "Danville, KY. United States",
              "path": [
                "United States",
                "KY",
                "Danville"
              ],
              "lat": 37.578,
              "lng": -84.77
            },
            {
              "name": "London",
              "fullName": "London, KY. United States",
              "path": [
                "United States",
                "KY",
                "London"
              ],
              "lat": 37.087,
              "lng": -84.077
            },
            {
              "name": "Louisville",
              "fullName": "Louisville, KY. United States",
              "path": [
                "United States",
                "KY",
                "Louisville"
              ],
              "lat": 38.181,
              "lng": -85.739
            },
            {
              "name": "Owensboro",
              "fullName": "Owensboro, KY. United States",
              "path": [
                "United States",
                "KY",
                "Owensboro"
              ],
              "lat": 37.75,
              "lng": -87.167
            },
            {
              "name": "Paducah",
              "fullName": "Paducah, KY. United States",
              "path": [
                "United States",
                "KY",
                "Paducah"
              ],
              "lat": 37.056,
              "lng": -88.774
            }
          ]
        },
        {
          "name": "LA",
          "children": [
            {
              "name": "Alexandria",
              "fullName": "Alexandria, LA. United States",
              "path": [
                "United States",
                "LA",
                "Alexandria"
              ],
              "lat": 31.335,
              "lng": -92.559
            },
            {
              "name": "Bastrop",
              "fullName": "Bastrop, LA. United States",
              "path": [
                "United States",
                "LA",
                "Bastrop"
              ],
              "lat": 32.756,
              "lng": -91.881
            },
            {
              "name": "Lafayette",
              "fullName": "Lafayette, LA. United States",
              "path": [
                "United States",
                "LA",
                "Lafayette"
              ],
              "lat": 30.205,
              "lng": -91.988
            },
            {
              "name": "New Olreans",
              "fullName": "New Olreans, LA. United States",
              "path": [
                "United States",
                "LA",
                "New Olreans"
              ],
              "lat": 29.997,
              "lng": -90.278
            },
            {
              "name": "Shreveport",
              "fullName": "Shreveport, LA. United States",
              "path": [
                "United States",
                "LA",
                "Shreveport"
              ],
              "lat": 32.4511,
              "lng": -93.8414
            }
          ]
        },
        {
          "name": "MA",
          "children": [
            {
              "name": "Boston",
              "fullName": "Boston, MA. United States",
              "path": [
                "United States",
                "MA",
                "Boston"
              ],
              "lat": 42.361,
              "lng": -71.01
            },
            {
              "name": "Chicopee",
              "fullName": "Chicopee, MA. United States",
              "path": [
                "United States",
                "MA",
                "Chicopee"
              ],
              "lat": 42.2,
              "lng": -72.533
            },
            {
              "name": "Nantucket",
              "fullName": "Nantucket, MA. United States",
              "path": [
                "United States",
                "MA",
                "Nantucket"
              ],
              "lat": 41.253,
              "lng": -70.061
            }
          ]
        },
        {
          "name": "MD",
          "children": [
            {
              "name": "Annapolis",
              "fullName": "Annapolis, MD. United States",
              "path": [
                "United States",
                "MD",
                "Annapolis"
              ],
              "lat": 38.991,
              "lng": -76.489
            },
            {
              "name": "Baltimore",
              "fullName": "Baltimore, MD. United States",
              "path": [
                "United States",
                "MD",
                "Baltimore"
              ],
              "lat": 39.281,
              "lng": -76.611
            },
            {
              "name": "Cumberland",
              "fullName": "Cumberland, MD. United States",
              "path": [
                "United States",
                "MD",
                "Cumberland"
              ],
              "lat": 39.617,
              "lng": -78.767
            },
            {
              "name": "Hagerstown",
              "fullName": "Hagerstown, MD. United States",
              "path": [
                "United States",
                "MD",
                "Hagerstown"
              ],
              "lat": 39.706,
              "lng": -77.73
            },
            {
              "name": "Salisbury",
              "fullName": "Salisbury, MD. United States",
              "path": [
                "United States",
                "MD",
                "Salisbury"
              ],
              "lat": 38.341,
              "lng": -75.513
            }
          ]
        },
        {
          "name": "ME",
          "children": [
            {
              "name": "Augusta",
              "fullName": "Augusta, ME. United States",
              "path": [
                "United States",
                "ME",
                "Augusta"
              ],
              "lat": 44.316,
              "lng": -69.797
            },
            {
              "name": "Caribou",
              "fullName": "Caribou, ME. United States",
              "path": [
                "United States",
                "ME",
                "Caribou"
              ],
              "lat": 46.871,
              "lng": -68.017
            },
            {
              "name": "Millinocket",
              "fullName": "Millinocket, ME. United States",
              "path": [
                "United States",
                "ME",
                "Millinocket"
              ],
              "lat": 45.648,
              "lng": -68.693
            },
            {
              "name": "Portland",
              "fullName": "Portland, ME. United States",
              "path": [
                "United States",
                "ME",
                "Portland"
              ],
              "lat": 43.65,
              "lng": -70.317
            }
          ]
        },
        {
          "name": "MI",
          "children": [
            {
              "name": "Alpena",
              "fullName": "Alpena, MI. United States",
              "path": [
                "United States",
                "MI",
                "Alpena"
              ],
              "lat": 45.072,
              "lng": -83.564
            },
            {
              "name": "Bad Axe",
              "fullName": "Bad Axe, MI. United States",
              "path": [
                "United States",
                "MI",
                "Bad Axe"
              ],
              "lat": 43.78,
              "lng": -82.986
            },
            {
              "name": "Cheboygan",
              "fullName": "Cheboygan, MI. United States",
              "path": [
                "United States",
                "MI",
                "Cheboygan"
              ],
              "lat": 45.654,
              "lng": -84.519
            },
            {
              "name": "Detroit",
              "fullName": "Detroit, MI. United States",
              "path": [
                "United States",
                "MI",
                "Detroit"
              ],
              "lat": 42.409,
              "lng": -83.01
            },
            {
              "name": "Grand Rapids",
              "fullName": "Grand Rapids, MI. United States",
              "path": [
                "United States",
                "MI",
                "Grand Rapids"
              ],
              "lat": 42.883,
              "lng": -85.524
            },
            {
              "name": "Iron Mountain",
              "fullName": "Iron Mountain, MI. United States",
              "path": [
                "United States",
                "MI",
                "Iron Mountain"
              ],
              "lat": 45.813,
              "lng": -88.113
            },
            {
              "name": "Ironwood",
              "fullName": "Ironwood, MI. United States",
              "path": [
                "United States",
                "MI",
                "Ironwood"
              ],
              "lat": 46.533,
              "lng": -90.133
            },
            {
              "name": "Kalamazoo",
              "fullName": "Kalamazoo, MI. United States",
              "path": [
                "United States",
                "MI",
                "Kalamazoo"
              ],
              "lat": 42.235,
              "lng": -85.552
            },
            {
              "name": "Manistique",
              "fullName": "Manistique, MI. United States",
              "path": [
                "United States",
                "MI",
                "Manistique"
              ],
              "lat": 45.95,
              "lng": -86.23
            },
            {
              "name": "Marquette",
              "fullName": "Marquette, MI. United States",
              "path": [
                "United States",
                "MI",
                "Marquette"
              ],
              "lat": 46.531,
              "lng": -87.549
            },
            {
              "name": "Menominee",
              "fullName": "Menominee, MI. United States",
              "path": [
                "United States",
                "MI",
                "Menominee"
              ],
              "lat": 45.117,
              "lng": -87.633
            },
            {
              "name": "Mount Pleasant",
              "fullName": "Mount Pleasant, MI. United States",
              "path": [
                "United States",
                "MI",
                "Mount Pleasant"
              ],
              "lat": 43.622,
              "lng": -84.737
            },
            {
              "name": "Sault Ste. Marie",
              "fullName": "Sault Ste. Marie, MI. United States",
              "path": [
                "United States",
                "MI",
                "Sault Ste. Marie"
              ],
              "lat": 46.479,
              "lng": -84.357
            },
            {
              "name": "Traverse City",
              "fullName": "Traverse City, MI. United States",
              "path": [
                "United States",
                "MI",
                "Traverse City"
              ],
              "lat": 44.741,
              "lng": -85.583
            }
          ]
        },
        {
          "name": "MN",
          "children": [
            {
              "name": "Bemidji",
              "fullName": "Bemidji, MN. United States",
              "path": [
                "United States",
                "MN",
                "Bemidji"
              ],
              "lat": 47.5,
              "lng": -94.933
            },
            {
              "name": "Duluth",
              "fullName": "Duluth, MN. United States",
              "path": [
                "United States",
                "MN",
                "Duluth"
              ],
              "lat": 46.837,
              "lng": -92.183
            },
            {
              "name": "Fergus Falls",
              "fullName": "Fergus Falls, MN. United States",
              "path": [
                "United States",
                "MN",
                "Fergus Falls"
              ],
              "lat": 46.283,
              "lng": -96.15
            },
            {
              "name": "Hibbing",
              "fullName": "Hibbing, MN. United States",
              "path": [
                "United States",
                "MN",
                "Hibbing"
              ],
              "lat": 47.386,
              "lng": -92.839
            },
            {
              "name": "International Falls",
              "fullName": "International Falls, MN. United States",
              "path": [
                "United States",
                "MN",
                "International Falls"
              ],
              "lat": 48.561,
              "lng": -93.398
            },
            {
              "name": "Mankato",
              "fullName": "Mankato, MN. United States",
              "path": [
                "United States",
                "MN",
                "Mankato"
              ],
              "lat": 44.217,
              "lng": -93.917
            },
            {
              "name": "Marshall",
              "fullName": "Marshall, MN. United States",
              "path": [
                "United States",
                "MN",
                "Marshall"
              ],
              "lat": 44.45,
              "lng": -95.817
            },
            {
              "name": "Minneapolis-St. Paul",
              "fullName": "Minneapolis-St. Paul, MN. United States",
              "path": [
                "United States",
                "MN",
                "Minneapolis-St. Paul"
              ],
              "lat": 44.883,
              "lng": -93.229
            },
            {
              "name": "Mora",
              "fullName": "Mora, MN. United States",
              "path": [
                "United States",
                "MN",
                "Mora"
              ],
              "lat": 45.886,
              "lng": -93.272
            },
            {
              "name": "Rochester",
              "fullName": "Rochester, MN. United States",
              "path": [
                "United States",
                "MN",
                "Rochester"
              ],
              "lat": 43.904,
              "lng": -92.492
            },
            {
              "name": "St. Cloud",
              "fullName": "St. Cloud, MN. United States",
              "path": [
                "United States",
                "MN",
                "St. Cloud"
              ],
              "lat": 45.543,
              "lng": -94.051
            },
            {
              "name": "Thief River Falls",
              "fullName": "Thief River Falls, MN. United States",
              "path": [
                "United States",
                "MN",
                "Thief River Falls"
              ],
              "lat": 48.067,
              "lng": -96.183
            },
            {
              "name": "Warroad",
              "fullName": "Warroad, MN. United States",
              "path": [
                "United States",
                "MN",
                "Warroad"
              ],
              "lat": 48.941,
              "lng": -95.348
            }
          ]
        },
        {
          "name": "MO",
          "children": [
            {
              "name": "Clinton",
              "fullName": "Clinton, MO. United States",
              "path": [
                "United States",
                "MO",
                "Clinton"
              ],
              "lat": 38.35,
              "lng": -93.683
            },
            {
              "name": "Farmington",
              "fullName": "Farmington, MO. United States",
              "path": [
                "United States",
                "MO",
                "Farmington"
              ],
              "lat": 37.761,
              "lng": -90.428
            },
            {
              "name": "Jefferson City",
              "fullName": "Jefferson City, MO. United States",
              "path": [
                "United States",
                "MO",
                "Jefferson City"
              ],
              "lat": 38.591,
              "lng": -92.156
            },
            {
              "name": "Kansas City",
              "fullName": "Kansas City, MO. United States",
              "path": [
                "United States",
                "MO",
                "Kansas City"
              ],
              "lat": 39.121,
              "lng": -94.597
            },
            {
              "name": "Kirksville",
              "fullName": "Kirksville, MO. United States",
              "path": [
                "United States",
                "MO",
                "Kirksville"
              ],
              "lat": 40.097,
              "lng": -92.543
            },
            {
              "name": "Poplar Bluff",
              "fullName": "Poplar Bluff, MO. United States",
              "path": [
                "United States",
                "MO",
                "Poplar Bluff"
              ],
              "lat": 36.773,
              "lng": -90.325
            },
            {
              "name": "Springfield",
              "fullName": "Springfield, MO. United States",
              "path": [
                "United States",
                "MO",
                "Springfield"
              ],
              "lat": 37.2347,
              "lng": -93.4014
            },
            {
              "name": "St. Joseph",
              "fullName": "St. Joseph, MO. United States",
              "path": [
                "United States",
                "MO",
                "St. Joseph"
              ],
              "lat": 39.774,
              "lng": -94.923
            },
            {
              "name": "St. Louis",
              "fullName": "St. Louis, MO. United States",
              "path": [
                "United States",
                "MO",
                "St. Louis"
              ],
              "lat": 38.753,
              "lng": -90.374
            }
          ]
        },
        {
          "name": "MS",
          "children": [
            {
              "name": "Columbus",
              "fullName": "Columbus, MS. United States",
              "path": [
                "United States",
                "MS",
                "Columbus"
              ],
              "lat": 33.45,
              "lng": -88.583
            },
            {
              "name": "Gulfport",
              "fullName": "Gulfport, MS. United States",
              "path": [
                "United States",
                "MS",
                "Gulfport"
              ],
              "lat": 30.412,
              "lng": -89.081
            },
            {
              "name": "Hattiesburg",
              "fullName": "Hattiesburg, MS. United States",
              "path": [
                "United States",
                "MS",
                "Hattiesburg"
              ],
              "lat": 31.265,
              "lng": -89.253
            },
            {
              "name": "Jackson",
              "fullName": "Jackson, MS. United States",
              "path": [
                "United States",
                "MS",
                "Jackson"
              ],
              "lat": 32.321,
              "lng": -90.078
            },
            {
              "name": "Oxford",
              "fullName": "Oxford, MS. United States",
              "path": [
                "United States",
                "MS",
                "Oxford"
              ],
              "lat": 34.383,
              "lng": -89.55
            }
          ]
        },
        {
          "name": "MT",
          "children": [
            {
              "name": "Billings",
              "fullName": "Billings, MT. United States",
              "path": [
                "United States",
                "MT",
                "Billings"
              ],
              "lat": 45.807,
              "lng": -108.542
            },
            {
              "name": "Dillon",
              "fullName": "Dillon, MT. United States",
              "path": [
                "United States",
                "MT",
                "Dillon"
              ],
              "lat": 48.174,
              "lng": -103.637
            },
            {
              "name": "Glasgow",
              "fullName": "Glasgow, MT. United States",
              "path": [
                "United States",
                "MT",
                "Glasgow"
              ],
              "lat": 48.2067,
              "lng": -106.6256
            },
            {
              "name": "Great Falls",
              "fullName": "Great Falls, MT. United States",
              "path": [
                "United States",
                "MT",
                "Great Falls"
              ],
              "lat": 47.4614,
              "lng": -111.3847
            },
            {
              "name": "Havre",
              "fullName": "Havre, MT. United States",
              "path": [
                "United States",
                "MT",
                "Havre"
              ],
              "lat": 48.543,
              "lng": -109.763
            },
            {
              "name": "Helena",
              "fullName": "Helena, MT. United States",
              "path": [
                "United States",
                "MT",
                "Helena"
              ],
              "lat": 46.606,
              "lng": -111.964
            },
            {
              "name": "Kalispell",
              "fullName": "Kalispell, MT. United States",
              "path": [
                "United States",
                "MT",
                "Kalispell"
              ],
              "lat": 48.304,
              "lng": -114.264
            },
            {
              "name": "Miles City",
              "fullName": "Miles City, MT. United States",
              "path": [
                "United States",
                "MT",
                "Miles City"
              ],
              "lat": 46.427,
              "lng": -105.883
            },
            {
              "name": "Missoula",
              "fullName": "Missoula, MT. United States",
              "path": [
                "United States",
                "MT",
                "Missoula"
              ],
              "lat": 46.921,
              "lng": -114.093
            },
            {
              "name": "Sidney",
              "fullName": "Sidney, MT. United States",
              "path": [
                "United States",
                "MT",
                "Sidney"
              ],
              "lat": 47.717,
              "lng": -104.183
            }
          ]
        },
        {
          "name": "NC",
          "children": [
            {
              "name": "Asheville",
              "fullName": "Asheville, NC. United States",
              "path": [
                "United States",
                "NC",
                "Asheville"
              ],
              "lat": 35.4945,
              "lng": -82.6142
            },
            {
              "name": "Charlotte",
              "fullName": "Charlotte, NC. United States",
              "path": [
                "United States",
                "NC",
                "Charlotte"
              ],
              "lat": 35.224,
              "lng": -80.955
            },
            {
              "name": "Elizabeth City",
              "fullName": "Elizabeth City, NC. United States",
              "path": [
                "United States",
                "NC",
                "Elizabeth City"
              ],
              "lat": 36.261,
              "lng": -76.175
            },
            {
              "name": "Fayetteville",
              "fullName": "Fayetteville, NC. United States",
              "path": [
                "United States",
                "NC",
                "Fayetteville"
              ],
              "lat": 35.133,
              "lng": -78.933
            },
            {
              "name": "New Bern",
              "fullName": "New Bern, NC. United States",
              "path": [
                "United States",
                "NC",
                "New Bern"
              ],
              "lat": 35.068,
              "lng": -77.048
            },
            {
              "name": "Raleigh",
              "fullName": "Raleigh, NC. United States",
              "path": [
                "United States",
                "NC",
                "Raleigh"
              ],
              "lat": 35.892,
              "lng": -78.782
            },
            {
              "name": "Richmond",
              "fullName": "Richmond, NC. United States",
              "path": [
                "United States",
                "NC",
                "Richmond"
              ],
              "lat": 34.891,
              "lng": -79.759
            },
            {
              "name": "South Rosemary",
              "fullName": "South Rosemary, NC. United States",
              "path": [
                "United States",
                "NC",
                "South Rosemary"
              ],
              "lat": 36.439,
              "lng": -77.71
            },
            {
              "name": "Wilkesboro",
              "fullName": "Wilkesboro, NC. United States",
              "path": [
                "United States",
                "NC",
                "Wilkesboro"
              ],
              "lat": 36.223,
              "lng": -81.098
            },
            {
              "name": "Wilmington",
              "fullName": "Wilmington, NC. United States",
              "path": [
                "United States",
                "NC",
                "Wilmington"
              ],
              "lat": 34.268,
              "lng": -77.9
            },
            {
              "name": "Winston-Salem",
              "fullName": "Winston-Salem, NC. United States",
              "path": [
                "United States",
                "NC",
                "Winston-Salem"
              ],
              "lat": 36.134,
              "lng": -80.222
            }
          ]
        },
        {
          "name": "ND",
          "children": [
            {
              "name": "Bismarck",
              "fullName": "Bismarck, ND. United States",
              "path": [
                "United States",
                "ND",
                "Bismarck"
              ],
              "lat": 46.783,
              "lng": -100.757
            },
            {
              "name": "Devils Lake",
              "fullName": "Devils Lake, ND. United States",
              "path": [
                "United States",
                "ND",
                "Devils Lake"
              ],
              "lat": 48.117,
              "lng": -98.9
            },
            {
              "name": "Grand Forks",
              "fullName": "Grand Forks, ND. United States",
              "path": [
                "United States",
                "ND",
                "Grand Forks"
              ],
              "lat": 47.943,
              "lng": -97.184
            },
            {
              "name": "Jamestown",
              "fullName": "Jamestown, ND. United States",
              "path": [
                "United States",
                "ND",
                "Jamestown"
              ],
              "lat": 46.926,
              "lng": -98.669
            },
            {
              "name": "Minot",
              "fullName": "Minot, ND. United States",
              "path": [
                "United States",
                "ND",
                "Minot"
              ],
              "lat": 48.255,
              "lng": -101.273
            },
            {
              "name": "Williston",
              "fullName": "Williston, ND. United States",
              "path": [
                "United States",
                "ND",
                "Williston"
              ],
              "lat": 48.174,
              "lng": -103.637
            }
          ]
        },
        {
          "name": "NE",
          "children": [
            {
              "name": "Chadron",
              "fullName": "Chadron, NE. United States",
              "path": [
                "United States",
                "NE",
                "Chadron"
              ],
              "lat": 42.837,
              "lng": -103.098
            },
            {
              "name": "Gering",
              "fullName": "Gering, NE. United States",
              "path": [
                "United States",
                "NE",
                "Gering"
              ],
              "lat": 41.871,
              "lng": -103.593
            },
            {
              "name": "Grand Island",
              "fullName": "Grand Island, NE. United States",
              "path": [
                "United States",
                "NE",
                "Grand Island"
              ],
              "lat": 40.961,
              "lng": -98.314
            },
            {
              "name": "Lincoln",
              "fullName": "Lincoln, NE. United States",
              "path": [
                "United States",
                "NE",
                "Lincoln"
              ],
              "lat": 40.851,
              "lng": -96.748
            },
            {
              "name": "Norfolk",
              "fullName": "Norfolk, NE. United States",
              "path": [
                "United States",
                "NE",
                "Norfolk"
              ],
              "lat": 41.986,
              "lng": -97.435
            },
            {
              "name": "North Platte",
              "fullName": "North Platte, NE. United States",
              "path": [
                "United States",
                "NE",
                "North Platte"
              ],
              "lat": 41.1328,
              "lng": -100.7
            },
            {
              "name": "Omaha",
              "fullName": "Omaha, NE. United States",
              "path": [
                "United States",
                "NE",
                "Omaha"
              ],
              "lat": 41.196,
              "lng": -96.112
            },
            {
              "name": "Valentine",
              "fullName": "Valentine, NE. United States",
              "path": [
                "United States",
                "NE",
                "Valentine"
              ],
              "lat": 42.857,
              "lng": -100.548
            }
          ]
        },
        {
          "name": "NH",
          "children": [
            {
              "name": "Berlin",
              "fullName": "Berlin, NH. United States",
              "path": [
                "United States",
                "NH",
                "Berlin"
              ],
              "lat": 44.576,
              "lng": -71.179
            },
            {
              "name": "Concord",
              "fullName": "Concord, NH. United States",
              "path": [
                "United States",
                "NH",
                "Concord"
              ],
              "lat": 43.205,
              "lng": -71.503
            },
            {
              "name": "Lebanon",
              "fullName": "Lebanon, NH. United States",
              "path": [
                "United States",
                "NH",
                "Lebanon"
              ],
              "lat": 43.626,
              "lng": -72.305
            },
            {
              "name": "Portsmouth",
              "fullName": "Portsmouth, NH. United States",
              "path": [
                "United States",
                "NH",
                "Portsmouth"
              ],
              "lat": 43.083,
              "lng": -70.817
            }
          ]
        },
        {
          "name": "NJ",
          "children": [
            {
              "name": "Atlantic City",
              "fullName": "Atlantic City, NJ. United States",
              "path": [
                "United States",
                "NJ",
                "Atlantic City"
              ],
              "lat": 39.452,
              "lng": -74.567
            },
            {
              "name": "Newark",
              "fullName": "Newark, NJ. United States",
              "path": [
                "United States",
                "NJ",
                "Newark"
              ],
              "lat": 40.683,
              "lng": -74.169
            },
            {
              "name": "Trenton",
              "fullName": "Trenton, NJ. United States",
              "path": [
                "United States",
                "NJ",
                "Trenton"
              ],
              "lat": 40.277,
              "lng": -74.816
            }
          ]
        },
        {
          "name": "NM",
          "children": [
            {
              "name": "Albuquerque",
              "fullName": "Albuquerque, NM. United States",
              "path": [
                "United States",
                "NM",
                "Albuquerque"
              ],
              "lat": 35.038,
              "lng": -106.622
            },
            {
              "name": "Farmington",
              "fullName": "Farmington, NM. United States",
              "path": [
                "United States",
                "NM",
                "Farmington"
              ],
              "lat": 36.744,
              "lng": -108.229
            },
            {
              "name": "Las Cruces",
              "fullName": "Las Cruces, NM. United States",
              "path": [
                "United States",
                "NM",
                "Las Cruces"
              ],
              "lat": 32.283,
              "lng": -106.917
            },
            {
              "name": "Roswell",
              "fullName": "Roswell, NM. United States",
              "path": [
                "United States",
                "NM",
                "Roswell"
              ],
              "lat": 33.308,
              "lng": -104.508
            },
            {
              "name": "Taos",
              "fullName": "Taos, NM. United States",
              "path": [
                "United States",
                "NM",
                "Taos"
              ],
              "lat": 36.45,
              "lng": -105.667
            }
          ]
        },
        {
          "name": "NV",
          "children": [
            {
              "name": "Caliente",
              "fullName": "Caliente, NV. United States",
              "path": [
                "United States",
                "NV",
                "Caliente"
              ],
              "lat": 37.612,
              "lng": -114.526
            },
            {
              "name": "Carson City",
              "fullName": "Carson City, NV. United States",
              "path": [
                "United States",
                "NV",
                "Carson City"
              ],
              "lat": 39.192,
              "lng": -119.734
            },
            {
              "name": "Elko",
              "fullName": "Elko, NV. United States",
              "path": [
                "United States",
                "NV",
                "Elko"
              ],
              "lat": 40.829,
              "lng": -115.789
            },
            {
              "name": "Ely",
              "fullName": "Ely, NV. United States",
              "path": [
                "United States",
                "NV",
                "Ely"
              ],
              "lat": 39.295,
              "lng": -114.847
            },
            {
              "name": "Las Vegas",
              "fullName": "Las Vegas, NV. United States",
              "path": [
                "United States",
                "NV",
                "Las Vegas"
              ],
              "lat": 36.212,
              "lng": -115.196
            },
            {
              "name": "Reno",
              "fullName": "Reno, NV. United States",
              "path": [
                "United States",
                "NV",
                "Reno"
              ],
              "lat": 39.484,
              "lng": -119.771
            },
            {
              "name": "Tonopah",
              "fullName": "Tonopah, NV. United States",
              "path": [
                "United States",
                "NV",
                "Tonopah"
              ],
              "lat": 38.051,
              "lng": -117.09
            },
            {
              "name": "Winnemucca",
              "fullName": "Winnemucca, NV. United States",
              "path": [
                "United States",
                "NV",
                "Winnemucca"
              ],
              "lat": 40.902,
              "lng": -117.808
            }
          ]
        },
        {
          "name": "NY",
          "children": [
            {
              "name": "Albany",
              "fullName": "Albany, NY. United States",
              "path": [
                "United States",
                "NY",
                "Albany"
              ],
              "lat": 42.747,
              "lng": -73.799
            },
            {
              "name": "Dunkirk",
              "fullName": "Dunkirk, NY. United States",
              "path": [
                "United States",
                "NY",
                "Dunkirk"
              ],
              "lat": 42.493,
              "lng": -79.272
            },
            {
              "name": "Ithaca",
              "fullName": "Ithaca, NY. United States",
              "path": [
                "United States",
                "NY",
                "Ithaca"
              ],
              "lat": 42.483,
              "lng": -76.467
            },
            {
              "name": "Montgomery",
              "fullName": "Montgomery, NY. United States",
              "path": [
                "United States",
                "NY",
                "Montgomery"
              ],
              "lat": 41.509,
              "lng": -74.265
            },
            {
              "name": "New York",
              "fullName": "New York, NY. United States",
              "path": [
                "United States",
                "NY",
                "New York"
              ],
              "lat": 40.779,
              "lng": -73.969
            },
            {
              "name": "Plattsburgh",
              "fullName": "Plattsburgh, NY. United States",
              "path": [
                "United States",
                "NY",
                "Plattsburgh"
              ],
              "lat": 44.65,
              "lng": -73.467
            },
            {
              "name": "Rochester",
              "fullName": "Rochester, NY. United States",
              "path": [
                "United States",
                "NY",
                "Rochester"
              ],
              "lat": 43.117,
              "lng": -77.677
            },
            {
              "name": "Syracuse",
              "fullName": "Syracuse, NY. United States",
              "path": [
                "United States",
                "NY",
                "Syracuse"
              ],
              "lat": 43.111,
              "lng": -76.104
            },
            {
              "name": "Watertown",
              "fullName": "Watertown, NY. United States",
              "path": [
                "United States",
                "NY",
                "Watertown"
              ],
              "lat": 43.989,
              "lng": -76.026
            },
            {
              "name": "Westhampton",
              "fullName": "Westhampton, NY. United States",
              "path": [
                "United States",
                "NY",
                "Westhampton"
              ],
              "lat": 40.844,
              "lng": -72.632
            }
          ]
        },
        {
          "name": "OH",
          "children": [
            {
              "name": "Akron",
              "fullName": "Akron, OH. United States",
              "path": [
                "United States",
                "OH",
                "Akron"
              ],
              "lat": 40.918,
              "lng": -81.444
            },
            {
              "name": "Albany",
              "fullName": "Albany, OH. United States",
              "path": [
                "United States",
                "OH",
                "Albany"
              ],
              "lat": 39.211,
              "lng": -82.231
            },
            {
              "name": "Cincinnati",
              "fullName": "Cincinnati, OH. United States",
              "path": [
                "United States",
                "OH",
                "Cincinnati"
              ],
              "lat": 39.103,
              "lng": -84.419
            },
            {
              "name": "Cleveland",
              "fullName": "Cleveland, OH. United States",
              "path": [
                "United States",
                "OH",
                "Cleveland"
              ],
              "lat": 41.406,
              "lng": -81.852
            },
            {
              "name": "Columbus",
              "fullName": "Columbus, OH. United States",
              "path": [
                "United States",
                "OH",
                "Columbus"
              ],
              "lat": 39.991,
              "lng": -82.877
            },
            {
              "name": "Lima",
              "fullName": "Lima, OH. United States",
              "path": [
                "United States",
                "OH",
                "Lima"
              ],
              "lat": 40.708,
              "lng": -84.027
            },
            {
              "name": "Toledo",
              "fullName": "Toledo, OH. United States",
              "path": [
                "United States",
                "OH",
                "Toledo"
              ],
              "lat": 41.587,
              "lng": -83.806
            }
          ]
        },
        {
          "name": "OK",
          "children": [
            {
              "name": "Durant",
              "fullName": "Durant, OK. United States",
              "path": [
                "United States",
                "OK",
                "Durant"
              ],
              "lat": 33.942,
              "lng": -96.394
            },
            {
              "name": "Oklahoma City",
              "fullName": "Oklahoma City, OK. United States",
              "path": [
                "United States",
                "OK",
                "Oklahoma City"
              ],
              "lat": 35.389,
              "lng": -97.601
            },
            {
              "name": "Tulsa",
              "fullName": "Tulsa, OK. United States",
              "path": [
                "United States",
                "OK",
                "Tulsa"
              ],
              "lat": 36.199,
              "lng": -95.887
            },
            {
              "name": "Woodward",
              "fullName": "Woodward, OK. United States",
              "path": [
                "United States",
                "OK",
                "Woodward"
              ],
              "lat": 36.437,
              "lng": -99.521
            }
          ]
        },
        {
          "name": "OR",
          "children": [
            {
              "name": "Astoria",
              "fullName": "Astoria, OR. United States",
              "path": [
                "United States",
                "OR",
                "Astoria"
              ],
              "lat": 46.157,
              "lng": -123.883
            },
            {
              "name": "Bend",
              "fullName": "Bend, OR. United States",
              "path": [
                "United States",
                "OR",
                "Bend"
              ],
              "lat": 44.095,
              "lng": -121.2
            },
            {
              "name": "Brookings",
              "fullName": "Brookings, OR. United States",
              "path": [
                "United States",
                "OR",
                "Brookings"
              ],
              "lat": 42.074,
              "lng": -124.29
            },
            {
              "name": "Burns",
              "fullName": "Burns, OR. United States",
              "path": [
                "United States",
                "OR",
                "Burns"
              ],
              "lat": 43.595,
              "lng": -118.956
            },
            {
              "name": "Eugene",
              "fullName": "Eugene, OR. United States",
              "path": [
                "United States",
                "OR",
                "Eugene"
              ],
              "lat": 44.128,
              "lng": -123.221
            },
            {
              "name": "Hermiston",
              "fullName": "Hermiston, OR. United States",
              "path": [
                "United States",
                "OR",
                "Hermiston"
              ],
              "lat": 45.826,
              "lng": -119.261
            },
            {
              "name": "Klamath Falls",
              "fullName": "Klamath Falls, OR. United States",
              "path": [
                "United States",
                "OR",
                "Klamath Falls"
              ],
              "lat": 42.147,
              "lng": -121.724
            },
            {
              "name": "La Grande",
              "fullName": "La Grande, OR. United States",
              "path": [
                "United States",
                "OR",
                "La Grande"
              ],
              "lat": 45.283,
              "lng": -118.0
            },
            {
              "name": "Medford",
              "fullName": "Medford, OR. United States",
              "path": [
                "United States",
                "OR",
                "Medford"
              ],
              "lat": 42.3769,
              "lng": -122.8822
            },
            {
              "name": "North Bend",
              "fullName": "North Bend, OR. United States",
              "path": [
                "United States",
                "OR",
                "North Bend"
              ],
              "lat": 43.413,
              "lng": -124.244
            },
            {
              "name": "Ontario",
              "fullName": "Ontario, OR. United States",
              "path": [
                "United States",
                "OR",
                "Ontario"
              ],
              "lat": 44.021,
              "lng": -117.013
            },
            {
              "name": "Portland",
              "fullName": "Portland, OR. United States",
              "path": [
                "United States",
                "OR",
                "Portland"
              ],
              "lat": 45.596,
              "lng": -122.609
            },
            {
              "name": "Salem",
              "fullName": "Salem, OR. United States",
              "path": [
                "United States",
                "OR",
                "Salem"
              ],
              "lat": 44.905,
              "lng": -123.001
            }
          ]
        },
        {
          "name": "PA",
          "children": [
            {
              "name": "Allentown",
              "fullName": "Allentown, PA. United States",
              "path": [
                "United States",
                "PA",
                "Allentown"
              ],
              "lat": 40.65,
              "lng": -75.448
            },
            {
              "name": "Clearfield",
              "fullName": "Clearfield, PA. United States",
              "path": [
                "United States",
                "PA",
                "Clearfield"
              ],
              "lat": 41.047,
              "lng": -78.412
            },
            {
              "name": "Erie",
              "fullName": "Erie, PA. United States",
              "path": [
                "United States",
                "PA",
                "Erie"
              ],
              "lat": 42.08,
              "lng": -80.182
            },
            {
              "name": "Harrisburg",
              "fullName": "Harrisburg, PA. United States",
              "path": [
                "United States",
                "PA",
                "Harrisburg"
              ],
              "lat": 40.196,
              "lng": -76.772
            },
            {
              "name": "Norristown",
              "fullName": "Norristown, PA. United States",
              "path": [
                "United States",
                "PA",
                "Norristown"
              ],
              "lat": 40.1,
              "lng": -75.267
            },
            {
              "name": "Philadelphia",
              "fullName": "Philadelphia, PA. United States",
              "path": [
                "United States",
                "PA",
                "Philadelphia"
              ],
              "lat": 39.873,
              "lng": -75.227
            },
            {
              "name": "Pittsburgh",
              "fullName": "Pittsburgh, PA. United States",
              "path": [
                "United States",
                "PA",
                "Pittsburgh"
              ],
              "lat": 40.355,
              "lng": -79.922
            },
            {
              "name": "Scranton",
              "fullName": "Scranton, PA. United States",
              "path": [
                "United States",
                "PA",
                "Scranton"
              ],
              "lat": 41.334,
              "lng": -75.727
            }
          ]
        },
        {
          "name": "RI",
          "children": [
            {
              "name": "Providence",
              "fullName": "Providence, RI. United States",
              "path": [
                "United States",
                "RI",
                "Providence"
              ],
              "lat": 41.723,
              "lng": -71.433
            },
            {
              "name": "Westerly",
              "fullName": "Westerly, RI. United States",
              "path": [
                "United States",
                "RI",
                "Westerly"
              ],
              "lat": 41.35,
              "lng": -71.799
            }
          ]
        },
        {
          "name": "SC",
          "children": [
            {
              "name": "Beaufort",
              "fullName": "Beaufort, SC. United States",
              "path": [
                "United States",
                "SC",
                "Beaufort"
              ],
              "lat": 32.412,
              "lng": -80.634
            },
            {
              "name": "Bennettsville",
              "fullName": "Bennettsville, SC. United States",
              "path": [
                "United States",
                "SC",
                "Bennettsville"
              ],
              "lat": 34.617,
              "lng": -79.733
            },
            {
              "name": "Charleston",
              "fullName": "Charleston, SC. United States",
              "path": [
                "United States",
                "SC",
                "Charleston"
              ],
              "lat": 32.895,
              "lng": -80.0275
            },
            {
              "name": "Columbia",
              "fullName": "Columbia, SC. United States",
              "path": [
                "United States",
                "SC",
                "Columbia"
              ],
              "lat": 33.971,
              "lng": -80.996
            },
            {
              "name": "Greenville",
              "fullName": "Greenville, SC. United States",
              "path": [
                "United States",
                "SC",
                "Greenville"
              ],
              "lat": 34.846,
              "lng": -82.346
            },
            {
              "name": "Myrtle Beach",
              "fullName": "Myrtle Beach, SC. United States",
              "path": [
                "United States",
                "SC",
                "Myrtle Beach"
              ],
              "lat": 33.683,
              "lng": -78.933
            },
            {
              "name": "Rock Hill",
              "fullName": "Rock Hill, SC. United States",
              "path": [
                "United States",
                "SC",
                "Rock Hill"
              ],
              "lat": 34.987,
              "lng": -81.058
            }
          ]
        },
        {
          "name": "SD",
          "children": [
            {
              "name": "Aberdeen",
              "fullName": "Aberdeen, SD. United States",
              "path": [
                "United States",
                "SD",
                "Aberdeen"
              ],
              "lat": 45.443,
              "lng": -98.413
            },
            {
              "name": "Buffalo",
              "fullName": "Buffalo, SD. United States",
              "path": [
                "United States",
                "SD",
                "Buffalo"
              ],
              "lat": 45.604,
              "lng": -103.546
            },
            {
              "name": "Mitchell",
              "fullName": "Mitchell, SD. United States",
              "path": [
                "United States",
                "SD",
                "Mitchell"
              ],
              "lat": 43.774,
              "lng": -98.038
            },
            {
              "name": "Pierre",
              "fullName": "Pierre, SD. United States",
              "path": [
                "United States",
                "SD",
                "Pierre"
              ],
              "lat": 44.381,
              "lng": -100.286
            },
            {
              "name": "Rapid City",
              "fullName": "Rapid City, SD. United States",
              "path": [
                "United States",
                "SD",
                "Rapid City"
              ],
              "lat": 44.046,
              "lng": -103.054
            },
            {
              "name": "Sioux Falls",
              "fullName": "Sioux Falls, SD. United States",
              "path": [
                "United States",
                "SD",
                "Sioux Falls"
              ],
              "lat": 43.578,
              "lng": -96.754
            },
            {
              "name": "Watertown",
              "fullName": "Watertown, SD. United States",
              "path": [
                "United States",
                "SD",
                "Watertown"
              ],
              "lat": 44.905,
              "lng": -97.149
            }
          ]
        },
        {
          "name": "TN",
          "children": [
            {
              "name": "Chattanooga",
              "fullName": "Chattanooga, TN. United States",
              "path": [
                "United States",
                "TN",
                "Chattanooga"
              ],
              "lat": 35.034,
              "lng": -85.2
            },
            {
              "name": "Johnson City",
              "fullName": "Johnson City, TN. United States",
              "path": [
                "United States",
                "TN",
                "Johnson City"
              ],
              "lat": 36.48,
              "lng": -82.399
            },
            {
              "name": "Knoxville",
              "fullName": "Knoxville, TN. United States",
              "path": [
                "United States",
                "TN",
                "Knoxville"
              ],
              "lat": 35.818,
              "lng": -83.986
            },
            {
              "name": "Memphis",
              "fullName": "Memphis, TN. United States",
              "path": [
                "United States",
                "TN",
                "Memphis"
              ],
              "lat": 35.056,
              "lng": -89.987
            },
            {
              "name": "Nashville",
              "fullName": "Nashville, TN. United States",
              "path": [
                "United States",
                "TN",
                "Nashville"
              ],
              "lat": 36.119,
              "lng": -86.689
            }
          ]
        },
        {
          "name": "TX",
          "children": [
            {
              "name": "Amarillo",
              "fullName": "Amarillo, TX. United States",
              "path": [
                "United States",
                "TX",
                "Amarillo"
              ],
              "lat": 35.2331,
              "lng": -101.7092
            },
            {
              "name": "Austin",
              "fullName": "Austin, TX. United States",
              "path": [
                "United States",
                "TX",
                "Austin"
              ],
              "lat": 30.183,
              "lng": -97.68
            },
            {
              "name": "Corpus Christi",
              "fullName": "Corpus Christi, TX. United States",
              "path": [
                "United States",
                "TX",
                "Corpus Christi"
              ],
              "lat": 27.774,
              "lng": -97.512
            },
            {
              "name": "Dallas",
              "fullName": "Dallas, TX. United States",
              "path": [
                "United States",
                "TX",
                "Dallas"
              ],
              "lat": 32.898,
              "lng": -97.019
            },
            {
              "name": "Del Rio",
              "fullName": "Del Rio, TX. United States",
              "path": [
                "United States",
                "TX",
                "Del Rio"
              ],
              "lat": 29.378,
              "lng": -100.927
            },
            {
              "name": "El Paso",
              "fullName": "El Paso, TX. United States",
              "path": [
                "United States",
                "TX",
                "El Paso"
              ],
              "lat": 31.811,
              "lng": -106.376
            },
            {
              "name": "Houston",
              "fullName": "Houston, TX. United States",
              "path": [
                "United States",
                "TX",
                "Houston"
              ],
              "lat": 29.717,
              "lng": -95.383
            },
            {
              "name": "Laredo",
              "fullName": "Laredo, TX. United States",
              "path": [
                "United States",
                "TX",
                "Laredo"
              ],
              "lat": 27.533,
              "lng": -99.467
            },
            {
              "name": "Nacogdoches",
              "fullName": "Nacogdoches, TX. United States",
              "path": [
                "United States",
                "TX",
                "Nacogdoches"
              ],
              "lat": 31.578,
              "lng": -94.709
            },
            {
              "name": "Odessa",
              "fullName": "Odessa, TX. United States",
              "path": [
                "United States",
                "TX",
                "Odessa"
              ],
              "lat": 31.921,
              "lng": -102.387
            },
            {
              "name": "Port Arthur",
              "fullName": "Port Arthur, TX. United States",
              "path": [
                "United States",
                "TX",
                "Port Arthur"
              ],
              "lat": 29.951,
              "lng": -94.021
            },
            {
              "name": "San Angelo",
              "fullName": "San Angelo, TX. United States",
              "path": [
                "United States",
                "TX",
                "San Angelo"
              ],
              "lat": 31.352,
              "lng": -100.495
            },
            {
              "name": "San Antonio",
              "fullName": "San Antonio, TX. United States",
              "path": [
                "United States",
                "TX",
                "San Antonio"
              ],
              "lat": 29.544,
              "lng": -98.484
            },
            {
              "name": "San Juan",
              "fullName": "San Juan, TX. United States",
              "path": [
                "United States",
                "TX",
                "San Juan"
              ],
              "lat": 26.176,
              "lng": -98.24
            },
            {
              "name": "Seguin",
              "fullName": "Seguin, TX. United States",
              "path": [
                "United States",
                "TX",
                "Seguin"
              ],
              "lat": 29.709,
              "lng": -98.046
            },
            {
              "name": "Tyler",
              "fullName": "Tyler, TX. United States",
              "path": [
                "United States",
                "TX",
                "Tyler"
              ],
              "lat": 32.354,
              "lng": -95.403
            },
            {
              "name": "Waco",
              "fullName": "Waco, TX. United States",
              "path": [
                "United States",
                "TX",
                "Waco"
              ],
              "lat": 31.618,
              "lng": -97.228
            },
            {
              "name": "Wichita Falls",
              "fullName": "Wichita Falls, TX. United States",
              "path": [
                "United States",
                "TX",
                "Wichita Falls"
              ],
              "lat": 33.858,
              "lng": -98.49
            }
          ]
        },
        {
          "name": "UT",
          "children": [
            {
              "name": "Blanding",
              "fullName": "Blanding, UT. United States",
              "path": [
                "United States",
                "UT",
                "Blanding"
              ],
              "lat": 37.583,
              "lng": -109.483
            },
            {
              "name": "Cedar City",
              "fullName": "Cedar City, UT. United States",
              "path": [
                "United States",
                "UT",
                "Cedar City"
              ],
              "lat": 37.709,
              "lng": -113.094
            },
            {
              "name": "Hanksville",
              "fullName": "Hanksville, UT. United States",
              "path": [
                "United States",
                "UT",
                "Hanksville"
              ],
              "lat": 38.417,
              "lng": -110.7
            },
            {
              "name": "Price",
              "fullName": "Price, UT. United States",
              "path": [
                "United States",
                "UT",
                "Price"
              ],
              "lat": 39.609,
              "lng": -110.755
            },
            {
              "name": "Salt Lake City",
              "fullName": "Salt Lake City, UT. United States",
              "path": [
                "United States",
                "UT",
                "Salt Lake City"
              ],
              "lat": 40.778,
              "lng": -111.969
            },
            {
              "name": "St. George",
              "fullName": "St. George, UT. United States",
              "path": [
                "United States",
                "UT",
                "St. George"
              ],
              "lat": 37.091,
              "lng": -113.593
            },
            {
              "name": "Vernal",
              "fullName": "Vernal, UT. United States",
              "path": [
                "United States",
                "UT",
                "Vernal"
              ],
              "lat": 40.443,
              "lng": -109.513
            },
            {
              "name": "Wendover",
              "fullName": "Wendover, UT. United States",
              "path": [
                "United States",
                "UT",
                "Wendover"
              ],
              "lat": 40.721,
              "lng": -114.036
            }
          ]
        },
        {
          "name": "VA",
          "children": [
            {
              "name": "Charlottesville",
              "fullName": "Charlottesville, VA. United States",
              "path": [
                "United States",
                "VA",
                "Charlottesville"
              ],
              "lat": 37.9975,
              "lng": -78.4656
            },
            {
              "name": "Emporia",
              "fullName": "Emporia, VA. United States",
              "path": [
                "United States",
                "VA",
                "Emporia"
              ],
              "lat": 36.687,
              "lng": -77.483
            },
            {
              "name": "Hillsville",
              "fullName": "Hillsville, VA. United States",
              "path": [
                "United States",
                "VA",
                "Hillsville"
              ],
              "lat": 36.766,
              "lng": -80.823
            },
            {
              "name": "Manassas",
              "fullName": "Manassas, VA. United States",
              "path": [
                "United States",
                "VA",
                "Manassas"
              ],
              "lat": 38.721,
              "lng": -77.515
            },
            {
              "name": "Richmond",
              "fullName": "Richmond, VA. United States",
              "path": [
                "United States",
                "VA",
                "Richmond"
              ],
              "lat": 37.512,
              "lng": -77.323
            },
            {
              "name": "Roanoke",
              "fullName": "Roanoke, VA. United States",
              "path": [
                "United States",
                "VA",
                "Roanoke"
              ],
              "lat": 37.317,
              "lng": -79.974
            },
            {
              "name": "Virginia Beach",
              "fullName": "Virginia Beach, VA. United States",
              "path": [
                "United States",
                "VA",
                "Virginia Beach"
              ],
              "lat": 36.817,
              "lng": -76.033
            },
            {
              "name": "Winchester",
              "fullName": "Winchester, VA. United States",
              "path": [
                "United States",
                "VA",
                "Winchester"
              ],
              "lat": 39.143,
              "lng": -78.144
            }
          ]
        },
        {
          "name": "VT",
          "children": [
            {
              "name": "Bennington",
              "fullName": "Bennington, VT. United States",
              "path": [
                "United States",
                "VT",
                "Bennington"
              ],
              "lat": 42.891,
              "lng": -73.247
            },
            {
              "name": "Montpelier",
              "fullName": "Montpelier, VT. United States",
              "path": [
                "United States",
                "VT",
                "Montpelier"
              ],
              "lat": 44.204,
              "lng": -72.562
            },
            {
              "name": "Newport",
              "fullName": "Newport, VT. United States",
              "path": [
                "United States",
                "VT",
                "Newport"
              ],
              "lat": 44.883,
              "lng": -72.233
            }
          ]
        },
        {
          "name": "WA",
          "children": [
            {
              "name": "Aberdeen",
              "fullName": "Aberdeen, WA. United States",
              "path": [
                "United States",
                "WA",
                "Aberdeen"
              ],
              "lat": 46.973,
              "lng": -123.93
            },
            {
              "name": "Bellingham",
              "fullName": "Bellingham, WA. United States",
              "path": [
                "United States",
                "WA",
                "Bellingham"
              ],
              "lat": 48.794,
              "lng": -122.537
            },
            {
              "name": "Dallesport",
              "fullName": "Dallesport, WA. United States",
              "path": [
                "United States",
                "WA",
                "Dallesport"
              ],
              "lat": 45.619,
              "lng": -121.166
            },
            {
              "name": "Kennewick",
              "fullName": "Kennewick, WA. United States",
              "path": [
                "United States",
                "WA",
                "Kennewick"
              ],
              "lat": 46.267,
              "lng": -119.117
            },
            {
              "name": "La Push",
              "fullName": "La Push, WA. United States",
              "path": [
                "United States",
                "WA",
                "La Push"
              ],
              "lat": 47.938,
              "lng": -124.555
            },
            {
              "name": "Longview",
              "fullName": "Longview, WA. United States",
              "path": [
                "United States",
                "WA",
                "Longview"
              ],
              "lat": 46.117,
              "lng": -122.894
            },
            {
              "name": "Olympia",
              "fullName": "Olympia, WA. United States",
              "path": [
                "United States",
                "WA",
                "Olympia"
              ],
              "lat": 46.973,
              "lng": -122.903
            },
            {
              "name": "Omak",
              "fullName": "Omak, WA. United States",
              "path": [
                "United States",
                "WA",
                "Omak"
              ],
              "lat": 48.464,
              "lng": -119.517
            },
            {
              "name": "Seattle",
              "fullName": "Seattle, WA. United States",
              "path": [
                "United States",
                "WA",
                "Seattle"
              ],
              "lat": 47.53,
              "lng": -122.301
            },
            {
              "name": "Spokane",
              "fullName": "Spokane, WA. United States",
              "path": [
                "United States",
                "WA",
                "Spokane"
              ],
              "lat": 47.683,
              "lng": -117.321
            },
            {
              "name": "Vancouver",
              "fullName": "Vancouver, WA. United States",
              "path": [
                "United States",
                "WA",
                "Vancouver"
              ],
              "lat": 45.621,
              "lng": -122.657
            },
            {
              "name": "Wenatchee",
              "fullName": "Wenatchee, WA. United States",
              "path": [
                "United States",
                "WA",
                "Wenatchee"
              ],
              "lat": 47.398,
              "lng": -120.201
            }
          ]
        },
        {
          "name": "WI",
          "children": [
            {
              "name": "Appleton",
              "fullName": "Appleton, WI. United States",
              "path": [
                "United States",
                "WI",
                "Appleton"
              ],
              "lat": 44.267,
              "lng": -88.517
            },
            {
              "name": "Eagle River",
              "fullName": "Eagle River, WI. United States",
              "path": [
                "United States",
                "WI",
                "Eagle River"
              ],
              "lat": 45.932,
              "lng": -89.269
            },
            {
              "name": "Eau Claire",
              "fullName": "Eau Claire, WI. United States",
              "path": [
                "United States",
                "WI",
                "Eau Claire"
              ],
              "lat": 44.867,
              "lng": -91.488
            },
            {
              "name": "Green Bay",
              "fullName": "Green Bay, WI. United States",
              "path": [
                "United States",
                "WI",
                "Green Bay"
              ],
              "lat": 44.479,
              "lng": -88.137
            },
            {
              "name": "La Crosse",
              "fullName": "La Crosse, WI. United States",
              "path": [
                "United States",
                "WI",
                "La Crosse"
              ],
              "lat": 43.879,
              "lng": -91.253
            },
            {
              "name": "Madison",
              "fullName": "Madison, WI. United States",
              "path": [
                "United States",
                "WI",
                "Madison"
              ],
              "lat": 43.141,
              "lng": -89.345
            },
            {
              "name": "Manitowoc",
              "fullName": "Manitowoc, WI. United States",
              "path": [
                "United States",
                "WI",
                "Manitowoc"
              ],
              "lat": 44.133,
              "lng": -87.667
            },
            {
              "name": "Merrill",
              "fullName": "Merrill, WI. United States",
              "path": [
                "United States",
                "WI",
                "Merrill"
              ],
              "lat": 45.199,
              "lng": -89.711
            },
            {
              "name": "Milwaukee",
              "fullName": "Milwaukee, WI. United States",
              "path": [
                "United States",
                "WI",
                "Milwaukee"
              ],
              "lat": 42.955,
              "lng": -87.904
            },
            {
              "name": "Platteville",
              "fullName": "Platteville, WI. United States",
              "path": [
                "United States",
                "WI",
                "Platteville"
              ],
              "lat": 42.689,
              "lng": -90.444
            },
            {
              "name": "Rhinelander",
              "fullName": "Rhinelander, WI. United States",
              "path": [
                "United States",
                "WI",
                "Rhinelander"
              ],
              "lat": 45.631,
              "lng": -89.482
            },
            {
              "name": "Rice Lake",
              "fullName": "Rice Lake, WI. United States",
              "path": [
                "United States",
                "WI",
                "Rice Lake"
              ],
              "lat": 45.419,
              "lng": -91.773
            },
            {
              "name": "Sheboygan",
              "fullName": "Sheboygan, WI. United States",
              "path": [
                "United States",
                "WI",
                "Sheboygan"
              ],
              "lat": 43.7495,
              "lng": -87.6927
            },
            {
              "name": "Superior",
              "fullName": "Superior, WI. United States",
              "path": [
                "United States",
                "WI",
                "Superior"
              ],
              "lat": 46.689,
              "lng": -92.094
            },
            {
              "name": "Wisconsin Rapids",
              "fullName": "Wisconsin Rapids, WI. United States",
              "path": [
                "United States",
                "WI",
                "Wisconsin Rapids"
              ],
              "lat": 44.359,
              "lng": -89.837
            }
          ]
        },
        {
          "name": "WV",
          "children": [
            {
              "name": "Bluefield",
              "fullName": "Bluefield, WV. United States",
              "path": [
                "United States",
                "WV",
                "Bluefield"
              ],
              "lat": 37.298,
              "lng": -81.204
            },
            {
              "name": "Charleston",
              "fullName": "Charleston, WV. United States",
              "path": [
                "United States",
                "WV",
                "Charleston"
              ],
              "lat": 38.379,
              "lng": -81.59
            },
            {
              "name": "Martinsburg",
              "fullName": "Martinsburg, WV. United States",
              "path": [
                "United States",
                "WV",
                "Martinsburg"
              ],
              "lat": 39.402,
              "lng": -77.984
            },
            {
              "name": "Morgantown",
              "fullName": "Morgantown, WV. United States",
              "path": [
                "United States",
                "WV",
                "Morgantown"
              ],
              "lat": 39.643,
              "lng": -79.916
            },
            {
              "name": "Parkersburg",
              "fullName": "Parkersburg, WV. United States",
              "path": [
                "United States",
                "WV",
                "Parkersburg"
              ],
              "lat": 39.345,
              "lng": -81.439
            }
          ]
        },
        {
          "name": "WY",
          "children": [
            {
              "name": "Casper",
              "fullName": "Casper, WY. United States",
              "path": [
                "United States",
                "WY",
                "Casper"
              ],
              "lat": 42.898,
              "lng": -106.474
            },
            {
              "name": "Cheyenne",
              "fullName": "Cheyenne, WY. United States",
              "path": [
                "United States",
                "WY",
                "Cheyenne"
              ],
              "lat": 41.158,
              "lng": -104.807
            },
            {
              "name": "Gilette",
              "fullName": "Gilette, WY. United States",
              "path": [
                "United States",
                "WY",
                "Gilette"
              ],
              "lat": 44.339,
              "lng": -105.542
            },
            {
              "name": "Riverton",
              "fullName": "Riverton, WY. United States",
              "path": [
                "United States",
                "WY",
                "Riverton"
              ],
              "lat": 43.0647,
              "lng": -108.4767
            },
            {
              "name": "Rock Springs",
              "fullName": "Rock Springs, WY. United States",
              "path": [
                "United States",
                "WY",
                "Rock Springs"
              ],
              "lat": 41.595,
              "lng": -109.053
            },
            {
              "name": "Sheridan",
              "fullName": "Sheridan, WY. United States",
              "path": [
                "United States",
                "WY",
                "Sheridan"
              ],
              "lat": 44.769,
              "lng": -106.969
            },
            {
              "name": "Yellowstone Lake",
              "fullName": "Yellowstone Lake, WY. United States",
              "path": [
                "United States",
                "WY",
                "Yellowstone Lake"
              ],
              "lat": 44.544,
              "lng": -110.421
            }
          ]
        }
      ]
    },
    {
      "name": "Uzbekistan",
      "children": [
        {
          "name": "Bukhara",
          "fullName": "Bukhara",
          "path": [
            "Uzbekistan",
            "Bukhara"
          ],
          "lat": 39.775,
          "lng": 64.483
        },
        {
          "name": "Karshi",
          "fullName": "Karshi",
          "path": [
            "Uzbekistan",
            "Karshi"
          ],
          "lat": 38.802,
          "lng": 65.773
        },
        {
          "name": "Navoi",
          "fullName": "Navoi",
          "path": [
            "Uzbekistan",
            "Navoi"
          ],
          "lat": 40.133,
          "lng": 65.35
        },
        {
          "name": "Nukus",
          "fullName": "Nukus",
          "path": [
            "Uzbekistan",
            "Nukus"
          ],
          "lat": 42.483,
          "lng": 59.617
        },
        {
          "name": "Samarkand",
          "fullName": "Samarkand",
          "path": [
            "Uzbekistan",
            "Samarkand"
          ],
          "lat": 39.701,
          "lng": 66.984
        },
        {
          "name": "Termez",
          "fullName": "Termez",
          "path": [
            "Uzbekistan",
            "Termez"
          ],
          "lat": 37.287,
          "lng": 67.31
        },
        {
          "name": "Urgench",
          "fullName": "Urgench",
          "path": [
            "Uzbekistan",
            "Urgench"
          ],
          "lat": 41.584,
          "lng": 60.642
        }
      ]
    }
  ]
}
